import gpl from 'graphql-tag';

export default {
  query:{
    allUsuarios: gpl `{
      allUsuarios{
        _id
        email
        nombreUsuario
        claveDeAcceso
        perfil{
          _id
          descrPerfil
        }
        descrEmpresa
        versionMacro
        cedula
        ciudad
        cargo
        telefono
        tipo
        estado
        gestionaHallazgos
        archivoFirma
        esLider
        suLider
      }
    }
    `,
    allUsuariosRtes: gpl `
      query ($tipoqry: String){
        allUsuariosRtes(tipoqry: $tipoqry) {
          _id
          email
          nombreUsuario
          claveDeAcceso
          perfil{
            _id
            descrPerfil
          }
          descrEmpresa
          versionMacro
          cedula
          ciudad
          cargo
          telefono
          tipo
          estado
          gestionaHallazgos
          archivoFirma
          esLider
          suLider
        }
      }
    
    `,
    allAutorizac: gpl `{
      allAutorizac{
        _id
        codigoAutorizac
        descrAutorizac
      }
    }
    `,
    allPerfiles: gpl `{
      allPerfiles{
        _id
        descrPerfil
        autorizac{
          codigoAutorizac
          descrAutorizac
        }
      }
    }
    `,
    // allPerfilesRtes: gpl `
    //   query ($tipoqry: String){
    //     allPerfilesRtes(tipoqry: $tipoqry) {
    //       _id
    //       descrPerfil
    //       autorizac{
    //         codigoAutorizac
    //         descrAutorizac
    //       }
    //     }
    //   }
    // `,
    allSequence: gpl `
      query ($_id: ID){
        allSequence(_id: $_id) {
          _id
          coleccion
          seq
        }
      }
    `,
    getParametro: gpl `
      query ($_id: ID){
        getParametro(_id: $_id) {
          _id
          mensaje
          empresaRazonSocial
          empresaNit
          empresaWeb
          empresaDir1
          empresaTel1
          empresaCel1
          empresaCiudad1
          empresaDir2
          empresaTel2
          empresaCel2
          empresaCiudad2
          empresaBanco1
          empresaCuenta1
          empresaBanco2
          empresaCuenta2
          empresaPresentacion
          empresaNombreFirma
          empresaCargoFirma
          empresaMailFirma
          empresaCelFirma
          rutaLogo
          generandoProg
          rango1Desde
          rango1Hasta
          rango2Hasta
          rango3Hasta
          trm
          mailFactura
          medidaQR
          minimoDolar
          maximoDolar
          mailFacturaPanama
          parametroMail1
          parametroMail2
          parametroMail3
          nodemailerUser
          nodemailerPass
          rutaLocal
          rutaRemota
          servidor
          usuario
          clave
        }
      }
      `,
      allRotulo: gpl `
      query{        
        allRotulo{
          _id
          descrRotulo
          descrFrecuencia
          claseLub
          colorAplicacion
          categoriaLub
          colorGrado
          tipoGrado
          isoGrasaColor
          isoGrasaTexto
          colorTexto
          apiSAE
          archRotulo
        }
      }
      `,
      allTurno: gpl `
      query{        
        allTurno{
          _id
          cedula
          nombreUsuario
          email
          fechaHoraIniTurno
          fechaHoraFinTurno
          latitudIni
          longitudIni
          ubicacionIni
          latitudFin
          longitudFin
          ubicacionFin
          minutosTotalTurno
          estado
          observacionesIni
          observacionesFin
          fechaCreate
          usuarioCreate
          imgInicio
          imgFin
          brandIni
          modelNameIni
          modelIdIni
          deviceYearClassIni
          osBuildIdIni
          osVersionIni
          brandFin
          modelNameFin
          modelIdFin
          deviceYearClassFin
          osBuildIdFin
          osVersionFin
        }
      }
      `,
      allTurnoRtes: gpl `
        query ($tipoqry: String){
          allTurnoRtes(tipoqry: $tipoqry) {
            _id
            cedula
            nombreUsuario
            email
            fechaHoraIniTurno
            fechaHoraFinTurno
            latitudIni
            longitudIni
            ubicacionIni
            latitudFin
            longitudFin
            ubicacionFin
            minutosTotalTurno
            estado
            observacionesIni
            observacionesFin
            fechaCreate
            usuarioCreate
            imgInicio
            imgFin
            brandIni
            modelNameIni
            modelIdIni
            deviceYearClassIni
            osBuildIdIni
            osVersionIni
            brandFin
            modelNameFin
            modelIdFin
            deviceYearClassFin
            osBuildIdFin
            osVersionFin
          }
        }
      `,
      allEmpresa: gpl `
      query{        
        allEmpresa{
        _id
        descrEmpresa
        comercialAtiende
        ciudad
        pais
        nit
        direccion
        telefono
        logo
        rut
        camara
        consecProducto
        consecServicio
        consecPrograma
        codEmpresa
        ultimaFormaPago
        anexos
        rutas
        laboratorio
        rutaInforme
        rutaBitacora
        rutaLogo
        }
      }
      `,
      allEmpresaRtes: gpl `
          query ($tipoqry: String){
            allEmpresaRtes(tipoqry: $tipoqry) {
              _id
              descrEmpresa 
              comercialAtiende
              ciudad
              pais
              nit
              direccion 
              telefono 
              logo
              rut
              camara
              consecProducto
              consecServicio
              consecPrograma
              codEmpresa
              ultimaFormaPago
              anexos
              rutas
              laboratorio
              rutaInforme
              rutaBitacora
              rutaLogo
            }
          }
      `,
      allEmpresaInd: gpl `
      query ($tipoqry: String){
        allEmpresaInd(tipoqry: $tipoqry) {
          _id
          descrEmpresa 
          nit
          direccion 
          telefono 
          logo
          rutaLogo
          rut
          camara
          consecProducto
          consecServicio
          consecPrograma
          anexos
          rutas
          laboratorio
          codEmpresa
          tipo
          subTipo
          usuario
          creado 
          desde
          hasta
          descrPlanta
          descrSeccion
          descrEquipo
          descrComponente
          descrMecanismo
          tipoLub
          descrLubricante
          descrUnidad
          descrMetodo
          descrTarea
          descrAplicacion
          tipoHallazgo
          color
          modo
          riesgo
          cantTotal
          cantMensual
          cantAnual
          puntos
          minutos
        }
      }
  `,
      allContacto: gpl `
      query{        
        allContacto{
        _id
        descrEmpresa
        nombreContacto 
        ciudadContacto
        cargoContacto
        mailContacto
        telContacto
        }
      }
      `,
      allContactoRtes: gpl `
          query ($tipoqry: String){
            allContactoRtes(tipoqry: $tipoqry) {
              _id
              descrEmpresa
              nombreContacto 
              ciudadContacto
              cargoContacto
              mailContacto
              telContacto
            }
          }
      `,
      allOperario: gpl `{
        allOperario{
          _id
          descrOperario
          cedula
        }
      }
      `,
      allSolicCompra: gpl `
        query ($tipoqry: String){
          allSolicCompra(tipoqry: $tipoqry) {
            _id
          descrProducto
          cantidad
          activo
          fechaCreate
          usuarioCreate
          }
        }
      `, 
      allLocalizac: gpl `{
        allLocalizac{
          _id
          descrLocalizac
        }
      }
      `,
      allCptogasto: gpl `{
        allCptogasto{
          _id
          descrCptogasto
        }
      }
      `,
      allCtocosto: gpl `{
        allCtocosto{
          _id
          descrCtocosto
        }
      }
      `,
      allTiposequipo: gpl `{
        allTiposequipo{
          _id
          descrTiposequipo
        }
      }
      `,
      allTiposcomp: gpl `{
        allTiposcomp{
          _id
          descrTiposcomp
        }
      }
      `,
      allFabricante: gpl `{
        allFabricante{
          _id
          descrFabricante
        }
      }
      `,
      allUnidad: gpl `{
        allUnidad{
          _id
          tipoUnidad
          descrUnidad
          abrevUnidad
        }
      }
      `,
      allEncuesta: gpl `{
        allEncuesta{
          _id
          pregunta
        }
      }
      `,
      allMeta: gpl `{
        allMeta{
          _id
          tipoMeta
          agno
          mes
          mesNum
          grupo
          cedula
          nombreUsuario
          valor
          meta
          valorReal
          valorRealAcumAgno
          metaAgno
          metaAcumAgno
          porcCumplimientoMetaAgno
          estado
          rango1Desde
          rango1Hasta
          rango2Hasta
          rango3Hasta
          porcCumplimiento
          porcCumplimientoMeta
          rangoAplicado
          valorRecaudo
          valorComision
          comisionVentas
        }
      }
      `,
      allMetaRtes: gpl `
        query ($tipoqry: String){
          allMetaRtes(tipoqry: $tipoqry) {
            _id
            tipoMeta
            agno
            mes
            mesNum
            grupo
            cedula
            nombreUsuario
            valor
            meta
            valorReal
            valorRealAcumAgno
            metaAgno
            metaAcumAgno
            porcCumplimientoMetaAgno
            estado
            rango1Desde
            rango1Hasta
            rango2Hasta
            rango3Hasta
            porcCumplimiento
            porcCumplimientoMeta
            rangoAplicado
            valorRecaudo
            valorComision
            comisionVentas
          }
        }
      `, 
      allMaterial: gpl `{
        allMaterial{
          _id
          tipoMaterial
          descrMaterial
          codMaterial
        }
      }
      `,
      allPolitica: gpl `{
        allPolitica{
          _id
          titulo
          descrPolitica
          tipoProducto
          titulo2
          parrafo2
          titulo3
          parrafo3
        }
      }
      `,
      allCotizacion: gpl `{
        allCotizacion{
          _id
          tipoCoti 
          pais
          numCoti
          numSolic
          ordenCompraCliente
          cedula
          nombreUsuario
          cedulaOC
          nombreUsuarioOC
          titulo
          descrPolitica
          titulo2
          parrafo2
          titulo3
          parrafo3
          tipo
          ciudadFechaEnvio
          monedaCoti
          imptoCoti
          nombreContacto 
          ciudadContacto
          cargoContacto
          mailContacto
          telContacto
          referencia
          tiempoEntrega
          lugarEntrega
          formaPago
          validezOferta
          estadoCoti 
          numOrdenCompra
          descrEmpresa
          descrProveed
          ciudad
          direccion
          telefono
          email
          archivoEnviado
          archivoRecibido
          fechaCreate         
          usuarioCreate
          observaciones
          fechaAut
          usuarioAut
          observacionesAut
          fechaEnvio
          usuarioEnvio
          fechaRta
          usuarioRta
          estadoOC
          archivoEncuesta
          actaInicial
          actaFinal
          informe
          contactoEncuesta
          cedulaEncuesta
          telefonoEncuesta
          emailEncuesta
          fechaIni
          fechaFin
          usuarioIni
          observacionesOC
          usuarioAutOC
          fechaAutOC
          usuarioCanOC
          fechaCanOC
          observacionesAutOC
          usuarioEjec
          fechaEjec
          fechaFinReal
          observacionesFin
          totalOC
          fechaOrdenCliente
          totalFact
          usuarioTotalOC
          usuarioFac
          fechaFac
          consecAvance
          consecDespacho
          trm
          itemsEncuesta{
            pregunta
            respuesta
            valoracion
          }
          itemsCoti{
            tipoProducto
            descrProducto
            descrCorta
            numProductoCoti
            ficha
            ficha2
            cantidadCoti
            valorUniCoti
            porcDcto
            porcIncremento
            porcIVA
            recargoTransp
            cantidadAprob
            cantidadRecibida
            valorUniAprob
            descrUnidad
            abrevUnidad
            numOrdenCompraCli
            cantidadOC
            moneda
            cantidadDespacho
            cantidadFact
            cantidadCompra
            cantidadCompraEjec
            fechaSolicCompra
            fechaEjecCompra
          }
          itemsFactura{
            numAvance
            valorFact
            valorFactSinIva
            numFactura
            trmFactura
            valorPagado
            archivoFactura
            ordenPago
            usuarioSolic
            fechaSolic
            usuarioFact
            fechaFact
            usuarioPago
            fechaPago
            venceFact
          }   
          itemsDespacho{
            numDespacho
            codigo
            codAvance
            descrProductoDes
            descrCortaDes
            idProducto
            cantidad
            cantidadDev
            valorDes
            descrUnidadDes
            usuarioDespacho
            fechaDespacho
            despFact
            porcIVADes
            porcDctoDes
            porcIncrementoDes
            dirEntrega
            fechaEntrega
            transportadora
            numGuia
            emailAviso
            porcComision
            valorComision
            agnoComision
            mesComision
            estadoComision
          }     
          itemsPagos{
            codiAvance
            valorPago
            valorIVA
            valorRetencion
            valorAjuste
            observacionAjuste
            tipoPago
            usuarioRegPago
            fechaRegPago
            cliProv
            trmPago
          }
        }
      }
      `,
      allCotizacionRtes: gpl `
        query ($tipoqry: String){
          allCotizacionRtes(tipoqry: $tipoqry) {
            _id
            tipoCoti 
            pais
            numCoti
            numSolic
            ordenCompraCliente
            cedula
            nombreUsuario
            cedulaOC
            nombreUsuarioOC
            titulo
            descrPolitica
            titulo2
            parrafo2
            titulo3
            parrafo3
            tipo
            ciudadFechaEnvio
            monedaCoti
            imptoCoti
            nombreContacto 
            ciudadContacto
            cargoContacto
            mailContacto
            telContacto
            referencia
            tiempoEntrega
            lugarEntrega
            formaPago
            validezOferta
            estadoCoti 
            numOrdenCompra
            descrEmpresa
            descrProveed
            ciudad
            direccion
            telefono
            email
            archivoEnviado
            archivoRecibido
            fechaCreate
            usuarioCreate
            observaciones
            fechaAut
            usuarioAut
            observacionesAut
            fechaEnvio
            usuarioEnvio
            fechaRta
            usuarioRta
            estadoOC
            archivoEncuesta
            actaInicial
            actaFinal
            informe
            contactoEncuesta
            cedulaEncuesta
            telefonoEncuesta
            emailEncuesta
            fechaIni
            fechaFin
            usuarioIni
            observacionesOC
            usuarioAutOC
            fechaAutOC
            usuarioCanOC
            fechaCanOC
            observacionesAutOC
            usuarioEjec
            fechaEjec
            fechaFinReal
            observacionesFin
            totalOC
            fechaOrdenCliente
            totalFact
            usuarioTotalOC
            usuarioFac
            fechaFac
            consecAvance
            consecDespacho
            trm
            trmFactura
            trmPago
            pregunta
            respuesta
            valoracion
            tipoProducto
            descrProducto
            descrCorta
            numProductoCoti
            ficha
            ficha2
            cantidadCoti
            valorUniCoti
            porcDcto
            porcIncremento
            porcIVA
            recargoTransp
            cantidadAprob
            cantidadRecibida
            valorUniAprob
            descrUnidad
            abrevUnidad
            numOrdenCompraCli
            cantidadOC
            moneda
            cantidadDespacho
            cantidadFact
            cantidadCompra
            cantidadCompraEjec
            fechaSolicCompra
            fechaEjecCompra
            numAvance
            valorFact
            valorFactSinIva
            numFactura
            valorPagado
            archivoFactura
            ordenPago
            usuarioSolic
            fechaSolic
            usuarioFact
            fechaFact
            usuarioPago
            fechaPago
            venceFact
            codAvance
            numDespacho
            codigo
            descrProductoDes
            descrCortaDes
            idProducto
            cantidad
            cantidadDev
            valorDes
            descrUnidadDes
            usuarioDespacho
            fechaDespacho
            despFact
            porcIVADes
            porcDctoDes
            porcIncrementoDes
            dirEntrega
            fechaEntrega
            transportadora
            numGuia
            emailAviso
            porcComision
            valorComision
            agnoComision
            mesComision
            estadoComision
            codiAvance
            valorPago
            valorIVA
            valorRetencion
            valorAjuste
            observacionAjuste
            tipoPago
            usuarioRegPago
            fechaRegPago
            cliProv
            zonaFranca
            gestionIngreso
            estadoGestion
            motivoEstado
            aplicaComision
            rangoAplicado
            diasImportacion
          }
        }
      `,
    allLubricanteRtes: gpl `
      query ($tipoqry: String){
        allLubricanteRtes(tipoqry: $tipoqry) {
          _id
          descrLubricante
          descrFabricante
          tipoLub
          claseLub
          categoriaLub
          tipoGrado
          descrGrado
          colorGrado
          apiSAE
          isoGrasa
          isoGrasaColor
          isoGrasaTexto
          descrEmpresa
          existencia
          minimo
          descrUnidad
          usuarioAct
          fechaAct
        }
      }
    `,
      allMetodo: gpl `{
        allMetodo{
          _id
          tipoLub
          descrMetodo
        }
      }
      `,
      allHallazgo: gpl `{
        allHallazgo{
          _id
          descrHallazgo
        }
      }
      `,
      allUtilidad: gpl `{
        allUtilidad{
          _id
          descrUtilidad
        }
      }
      `,
      allPrograma: gpl `{
        allPrograma{
          _id
          descrPrograma
        }
      }
      `,
      allTarea: gpl `{
        allTarea{
          _id
          tipoLub
          descrTarea
        }
      }
      `,
      allFrecuencia: gpl `{
        allFrecuencia{
          _id
          tipoFrecuencia
          descrFrecuencia
          cantidad
          abrevUnidad
        }
      }
      `,
      allAplicacion: gpl `{
        allAplicacion{
          _id
          descrAplicacion
          tipoLub
          tipoGrado
          sector
          color
        }
      }
      `,
      allGrado: gpl `{
        allGrado{
          _id
          tipoLub
          tipoGrado
          descrGrado
          sector
          aplicacionSAE
          categoriaSAE
          apiSAE
          color
          colorTexto
        }
      }
      `,
      allGradoRtes: gpl `
        query ($tipoqry: String){
          allGradoRtes(tipoqry: $tipoqry) {
            _id
            tipoLub
            tipoGrado
            descrGrado
            sector
            aplicacionSAE
            categoriaSAE
            apiSAE
            color
            colorTexto
          }
        }
      `,           
      allLubricante: gpl `{
        allLubricante{
          _id
          descrLubricante
          descrFabricante
          tipoLub
          claseLub
          categoriaLub
          tipoGrado
          descrGrado
          colorGrado
          apiSAE
          isoGrasa
          isoGrasaColor
          isoGrasaTexto
          color
          visco40
          visco100
          indice
          agua
          codigoPar
          micras4
          micras6
          micras14
          micras21
          micras25
          micras38
          micras70
          hollin
          nitracion
          sulfatacion
          dilucion
          glicol
          oxidacion
          tan
          tbn
          hierro
          cobre
          aluminio
          cromo
          plomo
          estano
          niquel
          vanadio
          titanio
          silicio
          sodio
          potasio
          boro
          magnesio
          calcio
          fosforo
          zinc
          molibdeno
          bario
          manganeso
          fluidez
          inflamacion
          cenizas
          tost
          rpvot
          metalicos
          phosporus
          grasa
          separabilidad
          abrasion
          bolas
          huella
          timken
          espuma
          secuencia1
          secuencia2
          secuencia3
          aeroemulsion
          demulsibilidad
          emulsion
          corrosion
          ultracentrifuga
          densidad
          fuego
          herrumbre
          destilada
          deMar
          temperatura
          penetracion
          goteo
          lavado
          nsf
          fda
          biodegradables
          noToxico
          ignifugo
          cumple
          salud
          inflamabilidad
          reactividad
          blanco
          pq
          fischer
          tanpte
          tbnpte
        }
      }
      `,
      allProcEjec: gpl `{
        allProcEjec{
          _id
          descrProcedimiento
          codProcedimiento
          nombreArchivo
        }
      }
      `,
      allInfoTarea: gpl `{
        allInfoTarea{
          _id
          descrInfoTarea
          codInfoTarea
          nombreArchivoInfo
        }
      }
      `,
      allPrueba: gpl `
      query ($_id: ID, $tipoPrueba: String, $descrPrueba: String, $unidad: String, $validacion: String, 
        $codNorma: String, $descrNorma: String, $campoBD: String, $descrArchivo: String, $tipoProblema: String, 
        $descrAplicacion: String, $descripcion: String, $metodo: String,
        $analisisCon: String,
        $analisisPre: String,
        $analisisAla: String,
        $analisisPel: String,
        $recomenCon: String,
        $recomenPre: String,
        $recomenAla: String,
        $recomenPel: String,){
          allPrueba(_id: $_id, tipoPrueba: $tipoPrueba, descrPrueba: $descrPrueba, unidad: $unidad, 
            validacion: $validacion, codNorma: $codNorma, descrNorma: $descrNorma, campoBD: $campoBD, 
            descrArchivo: $descrArchivo, tipoProblema: $tipoProblema, descrAplicacion: $descrAplicacion, 
            descripcion: $descripcion, metodo: $metodo,
            analisisCon: $analisisCon,
            analisisPre: $analisisPre,
            analisisAla: $analisisAla,
            analisisPel: $analisisPel,
            recomenCon: $recomenCon,
            recomenPre: $recomenPre,
            recomenAla: $recomenAla,
            recomenPel: $recomenPel,){
          _id
          tipoPrueba
          descrPrueba
          unidad
          validacion
          codNorma
          descrNorma
          campoBD
          descrArchivo
          tipoProblema
          descripcion
          metodo
          analisisCon
          analisisPre
          analisisAla
          analisisPel
          recomenCon
          recomenPre
          recomenAla
          recomenPel
          pruebaslab{
            descrAplicacion
            valor1Alarma
            valor2Alarma
            valor3Alarma
            valor1Corte
            valor2Corte
            valor3Corte
          }        
        }
      }
      `,
      allPruebaRtes: gpl `
        query ($tipoqry: String){
          allPruebaRtes(tipoqry: $tipoqry) {
            _id
            tipoPrueba
            descrPrueba
            validacion
            descrAplicacion
            analisisCon
            analisisAla
            analisisPel
            recomenCon
            recomenAla
            recomenPel
            valor1Alarma
            valor2Alarma
            valor3Alarma
            valor1Corte
            valor2Corte
            valor3Corte
            fechaCreate
          }
        }
      `,           
      allMecValRef: gpl `
      query ($_id: ID, $descrEmpresa: String, $descrPlanta: String, $descrSeccion: String, 
          $descrEquipo: String, $descrComponente: String, $descrMecanismo: String, $descrAplicacion: String){
          allMecValRef(_id: $_id, descrEmpresa: $descrEmpresa, descrPlanta: $descrPlanta, descrSeccion: $descrSeccion, descrEquipo: $descrEquipo, descrComponente: $descrComponente, descrMecanismo: $descrMecanismo, descrAplicacion: $descrAplicacion){
          _id
          descrEmpresa
          descrPlanta
          descrSeccion
          descrEquipo
          descrComponente
          descrMecanismo
          descrAplicacion
          pruebaslab{
            descrPrueba
            tipoPrueba
            validacion
            valor1Alarma
            valor2Alarma
            valor3Alarma
            valor1Corte
            valor2Corte
            valor3Corte
            fechaCreate
          }        
        }
      }
      `,
      allMecValRefRtes: gpl `
      query ($tipoqry: String){
        allMecValRefRtes(tipoqry: $tipoqry) {
          _id
          descrEmpresa
          descrPlanta
          descrSeccion
          descrEquipo
          descrComponente
          descrMecanismo
          descrAplicacion
          descrPrueba
          tipoPrueba
          validacion
          valor1Alarma
          valor2Alarma
          valor3Alarma
          valor1Corte
          valor2Corte
          valor3Corte 
          fechaCreate
        }
      }
    `,           
      allPlanta: gpl `
      query ($_id: ID, $codPlanta: String, $descrPlanta: String, $codSeccion: String, $descrSeccion: String, $codEquipo: String, $descrEquipo: String, $codComponente: String, $descrComponente: String, $codMecanismo: String, $descrMecanismo: String){
          allPlanta(_id: $_id, codPlanta: $codPlanta, descrPlanta: $descrPlanta, codSeccion: $codSeccion, descrSeccion: $descrSeccion, codEquipo: $codEquipo, descrEquipo: $descrEquipo, codComponente: $codComponente, descrComponente: $descrComponente, codMecanismo: $codMecanismo, descrMecanismo: $descrMecanismo) {
          _id
          codPlanta
          descrPlanta
          secciones{
            codSeccion
            descrSeccion
            equipos{
              codEquipo
              descrEquipo
              numCarta
              descrPrograma
              nombreUsuario
              cedula
              acumulado
              fechaAcum
              usuarioAcum
              horasKmPorDia
              componentes{
                codComponente
                descrComponente
                mecanismos{
                  codMecanismo
                  descrMecanismo
                  estado
                  ultInforme
                  nomArchivo
                  claseLub
                  descrFabricante
                  descrLubricante
                  categoriaLub
                  tipoLub
                  tipoGrado
                  descrGrado
                  colorGrado
                  colorTexto
                  apiSAE
                  isoGrasa
                  isoGrasaColor
                  isoGrasaTexto
                  descrUtilidad
                  descrAplicacion
                  colorAplicacion
                  tipoFrecuencia
                  abrevUnidadTF
                  cantidadTotal
                  descrUnidad
                  abrevUnidad
                  programacion{
                    consecutivo
                    cantidad
                    puntosLub
                    minutos
                    descrUnidad
                    descrMetodo
                    descrTarea
                    modoTarea
                    requiereSISO
                    descrFrecuencia
                    descrFrecuenciaPre
                    codProcedimiento
                    codInfoTarea
                    descrInfoTarea
                    nombreArchivo
                    nombreArchivoInfo
                    fechaUlt
                    fechaProx
                    acumUlt
                    acumProx
                    archRotulo
                    enRuta
                    ultObservacion
                    activo
                    estadoTarea
                  }
                }
              }
              imagenes{
                nombreImagen
                archImagen
                anchoImagen
                altoImagen
                ordenImagen
              }  
              documentos{
                nombreDoc
              }  
            }
            imagen{
              nombre
            }
          }
        }
      }
      `,
        allPlantaRtes: gpl `
          query ($tipoqry: String){
            allPlantaRtes(tipoqry: $tipoqry) {
              idPlanta
              codPlanta
              descrPlanta
              descrEmpresa
              codSeccion
              descrSeccion
              codEquipo
              descrEquipo
              numCarta
              descrPrograma
              nombreUsuario
              cedula
              acumulado
              fechaAcum
              usuarioAcum
              horasKmPorDia
              codComponente
              descrComponente
              codMecanismo
              codigoQR
              descrMecanismo
              estado
              ultInforme
              nomArchivo
              claseLub
              descrUtilidad
              descrAplicacion
              colorAplicacion
              descrFabricante
              descrLubricante
              categoriaLub
              tipoLub
              tipoGrado
              descrGrado
              colorGrado
              colorTexto
              apiSAE
              isoGrasa
              isoGrasaColor
              isoGrasaTexto
              tipoFrecuencia
              abrevUnidadTF
              cantidadTotal
              descrUnidad
              abrevUnidad
              enInfLabNuevo
              descrMetodo
              descrTarea
              modoTarea
              requiereSISO
              consecutivo
              cantidad
              puntosLub
              minutos
              descrFrecuencia
              descrFrecuenciaPre
              codProcedimiento
              archRotulo
              codInfoTarea
              descrInfoTarea
              nombreArchivo
              nombreArchivoInfo
              fechaUlt
              fechaProx
              acumUlt
              acumProx
              enRuta
              ultObservacion
              activo
              estadoTarea
              nombreImagen
              archImagen
              anchoImagen
              altoImagen
              ordenImagen
              nombre
              nombreDoc
            }
          }
          `,
          allInflab: gpl ` 
            query ($_id: ID, $numeroInflab: Number, $mecInflab: Number, $descrPlanta: String){
              allInflab(_id: $_id, numeroInflab: $numeroInflab, mecInflab: $mecInflab, descrPlanta: $descrPlanta) {
                _id
                estadoInflab
                estadoEnvio
                fechaEnvioLab
                usuarioEnvioLab
                fechaRecibeLab
                usuarioRecibeLab
                fechaEnvioCliente
                usuarioEnvioCliente
                numeroInflab
                mecInflab
                ruta
                numeroOrden
                descrEmpresa
                nombreUsuario
                email
                telefono
                codPlanta
                descrPlanta
                codSeccion
                descrSeccion
                codEquipo
                descrEquipo
                descrPrograma
                codComponente
                descrComponente
                codMecanismo
                descrMecanismo
                descrAplicacion
                descrFabricante
                descrLubricante
                tipoLub
                tipoGrado
                descrGrado
                apiSAE
                tipoFrecuencia
                abrevUnidadTF
                abrevUnidad
                estado
                fechaMuestra
                tomaMuestra
                ultimoCambio
                recorrido
                cambioFiltroAc
                cambioFiltroAire
                aceiteRep
                aceiteTotal
                visco40
                visco100
                indice
                agua
                codigoPar
                micras4
                micras6
                micras14
                micras21
                micras25
                micras38
                micras70
                hollin
                nitracion
                sulfatacion
                dilucion
                glicol
                oxidacion
                tan
                tbn
                hierro
                cobre
                aluminio
                cromo
                plomo
                estano
                niquel
                vanadio
                titanio
                silicio
                sodio
                potasio
                boro
                magnesio
                calcio
                fosforo
                zinc
                molibdeno
                bario
                manganeso
                color
                rulerP
                rulerA
                rulerF
                rulerZ
                rpvot
                barniz
                demulsibilidadA
                demulsibilidadAg
                demulsibilidadE
                demulsibilidadT
                separaA54
                separaAg54
                separaE54
                separaT54
                separaA82
                separaAg82
                separaE82
                separaT82
                espumas1_0
                espumas1_10
                espumas2_0
                espumas2_10
                espumas3_0
                espumas3_10
                liberacion
                inflamacion
                corrosion
                ultracentrifuga      
                densidad     
                apariencia
                olor
                fuego    
                observaciones
                observacionesLab
                acciones
                inf1
                inf2
                inf3
                est1
                est2
                est3
                fab1
                fab2
                fab3
                lub1
                lub2
                lub3
                gra1
                gra2
                gra3
                mue1
                mue2
                mue3
                ult1
                ult2
                ult3
                rec1
                rec2
                rec3
                fil1
                fil2
                fil3
                aire1
                aire2
                aire3
                rep1
                rep2
                rep3
                tot1
                tot2
                tot3
                fec1
                fec2
                fec3
                fecEnv1
                fecEnv2
                fecEnv3
                fecRec1
                fecRec2
                fecRec3
                fecCli1
                fecCli2
                fecCli3
                diasEnt
                diasLog
                diasEnt1
                diasLog1
                diasEnt2
                diasLog2
                diasEnt3
                diasLog3
                nomArchivo
                reportes{
                  columna1
                  columna2
                  columna3
                  columna4
                  columna5
                  columna6
                  columna7
                  columna8
                  columna9
                  columna10
                  columna11
                  columna12
                  columna13
                  columna14
                  columna15
                  columna16
                  columna17
                  columna18
                  columna19
                  columna20
                  columna21
                  columna22
                  columna23
                  columna24
                  columna25
                  columna26
                  columna27
                  columna28
                  columna29
                  columna30
                }
                fechaCreate
                usuarioCreate
              }
            }
          `,
          allInflabRtes: gpl `
            query ($tipoqry: String){
              allInflabRtes(tipoqry: $tipoqry) {
                _id
                estadoInflab
                estadoEnvio
                fechaEnvioLab
                usuarioEnvioLab
                fechaRecibeLab
                usuarioRecibeLab
                fechaEnvioCliente
                usuarioEnvioCliente
                numeroInflab
                mecInflab
                prioridad
                ruta
                numeroOrden
                ordenSAP
                numOrdenCompra
                descrEmpresa
                nombreUsuario
                email
                telefono
                codPlanta
                descrPlanta
                codSeccion
                descrSeccion
                codEquipo
                descrEquipo
                descrPrograma
                codComponente
                descrComponente
                codMecanismo
                descrMecanismo
                descrAplicacion
                descrFabricante
                descrLubricante
                tipoLub
                tipoGrado
                descrGrado
                apiSAE
                tipoFrecuencia
                abrevUnidadTF
                abrevUnidad
                estado
                fechaMuestra
                tomaMuestra
                ultimoCambio
                recorrido
                cambioFiltroAc
                cambioFiltroAire
                aceiteRep
                aceiteTotal
                visco40
                visco100
                indice
                agua
                codigoPar
                micras4
                micras6
                micras14
                micras21
                micras25
                micras38
                micras70
                hollin
                nitracion
                sulfatacion
                dilucion
                glicol
                oxidacion
                tan
                tbn
                hierro
                cobre
                aluminio
                cromo
                plomo
                estano
                niquel
                vanadio
                titanio
                silicio
                sodio
                potasio
                boro
                magnesio
                calcio
                fosforo
                zinc
                molibdeno
                bario
                manganeso
                color
                rulerP
                rulerA
                rulerF
                rulerZ
                rpvot
                barniz
                demulsibilidadA
                demulsibilidadAg
                demulsibilidadE
                demulsibilidadT
                separaA54
                separaAg54
                separaE54
                separaT54
                separaA82
                separaAg82
                separaE82
                separaT82
                espumas1_0
                espumas1_10
                espumas2_0
                espumas2_10
                espumas3_0
                espumas3_10
                liberacion
                inflamacion
                corrosion
                ultracentrifuga         
                densidad   
                pq
                fischer
                tanpte
                tbnpte 
                pqE
                fischerE
                tanpteE
                tbnpteE
                pqV
                fischerV
                tanpteV
                tbnpteV   
                visco40E
                visco100E
                indiceE
                aguaE
                codigoParE
                micras4E
                micras6E
                micras14E
                micras21E
                micras25E
                micras38E
                micras70E
                hollinE
                nitracionE
                sulfatacionE
                dilucionE
                glicolE
                oxidacionE
                tanE
                tbnE
                hierroE
                cobreE
                aluminioE
                cromoE
                plomoE
                estanoE
                niquelE
                vanadioE
                titanioE
                silicioE
                sodioE
                potasioE
                boroE
                magnesioE
                calcioE
                fosforoE
                zincE
                molibdenoE
                barioE
                manganesoE
                colorE
                rulerPE
                rulerAE
                rulerFE
                rulerZE
                rpvotE
                barnizE
                demulsibilidadAE
                demulsibilidadAgE
                demulsibilidadEE
                demulsibilidadTE
                separaA54E
                separaAg54E
                separaE54E
                separaT54E
                separaA82E
                separaAg82E
                separaE82E
                separaT82E
                espumas1_0E
                espumas1_10E
                espumas2_0E
                espumas2_10E
                espumas3_0E
                espumas3_10E
                liberacionE
                inflamacionE
                corrosionE
                ultracentrifugaE
                densidadE
                apariencia
                olor
                fuego
                aparienciaE
                olorE
                fuegoE
                visco40V
                visco100V
                indiceV
                aguaV
                codigoParV
                micras4V
                micras6V
                micras14V
                micras21V
                micras25V
                micras38V
                micras70V
                hollinV
                nitracionV
                sulfatacionV
                dilucionV
                glicolV
                oxidacionV
                tanV
                tbnV
                hierroV
                cobreV
                aluminioV
                cromoV
                plomoV
                estanoV
                niquelV
                vanadioV
                titanioV
                silicioV
                sodioV
                potasioV
                boroV
                magnesioV
                calcioV
                fosforoV
                zincV
                molibdenoV
                barioV
                manganesoV
                colorV
                rulerPV
                rulerAV
                rulerFV
                rulerZV
                rpvotV
                barnizV
                demulsibilidadAV
                demulsibilidadAgV
                demulsibilidadEV
                demulsibilidadTV
                separaA54V
                separaAg54V
                separaE54V
                separaT54V
                separaA82V
                separaAg82V
                separaE82V
                separaT82V
                espumas1_0V
                espumas1_10V
                espumas2_0V
                espumas2_10V
                espumas3_0V
                espumas3_10V
                liberacionV
                inflamacionV
                corrosionV
                ultracentrifugaV
                densidadV
                aparienciaV
                olorV
                fuegoV
                observaciones
                observacionesLab
                acciones
                inf1
                inf2
                inf3
                est1
                est2
                est3
                fab1
                fab2
                fab3
                lub1
                lub2
                lub3
                gra1
                gra2
                gra3
                mue1
                mue2
                mue3
                ult1
                ult2
                ult3
                rec1
                rec2
                rec3
                fil1
                fil2
                fil3
                aire1
                aire2
                aire3
                rep1
                rep2
                rep3
                tot1
                tot2
                tot3
                fec1
                fec2
                fec3
                fecEnv1
                fecEnv2
                fecEnv3
                fecRec1
                fecRec2
                fecRec3
                fecCli1
                fecCli2
                fecCli3
                diasEnt
                diasLog
                diasEnt1
                diasLog1
                diasEnt2
                diasLog2
                diasEnt3
                diasLog3
                nomArchivo
                reportes{
                  columna1
                  columna2
                  columna3
                  columna4
                  columna5
                  columna6
                  columna7
                  columna8
                  columna9
                  columna10
                  columna11
                  columna12
                  columna13
                  columna14
                  columna15
                  columna16
                  columna17
                  columna18
                  columna19
                  columna20
                  columna21
                  columna22
                  columna23
                  columna24
                  columna25
                  columna26
                  columna27
                  columna28
                  columna29
                  columna30
                }
                columna1
                columna2
                columna3
                columna4
                columna5
                columna6
                columna7
                columna8
                columna9
                columna10
                columna11
                columna12
                columna13
                columna14
                columna15
                columna16
                columna17
                columna18
                columna19
                columna20
                columna21
                columna22
                columna23
                columna24
                columna25
                columna26
                columna27
                columna28
                columna29
                columna30
                fechaCreate
                usuarioCreate
              }
            }
          `,
          allOrden: gpl `{
            allOrden{
              _id
              ruta
              fechaIni
              fechaFin
              estadoOrden
              numeroOrden
              ordenSAP
              descrEmpresa
              nombreUsuario
              cedula
              mail
              telefono
              codPlanta
              descrPlanta
              codSeccion
              descrSeccion
              codEquipo
              descrEquipo
              descrPrograma
              codComponente
              descrComponente
              codMecanismo
              descrMecanismo
              codigoQR
              claseLub
              tipoLub
              descrFabricante
              descrLubricante
              descrUtilidad
              descrAplicacion
              tipoFrecuencia
              abrevUnidadTF
              cantidadTotal
              descrUnidad
              abrevUnidad
              cantidad
              puntosLub
              minutos
              descrMetodo
              descrTarea
              modoTarea
              requiereSISO
              descrHallazgo
              descrFrecuencia
              descrFrecuenciaPre
              acumulado
              fechaUlt
              fechaProx
              acumUlt
              acumProx
              realizado
              acumReal
              fechaProg
              fechaReal
              horaReal
              cantidadReal
              minutosReal
              observaciones
              observacionesReal
              nombreUsuarioReal
              cedulaReal
              codProcedimiento
              nombreArchivo
              codInfoTarea
              descrInfoTarea
              nombreArchivoInfo
              numeroInflab
              mecInflab
              tempAntesLub
              tempDespuesLub
              ultraAntesLub
              ultraDespuesLub
              vibraAntesLub
              vibraDespuesLub
              imgAntes
              imgDespues
              videoAntes
              videoDespues
              fechaCreate
              usuarioCreate
              fechaUpd
              usuarioUpd
              alimSistema
              fallaLub
              archivoRCA
              tiempoFalla
              costoFalla
            }
          }
          `,   
          allOrdenRtes: gpl `
            query ($tipoqry: String){
              allOrdenRtes(tipoqry: $tipoqry) {
                _id
                ruta
                fechaIni
                fechaFin
                estadoOrden
                numeroOrden
                ordenSAP
                descrEmpresa
                nombreUsuario
                cedula
                mail
                telefono
                codPlanta
                descrPlanta
                codSeccion
                descrSeccion
                codEquipo
                descrEquipo
                descrPrograma
                codComponente
                descrComponente
                codMecanismo
                descrMecanismo
                codigoQR
                tipoLub
                claseLub
                descrFabricante
                descrLubricante
                descrUtilidad
                descrAplicacion
                tipoFrecuencia
                abrevUnidadTF
                cantidadTotal
                descrUnidad
                abrevUnidad
                cantidad
                puntosLub
                minutos
                descrMetodo
                descrTarea
                modoTarea
                requiereSISO
                descrHallazgo
                descrFrecuencia
                descrFrecuenciaPre
                acumulado
                fechaUlt
                fechaProx
                acumUlt
                acumProx
                realizado
                acumReal
                fechaProg
                fechaReal
                horaReal
                cantidadReal
                minutosReal
                observaciones
                observacionesReal
                nombreUsuarioReal
                cedulaReal
                codProcedimiento
                nombreArchivo
                codInfoTarea
                descrInfoTarea
                nombreArchivoInfo
                numeroInflab
                mecInflab
                tempAntesLub
                tempDespuesLub
                ultraAntesLub
                ultraDespuesLub
                vibraAntesLub
                vibraDespuesLub
                imgAntes
                imgDespues
                videoAntes
                videoDespues
                fechaCreate
                usuarioCreate
                fechaUpd
                usuarioUpd
                alimSistema
                fallaLub
                archivoRCA
                tiempoFalla
                costoFalla
              }
            }
          `,      
      allDocumento: gpl `{
        allDocumento{
          _id
          descrDocumento
        }
      }
      `,
      allBancoprov: gpl `{
        allBancoprov{
          _id
          descrBancoprov
        }
      }
      `,
      allProveed: gpl `{
        allProveed{
          _id
          descrDocumento
          ciudad
          direccion
          telefono
          email
          contacto
          numeroDocumento
          descrProveed
          consecCoti
        }
      }
      `,
      allProducto: gpl `{
        allProducto{
          _id
          tipoProducto
          descrProducto
          descrCorta
          marca
          ficha
          ficha2
          precio
          vigenteHasta
          numProducto
          descrUnidad 
          porcIVA
          descrLubricante
          estado
          fechaCreate
          precioDolar
          porcImpto
          tipoOrden
          costo
          monedaCosto
          margen
          codigo
          comisionRango1
          comisionRango2
          comisionRango3
          comisionExt
        }
      }
      `,
      allProductoRtes: gpl `
          query ($tipoqry: String){
            allProductoRtes(tipoqry: $tipoqry) {
              _id
              tipoProducto
              descrProducto
              descrCorta
              marca
              ficha
              ficha2
              precio
              vigenteHasta
              numProducto
              descrUnidad 
              porcIVA
              descrLubricante
              estado
              fechaCreate
              precioDolar
              porcImpto
              tipoOrden
              costo
              monedaCosto
              margen
              codigo
              comisionRango1
              comisionRango2
              comisionRango3
              comisionExt
            }
          }
      `,
      allCaja: gpl `{
        allCaja{
          _id
          numCaja
          tipoCaja
          descrCaja
          saldoCaja
        }
      }
      `,
      allProyecto: gpl `
        query ($contrato: String, $descrEmpresa: String, $obra: String, $estadoProyecto: String,
              $descrLocalizac: String, $numDocum: Int){
            allProyecto(contrato: $contrato, descrEmpresa: $descrEmpresa, obra: $obra, estadoProyecto: $estadoProyecto,
                descrLocalizac: $descrLocalizac, numDocum: $numDocum){
            _id
            contrato
            descrEmpresa
            obra
            estadoProyecto
            descrLocalizac
            fechaAsig
            fechaInicio
            fechaFinal
            nuevaFechaFinal
            fechaUpdAdicional
            usrUpdAdicional
            valorInicial
            valorAdicional
            valorTotal
            valorGastadoTotal
            observaciones
            fechaCreate
            presupgastos{
              descrCptogasto
              valorPresupuestado
              valorGastado
            }
          }
        }
      `,
      allMovcaja: gpl `
        query ($_id: ID, $contrato: String, $tipo: String, $subtipo: String, $tipoDocum: String, $fechaMov: Date, 
          $estadoMovim: String, $fechaPago: Date, $numOrdenPago: Number, $fechaOrden: Date, $descrCaja: String,
          $descrProveed: String, $descrCptogasto: String, $orden: String){
            allMovcaja(_id: $_id, contrato: $contrato, tipo: $tipo, subtipo: $subtipo, tipoDocum: $tipoDocum,
              fechaMov: $fechaMov, estadoMovim: $estadoMovim, fechaPago: $fechaPago, numOrdenPago: $numOrdenPago,
              fechaOrden: $fechaOrden, descrCaja: $descrCaja, descrProveed: $descrProveed,
              descrCptogasto: $descrCptogasto, orden: $orden){
            _id
            contrato
            tipo
            subtipo
            tipoDocum
            numeroDocum
            fechaMov
            estadoMovim
            concepto
            valorMovim
            valorReal
            fechaPago
            saldoCaja
            fechaEntreg
            fechaAnul
            numOrdenPago
            numeroEgreso
            cuentaContable
            fechaAut
            fechaRech
            fechaOrden
            fechaEnviado
            enviadoCon
            descrCaja
            descrdocumprov
            numdocumprov
            descrProveed
            descrBancoprov
            nombreTitular
            numCuenta
            tipoCuenta
            descrCptogasto
            fechaCreate
          }
        }
      `,
      allMovcajaRtes: gpl `
        query ($contrato: String, $tipo: String, $subtipo: String, $estadoMovim: String, $tipoqry: String){
          allMovcajaRtes(contrato: $contrato, tipo: $tipo, subtipo: $subtipo, estadoMovim: $estadoMovim,
              tipoqry: $tipoqry) {
            _id
            contrato
            tipo
            subtipo
            tipoDocum
            numeroDocum
            fechaMov
            estadoMovim
            concepto
            valorMovim
            valorReal
            fechaPago
            saldoCaja
            fechaEntreg
            fechaAnul
            numOrdenPago
            numeroEgreso
            cuentaContable
            fechaAut
            fechaRech
            fechaOrden
            fechaEnviado
            enviadoCon
            descrCaja
            descrdocumprov
            numdocumprov
            descrProveed
            descrBancoprov
            nombreTitular
            numCuenta
            tipoCuenta
            descrCptogasto
            fechaCreate          
          }
        }
      `,
    allMigrarBarrio: gpl `{
      allMigrarBarrio{
        _id
        codDpto
        codCiudad
        codZonas
        zona
        codigoBarrio
        nombrearea
        descrRecursoT
        numeroDocumT
        codigoTipoDocT
        descrRecursoR
        numeroDocumR
        codigoTipoDocR
      }
    }
    `,
    allMigrarServicio: gpl `{
      allMigrarServicio{
        _id
        idClaseServ
        codigoClaseServ
        descrClaseServ
        subclase
        codServicio
        DescResServicio
        DescServicio
        conceptoFra
        consecutivo
      }
    }
    `,
    allMigrarTarifa: gpl `{
      allMigrarTarifa{
        _id
        DescServicio
        Valor
        IVA
        ParaTarifa
      }
    }
    `,
    allMigrarCliente: gpl `{
      allMigrarCliente{
        _id
        numerocontrato
        contratosnet
        nombreabonado
        apellidosabonado
        estrato
        cicloFact
        Sexo
        TIPODOCUM
        cedulaabonado
        telefonoabonado
        celularabonado
        pagohastames
        pagohastaagno
        fechaafiliacion
        fechainstalacion
        fechadesconexionretiro
        fechareconexiion
        fecultimopago
        valorultimopago
        emailabonado
        observaciones
        CODTIPOCL
        CODGRAF
        estadoconexion
        Saldo
        SaldoInt
        mesesadelantado
      }
    }
    `,
    allMigrarDireccion: gpl `{
      allMigrarDireccion{
        numerocontrato
        TipoVia1
        campo2dir
        TipoVia2
        campo4dir
        campo5dir
        TipoUnd1
        direccioninterna
        TipoUnd2
        Piso
        direccioninterna1
      }
    }
    `,
    allMigrarDirmayor: gpl `{
      allMigrarDirmayor{
        numerocontrato
        CODDPTO
        DPTO
        CODCIUDAD
        CIUDAD
        CODZONAS
        ZONA
        CODAR
        nombrearea
      }
    }
    `,
    allMigrarTarifaCli: gpl `{
      allMigrarTarifaCli{
        numerocontrato
        descrTarifa
        nombreResumido1
        nombreResumido2
        DescServicio
        Valor
        IVA
      }
    }
    `,
    allCliTodos: gpl `{
      allCliTodos{
        _id
        estadoCliente
        contrato
        nombreCliente
        apellidoCliente
        saldoPendiente
      }
    }
    `,
    allCliBasico: gpl `
      query ($contrato: String, $estadoCliente: String, $nombreCliente: String, $apellidoCliente: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String){
          allCliBasico(contrato: $contrato, estadoCliente: $estadoCliente, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio) {
        _id
        estadoCliente
        contrato
        nombreCliente
        apellidoCliente
        saldoPendiente
        cargoMensual
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        fechaUltDX
        cicloFact
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
      }
    }
    `,
    allClientes: gpl `
      query ($_id: ID, $contrato: String, $nombreCliente: String, $apellidoCliente: String,
        $descrClaseServ: String, $descrSubclaseServ: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
        $descrRecursoR: String,
        $estadoCliente: String, $descrEstrato: String, $telefono1: String, $telefono2: String,
        $telefono3: String, $numeroDoc: String, $descrTipoCliente: String, $descrGrupoAfin: String,
        $diasMoraIni: Number, $diasMoraFin: Number, $telefono: String, $descrTipoVia1: String,
        $numeroTipoVia1: String, $descrTipoVia2: String, $numeroTipoVia2: String, $numeroTipoVia2F: String,
        $numDocum: Int, $tipoProc: String, $cicloFact: String, $campos: String){
          allClientes(_id: $_id, contrato: $contrato, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrClaseServ: $descrClaseServ,
            descrSubclaseServ: $descrSubclaseServ, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio, descrRecursoR: $descrRecursoR,
            estadoCliente: $estadoCliente,
            descrEstrato: $descrEstrato, telefono1: $telefono1, telefono2: $telefono2,
            telefono3: $telefono3, numeroDoc: $numeroDoc, descrTipoCliente: $descrTipoCliente,
            descrGrupoAfin: $descrGrupoAfin, diasMoraIni: $diasMoraIni, diasMoraFin: $diasMoraFin,
            telefono: $telefono, numDocum: $numDocum, descrTipoVia1: $descrTipoVia1,
            numeroTipoVia1: $numeroTipoVia1, descrTipoVia2: $descrTipoVia2, numeroTipoVia2: $numeroTipoVia2,
            numeroTipoVia2F: $numeroTipoVia2F, tipoProc: $tipoProc, cicloFact: $cicloFact, campos: $campos) {
        _id
        contrato
        nombreCliente
        apellidoCliente
        estadoCliente
        saldoPendiente
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        sexoCliente
        eMail
        descrEstrato
        cicloFact
        tag
        referencia1
        telefonoRef1
        referencia2
        telefonoRef2
        fechaCreacionSistema
        fechaUltOSAb
        fechaPrimeraActivacion
        fechaUltDX
        fecgaUltRX
        estadoAnterior
        fechaUltOSCe
        fechaUltPago
        valorUltPago
        cupoFinanc
        numeroOdeDX
        telefono1
        telefono2
        telefono3
        cargoMensual
        observaciones
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
          _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        tipodoc{
          _id
          codigoTipoDoc
          descrTipoDoc
        }
        numeroDoc
        tipocl{
          _id
          codigoTipoCliente
          descrTipoCliente
        }
        grupoaf{
          _id
          codigoGrupoAfin
          descrGrupoAfin
        }
      }
    }
    `,
    allClientesRtesGroup: gpl `
    query ($tipoqry: String){
      allClientesRtesGroup(tipoqry: $tipoqry) {
        descrRecurso
        rango
        cuenta
      }
    }
    `,
allClientesRtes: gpl `
      query ($contrato: String, $nombreCliente: String, $apellidoCliente: String,
        $descrClaseServ: String, $descrSubclaseServ: String,
        $descrDpto: String, $nombreCiudad: String, $nombreZona: String, $nombreBarrio: String,
        $descrRecursoR: String,
        $estadoCliente: String, $descrEstrato: String, $telefono1: String, $telefono2: String,
        $telefono3: String, $numeroDoc: String, $descrTipoCliente: String, $descrGrupoAfin: String,
        $diasMoraIni: Number, $diasMoraFin: Number, $telefono: String, $numDocum: Int, $tipoqry: String){
          allClientesRtes(contrato: $contrato, nombreCliente: $nombreCliente,
            apellidoCliente: $apellidoCliente, descrClaseServ: $descrClaseServ,
            descrSubclaseServ: $descrSubclaseServ, descrDpto: $descrDpto, nombreCiudad: $nombreCiudad,
            nombreZona: $nombreZona, nombreBarrio: $nombreBarrio, descrRecursoR: $descrRecursoR,
            estadoCliente: $estadoCliente,
            descrEstrato: $descrEstrato, telefono1: $telefono1, telefono2: $telefono2,
            telefono3: $telefono3, numeroDoc: $numeroDoc, descrTipoCliente: $descrTipoCliente,
            descrGrupoAfin: $descrGrupoAfin, diasMoraIni: $diasMoraIni, diasMoraFin: $diasMoraFin,
            telefono: $telefono, numDocum: $numDocum, tipoqry: $tipoqry) {
        _id
        contrato
        nombreCliente
        apellidoCliente
        estadoCliente
        saldoPendiente
        diasMora
        pagueHasta
        totPagoAdelSinFrar
        sexoCliente
        eMail
        descrEstrato
        cicloFact
        tag
        referencia1
        telefonoRef1
        referencia2
        telefonoRef2
        fechaCreacionSistema
        fechaUltOSAb
        fechaPrimeraActivacion
        fechaUltDX
        fecgaUltRX
        estadoAnterior
        fechaUltOSCe
        fechaUltPago
        valorUltPago
        cupoFinanc
        numeroOdeDX
        telefono1
        telefono2
        telefono3
        cargoMensual
        observaciones
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
          _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        tipodoc{
          _id
          codigoTipoDoc
          descrTipoDoc
        }
        numeroDoc
        tipocl{
          _id
          codigoTipoCliente
          descrTipoCliente
        }
        grupoaf{
          _id
          codigoGrupoAfin
          descrGrupoAfin
        }
        movimientos{
          contrato
          pagueHasta
          valorTotal
          valorPagado
          codigoServicio
        }
      }
    }
    `,
    allTarifa: gpl `
      query ($_id: ID, $codigoTarifa: String, $descrTarifa: String, $estadoTarifa: Boolean){
          allTarifa(_id: $_id, codigoTarifa: $codigoTarifa, descrTarifa: $descrTarifa, estadoTarifa: $estadoTarifa) {
        _id
        codigoTarifa
        descrTarifa
        cicloFact
        estadoTarifa
        servicios{
          codigoServicio
          nombreResumido
          descripcionServicio
          subclaseserv{
            _id
            codigoSubclaseServ
            descrSubclaseServ
            claseserv{
              _id
              codigoClaseServ
              descrClaseServ
            }
          }
          rango1NumServValorIni
          rango1NumServValorFin
          rango1Valor
          rango2NumServValorIni
          rango2NumServValorFin
          rango2Valor
          rango3NumServValorIni
          rango3NumServValorFin
          rango3Valor
          imptos{
            _id
            codigoImpto
            descrImpto
            porcImpto
          }
        }
        tipoos{
          codigoTipoOS
          descrTipoOS
          concepto1Tarifa
          valor1Tarifa
          concepto2Tarifa
          valor2Tarifa
          concepto3Tarifa
          valor3Tarifa
          imptos{
              _id
              codigoImpto
              descrImpto
              porcImpto
          }
        }
      }
    }
    `,
            allOferta: gpl `
              query ($_id: ID, $codigoOferta: String, $descrOferta: String, $estadoOferta: Boolean, $nombreResumido: String, $descripcionServicio: String, $descrClaseServ : String, $descrSubclaseServ: String){
                  allOferta(_id: $_id, codigoOferta: $codigoOferta, descrOferta: $descrOferta, estadoOferta: $estadoOferta, nombreResumido: $nombreResumido, descripcionServicio: $descripcionServicio, descrClaseServ : $descrClaseServ, descrSubclaseServ: $descrSubclaseServ) {
                      _id
                      codigoOferta
                      descrOferta
                      estadoOferta
                      servicios{
                          codigoServicio
                          nombreResumido
                          descripcionServicio
                          porcDctoOferta
                          numDiasOferta
                          subclaseserv{
                              _id
                              codigoSubclaseServ
                              descrSubclaseServ
                              claseserv{
                                  _id
                                  codigoClaseServ
                                  descrClaseServ
                              }
                          }
                      }
                  }
              }
          `,
          allDirmayor: gpl `
            query ($_id: ID, $codigoDpto: String, $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String, $codigoZona: String, $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String){
                allDirmayor(_id: $_id, codigoDpto: $codigoDpto, descrDpto: $descrDpto, codigoCiudad: $codigoCiudad, nombreCiudad: $nombreCiudad, codigoZona: $codigoZona, nombreZona: $nombreZona, codigoBarrio: $codigoBarrio, nombreBarrio: $nombreBarrio) {
                _id
                codigoDpto
                descrDpto
                ciudades{
                  codigoCiudad
                  nombreCiudad
                  zonas{
                    codigoZona
                    nombreZona
                    barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                    }
                  }
                }
            }
        }
        `,
        allServicios: gpl `
            query ($codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $paraProcMasDX: String){
                allServicios(codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, paraProcMasDX: $paraProcMasDX) {
                _id
                codigoServicio
                nombreResumido
                descripcionServicio
                conceptoEnFra
                consecEnFra
                paraProcMasDX
                subclaseserv{
                    _id
                    codigoSubclaseServ
                    descrSubclaseServ
                    claseserv{
                        _id
                        codigoClaseServ
                        descrClaseServ
                    }
                }
                paraProcMasDX
            }
        }
        `,
        allDetalleDX: gpl `
            query ($estadoDetDX: String, $numeroOdeDX: Number, $contrato: String, $descripcionServicio: String,
                $descrClaseServ: String){
            allDetalleDX(estadoDetDX: $estadoDetDX, numeroOdeDX: $numeroOdeDX, contrato: $contrato,
                descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ) {
                _id
                numeroOdeDX
                contrato
                codigoTarifa
                codigoServicio
                descripcionServicio
                descrClaseServ
                idMovim
                codigoServicioM
                descripcionServicioM
                descrClaseServM
                documento
                valorTotal
                valorPagado
                pagueHasta
                diasMora
                estadoDetDX
                fechaRX
            }
          }
          `,
        allMovClientes: gpl `
            query ($contrato: String, $numeroOdeDX: Number, $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $agno: String, $mes: String, $orden: String){
                allMovClientes(contrato: $contrato, numeroOdeDX: $numeroOdeDX, codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ,
                    agno: $agno, mes: $mes, orden: $orden) {
                _id
                contrato
                fechaMov
                tipo
                subTipo
                procesado
                pagueHasta
                numeroOdeDX
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                origen
                saldoCliente
                valorTotal
                valorAntesImptos
                imptos{
                  codigoImpto
                  descrImpto
                  porcImpto
                  valorImpto
                }
                agno
                mes
                numeroFra
                numeroCE
                numeroRC
                documento
                valorPagado
                fechaUltPago
                valorUltPago
            }
          }
          `,
          allMovTodos: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number,
              $valorPendiente: Number, $tipoProc: String){
            allMovTodos(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX,
              valorPendiente: $valorPendiente, tipoProc: $tipoProc) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              valorPendiente
              fechaUltPago
              valorUltPago
            }
          }
          `,
          allMovRtes: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number,
              $valorTotal: Number, $valorPagado: Number, $valorPendiente: Number,
              $tipoqry: String, $tipoProc: String){
              allMovRtes(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta,
                numeroOdeDX: $numeroOdeDX, valorTotal: $valorTotal, valorPagado: $valorPagado,
                valorPendiente: $valorPendiente, tipoqry: $tipoqry, tipoProc: $tipoProc) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              valorPendiente
              fechaUltPago
              valorUltPago
              cliente{
                contrato
                saldoPendiente
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }      
              }    
            }
          }
          `,
        allMovClientesCC: gpl `
            query ($contrato: String, $numeroOdeDX: Number, $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $agno: String, $mes: String, $orden: String){
                allMovClientesCC(contrato: $contrato, numeroOdeDX: $numeroOdeDX, codigoServicio: $codigoServicio, nombreResumido: $nombreResumido,
                    descripcionServicio: $descripcionServicio, descrClaseServ: $descrClaseServ,
                    agno: $agno, mes: $mes, orden: $orden) {
                _id
                contrato
                fechaMov
                tipo
                subTipo
                procesado
                pagueHasta
                numeroOdeDX
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                origen
                saldoCliente
                valorTotal
                valorAntesImptos
                imptos{
                  codigoImpto
                  descrImpto
                  porcImpto
                  valorImpto
                }
                agno
                mes
                numeroFra
                numeroCE
                numeroRC
                documento
                valorPagado
                fechaUltPago
                valorUltPago
            }
          }
          `,
          allMovTodosCC: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number){
            allMovTodosCC(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              fechaUltPago
              valorUltPago
            }
          }
          `,
          allMovRtesCC: gpl `
            query ($procesado: String, $tipo: String, $pagueHasta: Date, $numeroOdeDX: Number, $tipoqry: String){
              allMovRtesCC(procesado: $procesado, tipo: $tipo, pagueHasta: $pagueHasta, numeroOdeDX: $numeroOdeDX, tipoqry: $tipoqry) {
              _id
              contrato
              fechaMov
              tipo
              subTipo
              procesado
              pagueHasta
              numeroOdeDX
              codigoServicio
              nombreResumido
              descripcionServicio
              descrClaseServ
              concepto
              periodo
              origen
              saldoCliente
              valorTotal
              valorAntesImptos
              imptos{
                codigoImpto
                descrImpto
                porcImpto
                valorImpto
              }
              agno
              mes
              numeroFra
              numeroCE
              numeroRC
              documento
              valorPagado
              fechaUltPago
              valorUltPago
              cliente{
                contrato
                saldoPendiente
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }      
              }    
            }
          }
          `,
          allPagoClientes: gpl `
          query ($_id: ID, $contrato: String, $fechaPago: Date, $tipo: String){
            allPagoClientes(_id: $_id, contrato: $contrato, fechaPago: $fechaPago, tipo: $tipo) {
              _id
              contrato
              saldoPendiente
              fechaPago
              tipo
              descripcionPago
              numeroFra
              numeroRC
              documento
              numeroRT
              numeroDocum
              descrRecurso
              valorTotal
              valorEf
              valorCh
              numeroCh
              bancoCh
              fechaVencCh
              valorTr
              bancoTr
              fechaTr
              valorTD
              bancoTD
              valorTC
              bancoTC
              fechaCreate
              usuarioCreate
              detalle{
                idMovClientes
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                valorTotal
                valorDetalle
              }
            }
          }
          `,
          allTempRdo: gpl `
          query ($fechaPago: Date, $tipoqry: String){
            allTempRdo(fechaPago: $fechaPago, tipoqry: $tipoqry) {
              totPagos
              fechaPago
              valorTotal
            }
          }
          `,
          allPagoRtesGroup: gpl `
          query ($fechaPago: Date, $documento: String, $tipoqry: String){
            allPagoRtesGroup(fechaPago: $fechaPago, documento: $documento, tipoqry: $tipoqry) {
              documento
              recaudoEn
              descrClaseServ
              totPagos
              fechaPago
              valorTotal
              descrRecurso
            }
          }
          `,
          allPagoRtes: gpl `
          query ($contrato: String, $fechaPago: Date, $documento: String, $tipo: String, $tipoqry: String){
            allPagoRtes(contrato: $contrato, fechaPago: $fechaPago, documento: $documento, tipo: $tipo, tipoqry: $tipoqry) {
              _id
              contrato
              saldoPendiente
              fechaPago
              tipo
              descripcionPago
              numeroFra
              numeroRC
              documento
              numeroRT
              numeroDocum
              descrRecurso
              valorTotal
              valorEf
              valorCh
              numeroCh
              bancoCh
              fechaVencCh
              valorTr
              bancoTr
              fechaTr
              valorTD
              bancoTD
              valorTC
              bancoTC
              fechaCreate
              usuarioCreate
              detalle{
                idMovClientes
                codigoServicio
                nombreResumido
                descripcionServicio
                descrClaseServ
                concepto
                periodo
                valorTotal
                valorDetalle
              }
              razonap
              cliente{
                contrato
                nombreCliente
                apellidoCliente
                dirmayor{
                  codigoDpto
                  descrDpto
                  ciudades{
                    codigoCiudad
                    nombreCiudad
                    zonas{
                      codigoZona
                      nombreZona
                      barrios{
                        codigoBarrio
                        nombreBarrio
                        codigoTipoDocT
                        numeroDocumT
                        descrRecursoT
                        codigoTipoDocR
                        numeroDocumR
                        descrRecursoR
                      }
                    }
                  }
                }
                tarifa{
                    codigoTarifa
                    descrTarifa
                    servicios{
                        codigoServicio
                        nombreResumido
                        descripcionServicio
                        subclaseserv{
                            codigoSubclaseServ
                            descrSubclaseServ
                            claseserv{
                                codigoClaseServ
                                descrClaseServ
                            }
                        }
                        estadoServicio
                    }
                }    
              }    
            }
          }
          `,
          getPagoCliente: gpl `
            query ($_id: ID, $contrato: String, $orden: String){
              getPagoCliente(_id: $_id, contrato: $contrato, orden: $orden) {
                _id
                contrato
                saldoPendiente
                fechaPago
                tipo
                descripcionPago
                numeroFra
                numeroRC
                documento
                numeroRT
                numeroDocum
                descrRecurso
                valorTotal
                valorEf
                valorCh
                numeroCh
                bancoCh
                fechaVencCh
                valorTr
                bancoTr
                fechaTr
                valorTD
                bancoTD
                valorTC
                bancoTC
                fechaCreate
                usuarioCreate
                detalle{
                  idMovClientes
                  codigoServicio
                  nombreResumido
                  descripcionServicio
                  descrClaseServ
                  concepto
                  periodo
                  valorTotal
                  valorDetalle
                }
                razonap
            }
          }
          `,
        allFacturacion: gpl `
          query ($codProcFact: String, $tipoGen: String, $numeroFra: String, $fechaFact: Date, $fechaMov: Date,
            $contrato: String, $agno: String, $mes: String, $orden: String){
                allFacturacion(codProcFact: $codProcFact, tipoGen: $tipoGen, numeroFra: $numeroFra, fechaFact: $fechaFact,
                    fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes, orden: $orden) {
          _id
          codProcFact
          tipoGen
          idRangoFact
          numeroFra
          fechaFact
          contrato
          pagueHasta
          direccion
          descrDpto
          nombreCiudad
          nombreZona
          nombreBarrio
          nombreCliente
          apellidoCliente
          saldoPendiente
          fechaMov
          valorAntesImptos
          valorFacturado
          valorFactura
          agno
          mes
          numeroDocum
          descrRecurso
          detalleFact{
            _idMC
            codigoServicio
            nombreResumido
            descripcionServicio
            descrClaseServ
            concepto
            periodo
            tipo
            consecEnFra
            porcImpto
            valor
          }
      }
    }
    `,
    allFactRtes: gpl `
      query ($codProcFact: String, $tipoGen: String, $numeroFra: String, $fechaFact: Date,
        $fechaMov: Date, $contrato: String, $agno: String, $mes: String, $orden: String, $tipoqry: String){
          allFactRtes(codProcFact: $codProcFact, tipoGen: $tipoGen, numeroFra: $numeroFra,
            fechaFact: $fechaFact, fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes,
            orden: $orden, tipoqry: $tipoqry) {
      _id
      codProcFact
      tipoGen
      idRangoFact
      numeroFra
      fechaFact
      contrato
      direccion
      descrDpto
      nombreCiudad
      nombreZona
      nombreBarrio
      nombreCliente
      apellidoCliente
      saldoPendiente
      fechaMov
      valorAntesImptos
      valorFacturado
      valorFactura
      agno
      mes
      numeroDocum
      descrRecurso
      detalleFact{
        _idMC
        codigoServicio
        nombreResumido
        descripcionServicio
        descrClaseServ
        concepto
        periodo
        tipo
        consecEnFra
        porcImpto
        valor
      }
      cliente{
        contrato
        nombreCliente
        apellidoCliente
        saldoPendiente
        cargoMensual
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
      }
    }
  }
  `,
  allFactRtesGroup: gpl `
    query ($fechaFact: Date, $tipoGen: String, $codProcFact: String, $tipoqry: String){
      allFactRtesGroup(fechaFact: $fechaFact, tipoGen: $tipoGen, codProcFact: $codProcFact, tipoqry: $tipoqry) {
        tipoGen
        codProcFact
        fechaFact
        descrClaseServ
        descripcionServicio
        totServ
        valorSF
        valorIF
        totFras
        descrRecurso
        valorFactura
        valorFacturado
      }
    }
  `,
    allCargoEsp: gpl `
      query ($codProcCE: String, $tipoGen: String, $numeroCE: String, $fechaCE: Date, $fechaMov: Date,
        $contrato: String, $agno: String, $mes: String, $orden: String){
          allCargoEsp(codProcCE: $codProcCE, tipoGen: $tipoGen, numeroCE: $numeroCE, fechaCE: $fechaCE,
            fechaMov: $fechaMov, contrato: $contrato, agno: $agno, mes: $mes, orden: $orden) {
        _id
        codProcCE
        tipoGen
        numeroCE
        fechaCE
        contrato
        fechaMov
        valorAntesImptos
        valorCargado
        valorCargo
        agno
        mes
        nombreBarrio
        numeroDocum
        descrRecurso
        detalleCE{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnCE
          porcImpto
          valor
        }
      }
    }
    `,
    allNotasDebCre: gpl `
      query ($tipoNota: String, $numeroFra: String, $fechaNota: Date, $contrato: String,
        $numeroNota: String, $orden: String){
            allNotasDebCre(tipoNota: $tipoNota, numeroFra: $numeroFra, fechaNota: $fechaNota,
              contrato: $contrato, numeroNota: $numeroNota, orden: $orden) {
        _id
        tipoNota
        numeroNota
        numeroFra
        fechaNota
        contrato
        valorAntesImptos
        valorNota
        usuarioCreate
        detalleNota{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnFra
          porcImpto
          valor
        }
      }
    }
    `,
    allNotasDCRtes: gpl `
      query ($tipoNota: String, $idRangoFact: String, $numeroFra: String, $fechaNota: Date, $contrato: String,
        $numeroNota: String, $orden: String, $tipoqry: String){
            allNotasDCRtes(tipoNota: $tipoNota, idRangoFact: $idRangoFact, numeroFra: $numeroFra, fechaNota: $fechaNota,
              contrato: $contrato, numeroNota: $numeroNota, orden: $orden, tipoqry: $tipoqry) {
        _id
        tipoNota
        numeroNota
        numeroFra
        fechaNota
        contrato
        valorAntesImptos
        valorNota
        detalleNota{
          _idMC
          codigoServicio
          nombreResumido
          descripcionServicio
          descrClaseServ
          concepto
          periodo
          tipo
          consecEnFra
          porcImpto
          valor
        }
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
        }
      }
    }
    `,
    allAjuste: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String){
          allAjuste(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
        usuarioCreate
      }
    }
    `,
    allAjusteTodo: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String){
          allAjusteTodo(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
      }
    }
    `,
    allAjusteRtes: gpl `
      query ($tipoAjuste: String, $fechaAjuste: Date, $contrato: String,
        $numeroAjuste: String, $orden: String, $tipoqry: String){
          allAjusteRtes(tipoAjuste: $tipoAjuste, fechaAjuste: $fechaAjuste,
              contrato: $contrato, numeroAjuste: $numeroAjuste, orden: $orden, tipoqry: $tipoqry) {
        _id
        tipoAjuste
        numeroAjuste
        fechaAjuste
        contrato
        concepto
        valorAjuste
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
        }
      }
    }
    `,
    allHistProyecto: gpl `
        query ($contrato: String, $orden: String){
            allHistProyecto(contrato: $contrato, orden: $orden) {
              _id
              fechaHistProyecto
              contrato
              movimiento
              descripcion
              detalle
              relacion
              valor
              usuarioCreate
              }
      }
      `,
    allHistProyectoRtes: gpl `
      query ($fechaHistProyecto: Date, $contrato: String, $movimiento: String, $relacion: String,
              $orden: String, $tipoqry: String){
          allHistProyectoRtes(fechaHistProyecto: $fechaHistProyecto, contrato: $contrato,
              movimiento: $movimiento, relacion: $relacion, orden: $orden, tipoqry: $tipoqry) {
        _id
        fechaHistProyecto
        contrato
        movimiento
        descripcion
        detalle
        relacion
        valor
        usuarioCreate
        cliente{
          contrato
          nombreCliente
          apellidoCliente
        }
      }
    }
    `,
    allOdeS: gpl `
      query ($_id: ID, $numeroOS: Number, $contrato: String, $estadoOS: String,
        $numeroDocum: String, $descrRecurso: String, $fechaCreate: Date, $fechaEjec: Date){
          allOdeS(_id: $_id, numeroOS: $numeroOS, contrato: $contrato, estadoOS: $estadoOS,
            numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, fechaCreate: $fechaCreate, fechaEjec: $fechaEjec) {
        _id
        numeroOS
        contrato
        tipoos{
          _id
          codigoTipoOS
          descrTipoOS
        }
        estadoOS
        impresa
        observacAB
        observacCE
        observacCA
        codigoTipoDocV
        numeroDocumV
        descrRecursoV
        tag
        horaSolic
        nombreSolic
        fechaImpr
        usuarioImpr
        fechaClose
        usuarioClose
        fechaCanc
        usuarioCanc    
        fechaEjec
        fechaFra
        fechaCreate
        usuarioCreate
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          cicloFact
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        cargoFra{
          descrClaseServ
          codigoServicio
          nombreResumido
          descripcionServicio
          fechaCargo
          conceptoEnFra
          periodoFrado
          origen
          numeroServicios
          valorTotal
          valorAntesImptos
          imptos{
            codigoImpto
            descrImpto
            porcImpto
            valorImpto
          }
          agnoFra
          mesFra
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          accion
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        recursos{
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
        }
      }
    }
    `,
    allOdeSRtes: gpl `
      query ($numeroOS: Number, $contrato: String, $estadoOS: String, $numeroDocum: String,
        $descrRecurso: String, $fechaCreate: Date, $fechaEjec: Date, $tipoqry: String){
          allOdeSRtes(numeroOS: $numeroOS, contrato: $contrato, estadoOS: $estadoOS,
            numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, fechaCreate: $fechaCreate,
            fechaEjec: $fechaEjec, tipoqry: $tipoqry) {
        _id
        numeroOS
        contrato
        tipoos{
          _id
          codigoTipoOS
          descrTipoOS
        }
        estadoOS
        impresa
        observacAB
        observacCE
        observacCA
        codigoTipoDocV
        numeroDocumV
        descrRecursoV
        tag
        horaSolic
        nombreSolic
        fechaImpr
        usuarioImpr
        fechaClose
        usuarioClose
        fechaCanc
        usuarioCanc    
        fechaEjec
        fechaFra
        fechaCreate
        dirmayor{
          codigoDpto
          descrDpto
          ciudades{
            codigoCiudad
            nombreCiudad
            zonas{
              codigoZona
              nombreZona
              barrios{
                codigoBarrio
                nombreBarrio
                codigoTipoDocT
                numeroDocumT
                descrRecursoT
                codigoTipoDocR
                numeroDocumR
                descrRecursoR
              }
            }
          }
        }
        direccion{
          descrTipoVia1
          numeroTipoVia1
          descrTipoVia2
          numeroTipoVia2
          numeroTipoVia2F
          descrTipoUnd1
          numeroTipoUnd1
          descrTipoUnd2
          numeroTipoUnd2
          descrTiUndMat
          descrUndMat
        }
        tarifa{
          codigoTarifa
          descrTarifa
          cicloFact
          fechaVence
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
            estadoServicio
            rango1NumServValorIni
            rango1NumServValorFin
            rango1Valor
            rango2NumServValorIni
            rango2NumServValorFin
            rango2Valor
            rango3NumServValorIni
            rango3NumServValorFin
            rango3Valor
            numeroServicios
            valorServicios
            valorAntesImptos
            imptos{
              codigoImpto
              descrImpto
              porcImpto
              valorImpto
            }
          }
        }
        cargoFra{
          descrClaseServ
          codigoServicio
          nombreResumido
          descripcionServicio
          fechaCargo
          conceptoEnFra
          periodoFrado
          origen
          numeroServicios
          valorTotal
          valorAntesImptos
          imptos{
            codigoImpto
            descrImpto
            porcImpto
            valorImpto
          }
          agnoFra
          mesFra
        }
        oferta{
          codigoOferta
          descrOferta
          servicios{
            codigoServicio
            nombreResumido
            descripcionServicio
            porcDctoOferta
            numDiasOferta
            fechaFinOferta
            subclaseserv{
              _id
              codigoSubclaseServ
              descrSubclaseServ
              claseserv{
                _id
                codigoClaseServ
                descrClaseServ
              }
            }
          }
          fechaInicioOferta
        }
        equipos{
          numeroSerie
          mac
          accion
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
        }
        recursos{
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
        }
        cliente{
          contrato
          nombreCliente
          apellidoCliente
          saldoPendiente
          cargoMensual
          cicloFact
          direccion{
            descrTipoVia1
            numeroTipoVia1
            descrTipoVia2
            numeroTipoVia2
            numeroTipoVia2F
            descrTipoUnd1
            numeroTipoUnd1
            descrTipoUnd2
            numeroTipoUnd2
            descrTiUndMat
            descrUndMat
          }
          dirmayor{
            codigoDpto
            descrDpto
            ciudades{
              codigoCiudad
              nombreCiudad
              zonas{
                codigoZona
                nombreZona
                barrios{
                  codigoBarrio
                  nombreBarrio
                  codigoTipoDocT
                  numeroDocumT
                  descrRecursoT
                  codigoTipoDocR
                  numeroDocumR
                  descrRecursoR
                }
              }
            }
          }
        }
      }
    }
    `,
    allTipoRec: gpl `{
      allTipoRec{
        _id
        descrTipoRec
        areaAprovech
      }
    }
    `,
    allRecurso: gpl `
      query ($_id: ID, $codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String){
        allRecurso(_id: $_id, codigoTipoDoc: $codigoTipoDoc, numeroDocum: $numeroDocum, descrRecurso: $descrRecurso) {
          _id
          codigoTipoDoc
          numeroDocum
          descrRecurso
          tiporec{
            _id
            descrTipoRec
            areaAprovech
          }
          dirArchIn
        }
      }
      `,
      allRdoTerc: gpl `
        query ($_id: ID, $numeroDocum: String, $descrRecurso: String, $archivo: String, $procesado: String){
          allRdoTerc(_id: $_id, numeroDocum: $numeroDocum, descrRecurso: $descrRecurso, archivo: $archivo, procesado: $procesado) {
            _id
            numeroDocum
            descrRecurso
            archivo
            contrato
            nombreCliente
            apellidoCliente
            valorTotal
            fechaPago
            procesado
            fechaCreate
          }
        }
      `,
      allEquipo: gpl `
      query ($_id: ID, $numeroSerie: String, $mac: String, $estadoEquipo: String){
        allEquipo(_id: $_id, numeroSerie: $numeroSerie, mac: $mac, estadoEquipo: $estadoEquipo) {
          _id
          numeroSerie
          mac
          estadoEquipo
          claseequ{
            _id
            codigoClaseEqu
            descrClaseEqu
          }
          marcaequ{
            _id
            codigoMarcaEqu
            descrMarcaEqu
          }
          fabriequ{
            _id
            codigoFabriEqu
            descrFabriEqu
          }
          bodega{
            _id
            codigoBodega
            descrBodega
          }
          contrato
        }
      }
    `,
        allRangoFact: gpl `
          query ($_id: ID, $factInicial: Number, $factFinal: Number){
            allRangoFact(_id: $_id, factInicial: $factInicial, factFinal: $factFinal) {
              _id
              factInicial
              factFinal
              fecha
              numResolucion
              observaciones
              proxFact
              estadoRangoFact
          }
        }
        `,
        allProcDX: gpl `
          query ($numeroOdeDX: Number, $estadoProcDX: String){
            allProcDX(numeroOdeDX: $numeroOdeDX, estadoProcDX: $estadoProcDX) {
                _id
                numeroOdeDX
                codProcDX
                estadoProcDX
                totCliDX
                totServDX
                fechaRef
                diasMora
                porcMovim
                valorMovim
                servaDX
                descrDpto
                nombreCiudad
                nombreZona
                nombreBarrio
                descrClaseServ
            }
        }
        `,
        allProcFact: gpl `
          query ($_id: ID, $fechaFact: Date, $fechaCreate: Date){
            allProcFact(_id: $_id, fechaFact: $fechaFact, fechaCreate: $fechaCreate) {
              _id
              codProcFact
              mes
              fechaFact
              factInicial
              factFinal
              pagueHasta
              idRangoFact
              descrDpto
              nombreCiudad
              descrClaseServ
              cicloFact
              observaciones
              imagenLado
              imagenInf
              fechaCreate
          }
        }
        `,
        allProcCE: gpl `
          query ($_id: ID, $fechaCE: Date, $fechaCreate: Date){
            allProcCE(_id: $_id, fechaCE: $fechaCE, fechaCreate: $fechaCreate) {
              _id
              codProcCE
              mes
              fechaCE
              pagueHasta
              prefijoCE
              proxCE
              descrDpto
              nombreCiudad
              descrClaseServ
              cicloFact
              observaciones
              fechaCreate
          }
        }
        `,
        allTiUndMat: gpl `{
            allTiUndMat{
                _id
                codigoTiUndMat
                descrTiUndMat
            }
        }
        `,
        allClaseEqu: gpl `{
            allClaseEqu{
                _id
                codigoClaseEqu
                descrClaseEqu
            }
        }
        `,
        allMarcaEqu: gpl `{
            allMarcaEqu{
                _id
                codigoMarcaEqu
                descrMarcaEqu
            }
        }
        `,
        allFabriEqu: gpl `{
            allFabriEqu{
                _id
                codigoFabriEqu
                descrFabriEqu
            }
        }
        `,
        allBodega: gpl `{
            allBodega{
                _id
                codigoBodega
                descrBodega
            }
        }
        `,
        allUndMat: gpl `
            query ($_id: ID, $descrUndMat: String){
                allUndMat(_id: $_id, descrUndMat: $descrUndMat) {
                _id
                descrUndMat
                tiundmat{
                  _id
                  codigoTiUndMat
                  descrTiUndMat
                }
            }
        }
        `,
        allTipoUnd: gpl `{
            allTipoUnd{
                _id
                descrTipoUnd
            }
        }
        `,
        allTipoVia: gpl `{
            allTipoVia{
                _id
                descrTipoVia
            }
        }
        `,
        allEstrato: gpl `{
            allEstrato{
                _id
                descrEstrato
            }
        }
        `,
        allCicloFact: gpl `{
            allCicloFact{
                _id
                cicloFact
                noFactRET
            }
        }
        `,
        allClasesServ: gpl `{
          allClasesServ{
            _id
            codigoClaseServ
            descrClaseServ
          }
        }
        `,
        allTipoAju: gpl `{
          allTipoAju{
            _id
            descrTipoAju
          }
        }
        `,
        allBaseDat: gpl `{
          allBaseDat{
            _id
            descrBaseDat
          }
        }
        `,
        allTiposCliente: gpl `{
            allTiposCliente{
                _id
                codigoTipoCliente
                descrTipoCliente
            }
        }
        `,
        allGruposAfin: gpl `{
            allGruposAfin{
                _id
                codigoGrupoAfin
                descrGrupoAfin
            }
        }
        `,
        allTiposDoc: gpl `{
            allTiposDoc{
                _id
                codigoTipoDoc
                descrTipoDoc
            }
        }
        `,
        allImpto: gpl `{
            allImpto{
                _id
                codigoImpto
                descrImpto
                porcImpto
            }
        }
        `,
        allOtrosPagCl: gpl `{
            allOtrosPagCl{
                _id
                descrOtrosPagCl
                codigoImpto
                descrImpto
                porcImpto
                descrClaseServ
            }
        }
        `,
        allTiposOS: gpl `{
            allTiposOS{
                _id
                codigoTipoOS
                descrTipoOS
                permDireccion
                permTarServ
                permOfertas
                permEquipos
                paraCliNuevo
                estadoCrearOS
                estadoCerrarOS
            }
        }
        `,
        allSubclasesServ: gpl `
            query ($codigoSubclaseServ: String, $descrSubclaseServ: String){
                allSubclasesServ(codigoSubclaseServ: $codigoSubclaseServ, descrSubclaseServ: $descrSubclaseServ) {
                _id
                codigoSubclaseServ
                descrSubclaseServ
                claseserv{
                  _id
                  codigoClaseServ
                  descrClaseServ
                }
            }
        }
        `,
    },

  mutation:{
    login: gpl`
      mutation($email: String!, $claveDeAcceso: String!){
        login(email: $email, claveDeAcceso: $claveDeAcceso) {
        success
        token
        errors{
          path
          message
        }
        ok
      }
    }
    `,
    singleUpload: gpl`
      mutation($file: Upload){
        singleUpload(file: $file) {
          id
          path
          filename
          mimetype
          encoding
      }
    }
    `,
    fecha: gpl`
      mutation($tipo: String){
        fecha(tipo: $tipo) {
          fechaFechaHoy
          fechaHoraHoy
      }
    }
    `,
    encriptar: gpl`
      mutation($valor: String, $comparar: String){
        encriptar(valor: $valor, comparar: $comparar) {
        success
        encriptado
      }
    }
    `,
    createSequence: gpl`
      mutation($coleccion: String, $seq: Number){
        createSequence(
          sequence:{
            coleccion: $coleccion,
            seq: $seq
          }
        ){
          success
          _id
          errors{
            path
            message
          }                
      }
    }
    `,
    createUsuario: gpl`
      mutation($email: String!, $nombreUsuario: String!, $claveDeAcceso: String!, $_id: ID!,
          $descrPerfil: String, $descrEmpresa: String, $versionMacro: Number,
          $cedula: String,
          $ciudad: String,
          $cargo: String, $esLider: String, $suLider: String,
          $telefono: String, $tipo: String, $estado: String,
          $gestionaHallazgos: String, $archivoFirma: String){
        createUsuario(
        usuario:{
          email:$email,
          nombreUsuario:$nombreUsuario,
          claveDeAcceso:$claveDeAcceso,
          perfil:{
            _id: $_id,
            descrPerfil: $descrPerfil
          }
          descrEmpresa: $descrEmpresa,
          versionMacro: $versionMacro,
          cedula: $cedula,
          ciudad: $ciudad,
          cargo: $cargo,
          telefono: $telefono,
          tipo: $tipo,
          estado: $estado,
          esLider: $esLider,
          suLider: $suLider,
          gestionaHallazgos: $gestionaHallazgos,
          archivoFirma: $archivoFirma
        }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
    `,
    createAutorizac: gpl`
      mutation($codigoAutorizac: String!, $descrAutorizac: String!){
        createAutorizac(
          autorizac:{
            codigoAutorizac: $codigoAutorizac,
            descrAutorizac: $descrAutorizac
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
      }
    `,
    createPerfil: gpl`
      mutation($descrPerfil: String){
        createPerfil(
          perfil:{
            descrPerfil:$descrPerfil,
          }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
      `,
    createParametro: gpl`
      mutation($mensaje: String, 
        $empresaRazonSocial: String,
        $empresaNit: String,
        $empresaWeb: String,
        $empresaDir1: String,
        $empresaTel1: String,
        $empresaCel1: String,
        $empresaCiudad1: String,
        $empresaDir2: String,
        $empresaTel2: String,
        $empresaCel2: String,
        $empresaCiudad2: String,
        $empresaBanco1: String,
        $empresaCuenta1: String,
        $empresaBanco2: String,
        $empresaCuenta2: String,
        $empresaPresentacion: String,
        $empresaNombreFirma: String,
        $empresaCargoFirma: String,
        $empresaMailFirma: String, 
        $empresaCelFirma: String,
        $rutaLogo: String,
        $generandoProg: String,
        $trm: String,
        $mailFactura: String,
        $medidaQR: Number,
        $minimoDolar: Number,
        $maximoDolar: Number,
        $mailFacturaPanama: String,
        $parametroMail1: String,
        $parametroMail2: String,
        $parametroMail3: String,
        $nodemailerUser: String,
        $nodemailerPass: String,
        $rango1Desde: Number,
        $rango1Hasta: Number,
        $rango2Hasta: Number,
        $rango3Hasta: Number){
        createParametro(
          parametro:{
            mensaje: $mensaje,
            empresaRazonSocial: $empresaRazonSocial,
            empresaNit: $empresaNit,
            empresaWeb: $empresaWeb,
            empresaDir1: $empresaDir1,
            empresaTel1: $empresaTel1,
            empresaCel1: $empresaCel1,
            empresaCiudad1: $empresaCiudad1,
            empresaDir2: $empresaDir2,
            empresaTel2: $empresaTel2,
            empresaCel2: $empresaCel2,
            empresaCiudad2: $empresaCiudad2,
            empresaBanco1: $empresaBanco1,
            empresaCuenta1: $empresaCuenta1,
            empresaBanco2: $empresaBanco2,
            empresaCuenta2: $empresaCuenta2,
            empresaPresentacion: $empresaPresentacion,
            empresaNombreFirma: $empresaNombreFirma,
            empresaCargoFirma: $empresaCargoFirma,
            empresaMailFirma: $empresaMailFirma,
            empresaCelFirma: $empresaCelFirma,
            rutaLogo: $rutaLogo,
            generandoProg: $generandoProg,
            trm: $trm,
            mailFactura: $mailFactura,
            mailFacturaPanama: $mailFacturaPanama,
            medidaQR: $medidaQR,
            minimoDolar: $minimoDolar,
            maximoDolar: $maximoDolar,
            parametroMail1: $parametroMail1,
            parametroMail2: $parametroMail2,
            parametroMail3: $parametroMail3,
            nodemailerUser: $nodemailerUser,
            nodemailerPass: $nodemailerPass,
            rango1Desde: $rango1Desde,
            rango1Hasta: $rango1Hasta,
            rango2Hasta: $rango2Hasta,
            rango3Hasta: $rango3Hasta
          }
        ){
          success
          errors{
            path
            message
          }                
        }
      }
      `,
      createRotulo: gpl`
        mutation(
          $descrRotulo: String,
          $descrFrecuencia: String,
          $claseLub: String,
          $colorAplicacion: String,
          $categoriaLub: String, 
          $colorGrado: String,
          $tipoGrado: String,
          $isoGrasaColor: String,
          $isoGrasaTexto: String,
          $colorTexto: String,
          $apiSAE: String,
          $archRotulo: String,
          $fechaCreate: Date){
          createRotulo(
            rotulo:{
              descrRotulo: $descrRotulo,
              descrFrecuencia: $descrFrecuencia,
              claseLub: $claseLub,
              colorAplicacion: $colorAplicacion,
              categoriaLub: $categoriaLub, 
              colorGrado: $colorGrado,
              tipoGrado: $tipoGrado,
              isoGrasaColor: $isoGrasaColor,
              isoGrasaTexto: $isoGrasaTexto,
              colorTexto: $colorTexto,
              apiSAE: $apiSAE,
              archRotulo: $archRotulo,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editRotulo: gpl`
        mutation($_id: ID, 
          $descrRotulo: String,
          $descrFrecuencia: String,
          $claseLub: String,
          $colorAplicacion: String,
          $categoriaLub: String, 
          $colorGrado: String,
          $tipoGrado: String,
          $isoGrasaColor: String,
          $isoGrasaTexto: String,
          $colorTexto: String,
          $apiSAE: String,
          $archRotulo: String,
          ){
          editRotulo(
            rotulo:{
              _id: $_id,
              descrRotulo: $descrRotulo,
              descrFrecuencia: $descrFrecuencia,
              claseLub: $claseLub,
              colorAplicacion: $colorAplicacion,
              categoriaLub: $categoriaLub, 
              colorGrado: $colorGrado,
              tipoGrado: $tipoGrado,
              isoGrasaColor: $isoGrasaColor,
              isoGrasaTexto: $isoGrasaTexto,
              colorTexto: $colorTexto,
              apiSAE: $apiSAE,
              archRotulo: $archRotulo,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
    deleteRotulo: gpl`
      mutation($_id: ID!){
        deleteRotulo(
            _id: $_id
        ){
        success
        errors{
            path
            message
            }                
        }
      }
    `,
    createTurno: gpl`
        mutation(
          $cedula: String,
          $nombreUsuario: String,
          $email: String,
          $fechaHoraIniTurno: Date,
          $latitudIni: Number, 
          $longitudIni: Number,
          $ubicacionIni: String,
          $estado: String,
          $observacionesIni: String,
          $fechaCreate: Date,
          $imgInicio: String,
          $brandIni: String,
          $modelNameIni: String,
          $modelIdIni: String,
          $deviceYearClassIni: String,
          $osBuildIdIni: String,
          $osVersionIni: String,
          $brandFin: String,
          $modelNameFin: String,
          $modelIdFin: String,
          $deviceYearClassFin: String,
          $osBuildIdFin: String,
          $osVersionFin: String){
          createTurno(
            turno:{
              cedula: $cedula,
              nombreUsuario: $nombreUsuario,
              email: $email,
              fechaHoraIniTurno: $fechaHoraIniTurno,
              latitudIni: $latitudIni, 
              longitudIni: $longitudIni,
              ubicacionIni: $ubicacionIni,
              estado: $estado,
              observacionesIni: $observacionesIni,
              fechaCreate: $fechaCreate,
              imgInicio: $imgInicio,
              brandIni: $brandIni,
              modelNameIni: $modelNameIni,
              modelIdIni: $modelIdIni,
              deviceYearClassIni: $deviceYearClassIni,
              osBuildIdIni: $osBuildIdIni,
              osVersionIni: $osVersionIni,
              brandFin: $brandFin,
              modelNameFin: $modelNameFin,
              modelIdFin: $modelIdFin,
              deviceYearClassFin: $deviceYearClassFin,
              osBuildIdFin: $osBuildIdFin,
              osVersionFin: $osVersionFin,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editTurno: gpl`
        mutation($_id: ID, 
          $fechaHoraFinTurno: Date,
          $latitudFin: Number, 
          $longitudFin: Number,
          $ubicacionFin: String,
          $minutosTotalTurno: Number,
          $estado: String,
          $observacionesFin: String,
          $imgFin: String,
          $brandIni: String,
          $modelNameIni: String,
          $modelIdIni: String,
          $deviceYearClassIni: String,
          $osBuildIdIni: String,
          $osVersionIni: String,
          $brandFin: String,
          $modelNameFin: String,
          $modelIdFin: String,
          $deviceYearClassFin: String,
          $osBuildIdFin: String,
          $osVersionFin: String
          ){
          editTurno(
            turno:{
              _id: $_id,
              fechaHoraFinTurno: $fechaHoraFinTurno,
              latitudFin: $latitudFin, 
              longitudFin: $longitudFin,
              ubicacionFin: $ubicacionFin,
              minutosTotalTurno: $minutosTotalTurno,
              estado: $estado,
              observacionesFin: $observacionesFin,
              imgFin: $imgFin,
              brandIni: $brandIni,
              modelNameIni: $modelNameIni,
              modelIdIni: $modelIdIni,
              deviceYearClassIni: $deviceYearClassIni,
              osBuildIdIni: $osBuildIdIni,
              osVersionIni: $osVersionIni,
              brandFin: $brandFin,
              modelNameFin: $modelNameFin,
              modelIdFin: $modelIdFin,
              deviceYearClassFin: $deviceYearClassFin,
              osBuildIdFin: $osBuildIdFin,
              osVersionFin: $osVersionFin,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
    deleteTurno: gpl`
      mutation($_id: ID!){
        deleteTurno(
            _id: $_id
        ){
        success
        errors{
            path
            message
            }                
        }
      }
    `,
      createEmpresa: gpl`
        mutation($descrEmpresa: String, $nit: String, $direccion: String, $telefono: String, $comercialAtiende: String,
          $ciudad: String, $pais: String, $logo: String, $codEmpresa: String, $rutas: String, $anexos: String, $fechaCreate: Date){
          createEmpresa(
            empresa:{
              descrEmpresa: $descrEmpresa,
              comercialAtiende: $comercialAtiende,
              ciudad: $ciudad,
              pais: $pais,
              nit: $nit,
              direccion: $direccion,
              telefono: $telefono,
              logo: $logo,
              codEmpresa: $codEmpresa,
              rutas: $rutas,
              anexos: $anexos,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editEmpresa: gpl`
        mutation($_id: ID, 
               $descrEmpresa: String, $comercialAtiende: String,
               $ciudad: String, 
               $pais: String,
               $nit: String, 
               $descrEmpresaAnt: String, 
               $direccion: String, 
               $telefono: String,
               $logo: String, 
               $rut: String, 
               $camara: String, 
               $codEmpresa: String, 
               $modLogo: String, 
               $modRut: String,
               $modCamara: String, 
               $consecProducto: Number,
               $consecServicio: Number, 
               $consecPrograma: Number, 
               $ultimaFormaPago: String,
               $tipoAct: String,
               $tipo: String,
               $subTipo: String,
               $usuario: String,
               $creado: Date, 
               $desde: Date,
               $hasta: Date,
               $descrPlanta: String,
               $descrSeccion: String,
               $descrEquipo: String,
               $descrComponente: String,
               $descrMecanismo: String,
               $tipoLub: String,
               $descrLubricante: String,
               $descrUnidad: String,
               $descrMetodo: String, 
               $descrTarea: String,
               $descrAplicacion: String,
               $tipoHallazgo: String,
               $color: String,
               $modo: String,
               $riesgo: String,
               $cantTotal: Number,
               $cantMensual: Number,
               $cantAnual: Number,
               $puntos: Number,
               $minutos: Number,
               $rutas: String,
               $anexos: String,
               $rutaLogo: String,
               $estadoFact: String,
               $factVigentes: String,
               $factVencidas: String,
               ){
          editEmpresa(
            empresa:{
              _id: $_id,
              descrEmpresa: $descrEmpresa,
              comercialAtiende: $comercialAtiende,
              ciudad: $ciudad,
              pais: $pais,
              nit: $nit,
              descrEmpresaAnt: $descrEmpresaAnt,
              direccion: $direccion,
              telefono: $telefono,
              logo: $logo,
              rut: $rut,
              camara: $camara,
              codEmpresa: $codEmpresa,
              rutas: $rutas,
              anexos: $anexos,
              modLogo: $modLogo,
              modRut: $modRut,
              modCamara: $modCamara,
              rutaLogo: $rutaLogo,
              consecProducto: $consecProducto,
              consecServicio: $consecServicio,
              consecPrograma: $consecPrograma,
              ultimaFormaPago: $ultimaFormaPago,
              tipoAct: $tipoAct,
              estadoFact: $estadoFact,
              factVigentes: $factVigentes,
              factVencidas: $factVencidas,
              reportes:{
                tipo: $tipo,
                subTipo: $subTipo,
                usuario: $usuario,
                creado: $creado, 
                desde: $desde,
                hasta: $hasta,
                descrPlanta: $descrPlanta,
                descrSeccion: $descrSeccion,
                descrEquipo: $descrEquipo,
                descrComponente: $descrComponente,
                descrMecanismo: $descrMecanismo,
                tipoLub: $tipoLub,
                descrLubricante: $descrLubricante,
                descrUnidad: $descrUnidad,
                descrMetodo: $descrMetodo, 
                descrTarea: $descrTarea,
                descrAplicacion: $descrAplicacion,
                tipoHallazgo: $tipoHallazgo,
                color: $color,
                modo: $modo,
                riesgo: $riesgo,
                cantTotal: $cantTotal,
                cantMensual: $cantMensual,
                cantAnual: $cantAnual,
                puntos: $puntos,
                minutos: $minutos,
              }
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      editEmpresaMany: gpl`
        mutation($empresa: [iEmpresaUpdInd]){
          editEmpresaMany(
            empresa: $empresa
          )
          {
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteEmpresa: gpl`
        mutation($_id: ID!){
          deleteEmpresa(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
      `,
      createContacto: gpl`
        mutation($descrEmpresa: String, $nombreContacto: String, $ciudadContacto: String, $cargoContacto: String,
                $mailContacto: String, $telContacto: String, $fechaCreate: Date){
          createContacto(
            contacto:{
              descrEmpresa: $descrEmpresa,
              nombreContacto: $nombreContacto,
              ciudadContacto: $ciudadContacto,
              cargoContacto: $cargoContacto,
              mailContacto: $mailContacto,
              telContacto: $telContacto,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editContacto: gpl`
        mutation($_id: ID, $descrEmpresa: String,
                  $nombreContacto: String, 
                  $nombreContactoAnt: String, 
                  $ciudadContacto: String,
                  $cargoContacto: String,
                  $mailContacto: String,
                  $telContacto: String){
          editContacto(
            contacto:{
              _id: $_id,
              descrEmpresa: $descrEmpresa,
              nombreContacto: $nombreContacto,
              nombreContactoAnt: $nombreContactoAnt,
              ciudadContacto: $ciudadContacto,
              cargoContacto: $cargoContacto,
              mailContacto: $mailContacto,
              telContacto: $telContacto,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteContacto: gpl`
        mutation($_id: ID!){
          deleteContacto(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
      `,

      createSolicCompra: gpl`
        mutation($descrProducto: String, $cantidad: Number, $activo: String, 
          $fechaCreate: Date, $usuarioCreate: String){
          createSolicCompra(
            solicCompra:{
              descrProducto: $descrProducto,
              cantidad: $cantidad,
              activo: $activo,
              fechaCreate: $fechaCreate,
              usuarioCreate: $usuarioCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editSolicCompra: gpl`
        mutation($_id: ID, $descrProducto: String, $cantidad: Number, $activo: String, $tipoAct: String){
          editSolicCompra(
            solicCompra:{
              _id: $_id,
              descrProducto: $descrProducto,
              cantidad: $cantidad,
              activo: $activo, 
              tipoAct: $tipoAct,         }
          ){
            success
            errors{
              path
              message
            }
          }
        }
      `,
      deleteSolicCompra: gpl`
        mutation($_id: ID!){
          deleteSolicCompra(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
      `,

      createOperario: gpl`
        mutation($descrOperario: String, $cedula: String, $fechaCreate: Date){
          createOperario(
            operario:{
              descrOperario: $descrOperario,
              cedula: $cedula,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editOperario: gpl`
        mutation($_id: ID, $descrOperario: String, $descrOperarioAnt: String, $cedula: String, $cedulaAnt: String){
          editOperario(
            operario:{
              _id: $_id,
              descrOperario: $descrOperario,
              descrOperarioAnt: $descrOperarioAnt,
              cedula: $cedula,
              cedulaAnt: $cedulaAnt,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteOperario: gpl`
        mutation($_id: ID!){
          deleteOperario(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
      `,
      createLocalizac: gpl`
        mutation($descrLocalizac: String, $fechaCreate: Date){
          createLocalizac(
            localizac:{
              descrLocalizac: $descrLocalizac,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editLocalizac: gpl`
        mutation($_id: ID, $descrLocalizac: String){
          editLocalizac(
            localizac:{
              _id: $_id,
              descrLocalizac: $descrLocalizac,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteLocalizac: gpl`
        mutation($_id: ID!){
          deleteLocalizac(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
      `,
      createCptogasto: gpl`
        mutation($descrCptogasto: String, $fechaCreate: Date){
          createCptogasto(
            cptogasto:{
              descrCptogasto: $descrCptogasto,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editCptogasto: gpl`
        mutation($_id: ID, $descrCptogasto: String){
          editCptogasto(
            cptogasto:{
              _id: $_id,
              descrCptogasto: $descrCptogasto,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteCptogasto: gpl`
        mutation($_id: ID!){
          deleteCptogasto(
            _id: $_id
          ){
          success
          errors{
            path
            message
            }                
          }
        }
      `,
      createCtocosto: gpl`
        mutation($descrCtocosto: String, $fechaCreate: Date){
          createCtocosto(
            ctocosto:{
              descrCtocosto: $descrCtocosto,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editCtocosto: gpl`
        mutation($_id: ID, $descrCtocosto: String){
          editCtocosto(
            ctocosto:{
              _id: $_id,
              descrCtocosto: $descrCtocosto,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteCtocosto: gpl`
        mutation($_id: ID!){
          deleteCtocosto(
            _id: $_id
          ){
          success
          errors{
            path
            message
            }                
          }
        }
      `,
      createTiposequipo: gpl`
        mutation($descrTiposequipo: String, $fechaCreate: Date){
          createTiposequipo(
            tiposequipo:{
              descrTiposequipo: $descrTiposequipo,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editTiposequipo: gpl`
        mutation($_id: ID, $descrTiposequipo: String){
          editTiposequipo(
            tiposequipo:{
              _id: $_id,
              descrTiposequipo: $descrTiposequipo,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteTiposequipo: gpl`
        mutation($_id: ID!){
          deleteTiposequipo(
            _id: $_id
          ){
          success
          errors{
            path
            message
            }                
          }
        }
        `,
        createTiposcomp: gpl`
          mutation($descrTiposcomp: String, $fechaCreate: Date){
            createTiposcomp(
              tiposcomp:{
                descrTiposcomp: $descrTiposcomp,
                fechaCreate: $fechaCreate,
              }
            ){
              success
              _id
              errors{
                path
                message
              }
            }
          }
        `,
        editTiposcomp: gpl`
          mutation($_id: ID, $descrTiposcomp: String){
            editTiposcomp(
              tiposcomp:{
                _id: $_id,
                descrTiposcomp: $descrTiposcomp,
              }
            ){
              success
              errors{
                path
                message
              }                
            }
          }
        `,
        deleteTiposcomp: gpl`
          mutation($_id: ID!){
            deleteTiposcomp(
              _id: $_id
            ){
            success
            errors{
              path
              message
              }                
            }
          }
        `,      
        createFabricante: gpl`
        mutation($descrFabricante: String, $fechaCreate: Date){
          createFabricante(
            fabricante:{
              descrFabricante: $descrFabricante,
              fechaCreate: $fechaCreate,
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editFabricante: gpl`
        mutation($_id: ID, $descrFabricante: String){
          editFabricante(
            fabricante:{
              _id: $_id,
              descrFabricante: $descrFabricante,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteFabricante: gpl`
        mutation($_id: ID!){
          deleteFabricante(
            _id: $_id
          ){
          success
          errors{
            path
            message
            }                
          }
        }
      `,

    createUnidad: gpl`
      mutation($tipoUnidad: String, $descrUnidad: String, $abrevUnidad: String, $fechaCreate: Date){
        createUnidad(
          unidad:{
            tipoUnidad: $tipoUnidad,
            descrUnidad: $descrUnidad,
            abrevUnidad: $abrevUnidad,
            fechaCreate: $fechaCreate,
          }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
    `,
    editUnidad: gpl`
      mutation($_id: ID, $tipoUnidad: String, $descrUnidad: String, $abrevUnidad: String, 
                $descrUnidadAnt: String, $abrevUnidadAnt: String){
        editUnidad(
          unidad:{
            _id: $_id,
            tipoUnidad: $tipoUnidad,
            descrUnidad: $descrUnidad,
            abrevUnidad: $abrevUnidad,
            descrUnidadAnt: $descrUnidadAnt,
            abrevUnidadAnt: $abrevUnidadAnt,          }
        ){
          success
          errors{
            path
            message
          }
        }
      }
    `,
    deleteUnidad: gpl`
      mutation($_id: ID!){
        deleteUnidad(
          _id: $_id
        ){
        success
        errors{
          path
          message
          }                
        }
      }
    `,
    createEncuesta: gpl`
    mutation($pregunta: String){
      createEncuesta(
        encuesta:{
          pregunta: $pregunta,
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,
  editEncuesta: gpl`
    mutation($_id: ID, $pregunta: String){
      editEncuesta(
        encuesta:{
          _id: $_id,
          pregunta: $pregunta,
        }
      ){
        success
        errors{
          path
          message
        }                
      }
    }
  `,
  deleteEncuesta: gpl`
    mutation($_id: ID!){
      deleteEncuesta(
        _id: $_id
      ){
      success
      errors{
        path
        message
        }                
      }
    }
  `,

  createMaterial: gpl`
    mutation($tipoMaterial: String, $descrMaterial: String, $codMaterial: String, $fechaCreate: Date){
      createMaterial(
        material:{
          tipoMaterial: $tipoMaterial,
          descrMaterial: $descrMaterial,
          codMaterial: $codMaterial,
          fechaCreate: $fechaCreate,
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,


  editMaterial: gpl`
    mutation($_id: ID, $tipoMaterial: String, $descrMaterial: String, $codMaterial: String, 
              $descrMaterialAnt: String, $codMaterialAnt: String){
      editMaterial(
        material:{
          _id: $_id,
          tipoMaterial: $tipoMaterial,
          descrMaterial: $descrMaterial,
          codMaterial: $codMaterial,
          descrMaterialAnt: $descrMaterialAnt,
          codMaterialAnt: $codMaterialAnt,          }
      ){
        success
        errors{
          path
          message
        }
      }
    }
  `,
  deleteMaterial: gpl`
    mutation($_id: ID!){
      deleteMaterial(
        _id: $_id
      ){
      success
      errors{
        path
        message
        }                
      }
    }
  `,
  createMeta: gpl`
    mutation($tipoMeta: String, $agno: Number, $mes: String, $mesNum: Number, $grupo: String, $cedula: String, $nombreUsuario: String, 
            $valor: Number, $meta: Number, $valorReal: Number, $estado: String, $fechaCreate: Date, $metaAgno: Number, $metaAcumAgno: Number){
      createMeta(
        meta:{
          tipoMeta: $tipoMeta,
          agno: $agno,
          mes: $mes,
          mesNum: $mesNum,
          grupo: $grupo,
          cedula: $cedula,
          nombreUsuario: $nombreUsuario,
          valor: $valor,
          meta: $meta, 
          valorReal: $valorReal,
          metaAgno: $metaAgno, 
          metaAcumAgno: $metaAcumAgno,
          fechaCreate: $fechaCreate,
          estado: $estado
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,
  editMeta: gpl`
    mutation($_id: ID, $tipoMeta: String, $agno: Number, $mes: String, $mesNum: Number, $grupo: String, $cedula: String, $nombreUsuario: String, 
      $valor: Number, $meta: Number, $valorReal: Number, $estado: String,
      $rango1Desde: Number,
      $rango1Hasta: Number,
      $rango2Hasta: Number,
      $rango3Hasta: Number,
      $porcCumplimiento: Number, $porcCumplimientoMeta: Number, 
      $rangoAplicado: Number,
      $valorRecaudo: Number,
      $valorComision: Number, $comisionVentas: Number,
      $valorRealAcumAgno: Number,
      $metaAgno: Number,
      $metaAcumAgno: Number,
      $porcCumplimientoMetaAgno: Number){
      editMeta(
        meta:{
          _id: $_id,
          tipoMeta: $tipoMeta,
          agno: $agno,
          mes: $mes,
          mesNum: $mesNum,
          grupo: $grupo,
          cedula: $cedula,
          nombreUsuario:$nombreUsuario,
          valor: $valor,
          meta: $meta, 
          valorReal: $valorReal,
          valorRealAcumAgno: $valorRealAcumAgno,
          metaAgno: $metaAgno,
          metaAcumAgno: $metaAcumAgno,
          porcCumplimientoMetaAgno: $porcCumplimientoMetaAgno,
          estado: $estado,  
          rango1Desde: $rango1Desde,
          rango1Hasta: $rango1Hasta,
          rango2Hasta: $rango2Hasta,
          rango3Hasta: $rango3Hasta,
          porcCumplimiento: $porcCumplimiento,
          porcCumplimientoMeta: $porcCumplimientoMeta,
          rangoAplicado: $rangoAplicado,
          valorRecaudo: $valorRecaudo,
          valorComision: $valorComision,      
          comisionVentas: $comisionVentas,
        }
      ){
        success
        errors{
          path
          message
        }
      }
    }
  `,
  deleteMeta: gpl`
    mutation($_id: ID!){
      deleteMeta(
        _id: $_id
      ){
      success
      errors{
        path
        message
        }                
      }
    }
  `,
  createPolitica: gpl`
  mutation($titulo: String, $descrPolitica: String, $tipoProducto: String, $titulo2: String,
    $parrafo2: String, $titulo3: String, $parrafo3: String, $fechaCreate: Date){
    createPolitica(
      politica:{
        titulo: $titulo,
        descrPolitica: $descrPolitica,
        tipoProducto: $tipoProducto,
        titulo2: $titulo2,
        parrafo2: $parrafo2,
        titulo3: $titulo3,
        parrafo3: $parrafo3,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editPolitica: gpl`
      mutation($_id: ID, $titulo: String, $descrPolitica: String, $tipoProducto: String, $titulo2: String,
        $parrafo2: String, $titulo3: String, $parrafo3: String, $tituloAnt: String){
        editPolitica(
          politica:{
            _id: $_id,
            titulo: $titulo,
            descrPolitica: $descrPolitica,
            tipoProducto: $tipoProducto,
            titulo2: $titulo2,
            parrafo2: $parrafo2,
            titulo3: $titulo3,
            parrafo3: $parrafo3,
            tituloAnt: $tituloAnt, 
          }
        ){
          success
          errors{
            path
            message
          }
        }
      }
    `,
deletePolitica: gpl`
mutation($_id: ID!){
  deletePolitica(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,
createCotizacion: gpl`
  mutation($tipoCoti: String, 
    $pais: String,
    $numCoti: String,
    $numSolic: String,
    $cedula: String,
    $nombreUsuario: String,
    $titulo: String,
    $descrPolitica: String,
    $titulo2: String,
    $parrafo2: String,
    $titulo3: String,
    $parrafo3: String,
    $tipo: String,
    $ciudadFechaEnvio: String,
    $monedaCoti: String,
    $imptoCoti: String,
    $nombreContacto: String, 
    $ciudadContacto: String,
    $cargoContacto: String,
    $mailContacto: String,
    $telContacto: String,
    $referencia: String,
    $tiempoEntrega: String,
    $lugarEntrega: String,
    $formaPago: String,
    $validezOferta: String,
    $estadoCoti: String, 
    $descrEmpresa: String,
    $descrProveed: String,
    $ciudad: String,
    $direccion: String,
    $telefono: String,
    $email: String,
    $fechaCreate: Date,
    $usuarioCreate: String,
    $observaciones: String,
    $observacionesOC: String,
    $consecAvance: Number,
    $consecDespacho: Number,
    $archivoRecibido: String,
    $zonaFranca: String,
    $gestionIngreso: String,
    $ordenCompraCliente: String){
    createCotizacion(
      cotizacion:{
        tipoCoti: $tipoCoti, 
        pais: $pais,
        numCoti: $numCoti,
        numSolic: $numSolic,
        cedula: $cedula,
        nombreUsuario: $nombreUsuario,
        titulo: $titulo,
        descrPolitica: $descrPolitica,
        titulo2: $titulo2,
        parrafo2: $parrafo2,
        titulo3: $titulo3,
        parrafo3: $parrafo3,
        tipo: $tipo,
        ciudadFechaEnvio: $ciudadFechaEnvio,
        monedaCoti: $monedaCoti,
        imptoCoti: $imptoCoti,
        nombreContacto: $nombreContacto, 
        ciudadContacto: $ciudadContacto,
        cargoContacto: $cargoContacto,
        mailContacto: $mailContacto,
        telContacto: $telContacto,
        referencia: $referencia,
        tiempoEntrega: $tiempoEntrega,
        lugarEntrega: $lugarEntrega,
        formaPago: $formaPago,
        validezOferta: $validezOferta,
        estadoCoti: $estadoCoti, 
        descrEmpresa: $descrEmpresa,
        descrProveed: $descrProveed,
        ciudad: $ciudad,
        direccion: $direccion,
        telefono: $telefono,
        email: $email,
        fechaCreate: $fechaCreate,
        usuarioCreate: $usuarioCreate,
        observaciones: $observaciones,
        observacionesOC: $observacionesOC,
        consecAvance: $consecAvance,
        consecDespacho: $consecDespacho,
        archivoRecibido: $archivoRecibido,
        zonaFranca: $zonaFranca,
        gestionIngreso: $gestionIngreso,
        ordenCompraCliente: $ordenCompraCliente,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,

editCotizacion: gpl`
mutation($_id: ID, $pais: String, $numCoti: String, $numSolic: String, $ordenCompraCliente: String,
  $cedula: String, $nombreUsuario: String,
  $cedulaOC: String,
  $nombreUsuarioOC: String,
  $titulo: String,
  $descrPolitica: String,
  $titulo2: String,
  $parrafo2: String,
  $titulo3: String,
  $parrafo3: String,
  $tipo: String,
  $ciudadFechaEnvio: String,
  $monedaCoti: String,
  $imptoCoti: String,
  $nombreContacto: String, 
  $ciudadContacto: String,
  $cargoContacto: String,
  $mailContacto: String,
  $telContacto: String,
  $referencia: String,
  $tiempoEntrega: String,
  $lugarEntrega: String,
  $formaPago: String,
  $validezOferta: String,
  $estadoCoti: String, 
  $numOrdenCompra: Number,
  $descrEmpresa: String,
  $descrProveed: String,
  $ciudad: String,
  $direccion: String,
  $telefono: String,
  $email: String,
  $archivoEnviado: String,
  $archivoRecibido: String,
  $observaciones: String,
  $fechaAut: Date,
  $usuarioAut: String,
  $observacionesAut: String,
  $fechaEnvio: Date,
  $usuarioEnvio: String,
  $fechaRta: Date,
  $usuarioRta: String,
  $estadoOC: String,
  $archivoEncuesta: String,
  $actaInicial: String,
  $actaFinal: String,
  $informe: String,
  $contactoEncuesta: String,
  $cedulaEncuesta: String,
  $telefonoEncuesta: String,
  $emailEncuesta: String,
  $fechaIni: Date,
  $fechaFin: Date,
  $usuarioIni: String,
  $observacionesOC: String,
  $usuarioAutOC: String,
  $fechaAutOC: Date,
  $usuarioCanOC: String,
  $fechaCanOC: Date,
  $observacionesAutOC: String,
  $usuarioEjec: String,
  $fechaEjec: Date,
  $fechaFinReal: Date,
  $observacionesFin: String,
  $totalOC: Number,
  $fechaOrdenCliente: Date,
  $totalFact: Number,
  $usuarioTotalOC: String,
  $usuarioFac: String,
  $fechaFac: Date,
  $consecAvance: Number,
  $consecDespacho: Number,
  $trm: Number,
  $zonaFranca: String,
  $gestionIngreso: String,
  $estadoGestion: String,
  $motivoEstado: String,
  $aplicaComision: String,
  $rangoAplicado: Number,
  $diasImportacion: Number,
  $tipoAct: String,
  $modArch1: String,
  $modArch2: String,
  $modArch3: String,
  $modArch4: String,
  $modArch5: String,
  $consecProducto: Number,
  $consecServicio: Number,
  $consecPrograma: Number,
  $pregunta: String,
  $respuesta: String,
  $valoracion: Number,
  $tipoProducto: String,
  $descrProducto: String,
  $descrCorta: String,
  $numProductoCoti: Number,
  $ficha: String, 
  $ficha2: String,
  $cantidadCoti: Number,
  $valorUniCoti: Number,
  $porcDcto: Number,
  $porcIncremento: Number,
  $porcIVA: Number,
  $recargoTransp: Number,
  $cantidadAprob: Number,
  $cantidadRecibida: Number,
  $valorUniAprob: Number,
  $descrUnidad: String,
  $abrevUnidad: String,
  $numOrdenCompraCli: Number,
  $cantidadOC: Number,
  $moneda: String,
  $cantidadDespacho: Number,
  $cantidadFact: Number,
  $cantidadCompra: Number,
  $cantidadCompraEjec: Number,
  $fechaSolicCompra: Date,
  $fechaEjecCompra: Date,
  $numAvance: Number,
  $valorFact: Number,
  $valorFactSinIva: Number,
  $numFactura: String,
  $venceFact: Date,
  $trmFactura: Number,
  $valorPagado: Number,
  $archivoFactura: String,
  $ordenPago: String,
  $usuarioSolic: String,
  $fechaSolic: Date,
  $usuarioFact: String,
  $fechaFact: Date,
  $usuarioPago: String,
  $fechaPago: Date,
  $numDespacho: String,
  $codigo: Number,
  $codAvance: Number,
  $descrProductoDes: String,
  $descrCortaDes: String,
  $idProducto: Number,
  $cantidad: Number,
  $cantidadDev: Number,
  $valorDes: Number,
  $descrUnidadDes: String,
  $usuarioDespacho: String,
  $fechaDespacho: Date,
  $despFact: String,
  $porcIVADes: Number,
  $porcDctoDes: Number,
  $porcIncrementoDes: Number,
  $dirEntrega: String,
  $fechaEntrega: Date,
  $transportadora: String,
  $numGuia: String,
  $emailAviso: String,
  $porcComision: Number,
  $valorComision: Number,
  $agnoComision: Number,
  $mesComision: Number,
  $estadoComision: String,
  $codiAvance: Number,
  $valorPago: Number,
  $valorIVA: Number,
  $valorRetencion: Number,
  $valorAjuste: Number,
  $observacionAjuste: String,
  $tipoPago: String,
  $usuarioRegPago: String,
  $fechaRegPago: Date,
  $cliProv: String,
  $trmPago: Number,
  ){
  editCotizacion(
    cotizacion:{
      _id: $_id,
      pais: $pais, 
      numCoti: $numCoti, 
      numSolic: $numSolic,
      ordenCompraCliente: $ordenCompraCliente,
      cedula: $cedula, 
      nombreUsuario: $nombreUsuario,
      cedulaOC: $cedulaOC,
      nombreUsuarioOC: $nombreUsuarioOC,
      titulo: $titulo,
      descrPolitica: $descrPolitica,
      titulo2: $titulo2,
      parrafo2: $parrafo2,
      titulo3: $titulo3,
      parrafo3: $parrafo3,
      tipo: $tipo,
      ciudadFechaEnvio: $ciudadFechaEnvio,
      monedaCoti: $monedaCoti,
      imptoCoti: $imptoCoti,
      nombreContacto: $nombreContacto, 
      ciudadContacto: $ciudadContacto,
      cargoContacto: $cargoContacto,
      mailContacto: $mailContacto,
      telContacto: $telContacto,
      referencia: $referencia,
      tiempoEntrega: $tiempoEntrega,
      lugarEntrega: $lugarEntrega,
      formaPago: $formaPago,
      validezOferta: $validezOferta,
      estadoCoti: $estadoCoti, 
      numOrdenCompra: $numOrdenCompra,
      descrEmpresa: $descrEmpresa,
      descrProveed: $descrProveed,
      ciudad: $ciudad,
      direccion: $direccion,
      telefono: $telefono,
      email: $email,
      archivoEnviado: $archivoEnviado,
      archivoRecibido: $archivoRecibido,
      observaciones: $observaciones,
      fechaAut: $fechaAut,
      usuarioAut: $usuarioAut,
      observacionesAut: $observacionesAut,
      fechaEnvio: $fechaEnvio,
      usuarioEnvio: $usuarioEnvio,
      fechaRta: $fechaRta,
      usuarioRta: $usuarioRta,
      estadoOC: $estadoOC,
      archivoEncuesta: $archivoEncuesta,
      actaInicial: $actaInicial,
      actaFinal: $actaFinal,
      informe: $informe,
      contactoEncuesta: $contactoEncuesta,
      cedulaEncuesta: $cedulaEncuesta,
      telefonoEncuesta: $telefonoEncuesta,
      emailEncuesta: $emailEncuesta,
      fechaIni: $fechaIni,
      fechaFin: $fechaFin,
      usuarioIni: $usuarioIni,
      observacionesOC: $observacionesOC,
      usuarioAutOC: $usuarioAutOC,
      fechaAutOC: $fechaAutOC,
      usuarioCanOC: $usuarioCanOC,
      fechaCanOC: $fechaCanOC,      
      observacionesAutOC: $observacionesAutOC,
      usuarioEjec: $usuarioEjec,
      fechaEjec: $fechaEjec,
      fechaFinReal: $fechaFinReal,
      observacionesFin: $observacionesFin,
      totalOC: $totalOC,
      fechaOrdenCliente: $fechaOrdenCliente,
      totalFact: $totalFact,
      usuarioTotalOC: $usuarioTotalOC,
      usuarioFac: $usuarioFac,
      fechaFac: $fechaFac,
      consecAvance: $consecAvance, 
      consecDespacho: $consecDespacho,
      trm: $trm,
      zonaFranca: $zonaFranca,
      gestionIngreso: $gestionIngreso,
      estadoGestion: $estadoGestion,
      motivoEstado: $motivoEstado,
      aplicaComision: $aplicaComision,
      rangoAplicado: $rangoAplicado,
      diasImportacion: $diasImportacion,
      tipoAct: $tipoAct,
      modArch1: $modArch1,
      modArch2: $modArch2,
      modArch3: $modArch3,
      modArch4: $modArch4,
      modArch5: $modArch5,
      consecProducto: $consecProducto,
      consecServicio: $consecServicio,
      consecPrograma: $consecPrograma,
      itemsEncuesta:{
        pregunta: $pregunta,
        respuesta: $respuesta,
        valoracion: $valoracion,
      },
      itemsCoti:{ 
        tipoProducto: $tipoProducto,
        descrProducto: $descrProducto,
        descrCorta: $descrCorta,
        numProductoCoti: $numProductoCoti,
        ficha: $ficha, 
        ficha2: $ficha2,
        cantidadCoti: $cantidadCoti,
        valorUniCoti: $valorUniCoti,
        porcDcto: $porcDcto,
        porcIncremento: $porcIncremento,
        porcIVA: $porcIVA,
        recargoTransp: $recargoTransp,
        cantidadAprob: $cantidadAprob,
        cantidadRecibida: $cantidadRecibida,
        valorUniAprob: $valorUniAprob,
        descrUnidad: $descrUnidad,
        abrevUnidad: $abrevUnidad,
        numOrdenCompraCli: $numOrdenCompraCli,
        cantidadOC: $cantidadOC,
        moneda: $moneda,
        cantidadDespacho: $cantidadDespacho,
        cantidadFact: $cantidadFact,
        cantidadCompra: $cantidadCompra,
        cantidadCompraEjec: $cantidadCompraEjec,
        fechaSolicCompra: $fechaSolicCompra,
        fechaEjecCompra: $fechaEjecCompra,
      },
      itemsFactura:{
        numAvance: $numAvance,
        valorFact: $valorFact,
        valorFactSinIva: $valorFactSinIva,
        numFactura: $numFactura,
        venceFact: $venceFact,
        trmFactura: $trmFactura,
        valorPagado: $valorPagado,
        archivoFactura: $archivoFactura,
        ordenPago: $ordenPago,
        usuarioSolic: $usuarioSolic,
        fechaSolic: $fechaSolic,
        usuarioFact: $usuarioFact,
        fechaFact: $fechaFact,
        usuarioPago: $usuarioPago,
        fechaPago: $fechaPago,
      },
      itemsDespacho:{
        numDespacho: $numDespacho,
        codigo: $codigo,
        codAvance: $codAvance,
        descrProductoDes: $descrProductoDes,
        descrCortaDes: $descrCortaDes,
        idProducto: $idProducto,
        cantidad: $cantidad,
        cantidadDev: $cantidadDev,
        valorDes: $valorDes,
        descrUnidadDes: $descrUnidadDes,
        usuarioDespacho: $usuarioDespacho,
        fechaDespacho: $fechaDespacho,
        despFact: $despFact,
        porcIVADes: $porcIVADes,
        porcDctoDes: $porcDctoDes,
        porcIncrementoDes: $porcIncrementoDes,
        dirEntrega: $dirEntrega,
        fechaEntrega: $fechaEntrega,
        transportadora: $transportadora,
        numGuia: $numGuia,
        emailAviso: $emailAviso,
        porcComision: $porcComision,
        valorComision: $valorComision,
        agnoComision: $agnoComision,
        mesComision: $mesComision,
        estadoComision: $estadoComision,
      },
      itemsPagos:{
        codiAvance: $codiAvance,
        valorPago: $valorPago,
        valorIVA: $valorIVA,
        valorRetencion: $valorRetencion,
        valorAjuste: $valorAjuste,
        observacionAjuste: $observacionAjuste,
        tipoPago: $tipoPago,
        usuarioRegPago: $usuarioRegPago,
        fechaRegPago: $fechaRegPago,
        cliProv: $cliProv,
        trmPago: $trmPago,
      }
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
deleteCotizacion: gpl`
mutation($_id: ID!){
  deleteCotizacion(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,

createMetodo: gpl`
      mutation($tipoLub: String, $descrMetodo: String, $fechaCreate: Date){
        createMetodo(
          metodo:{
            tipoLub: $tipoLub,
            descrMetodo: $descrMetodo,
            fechaCreate: $fechaCreate,
          }
        ){
          success
          _id
          errors{
            path
            message
          }
        }
      }
    `,
    editMetodo: gpl`
      mutation($_id: ID, $tipoLub: String, $descrMetodo: String, $descrMetodoAnt: String){
        editMetodo(
          metodo:{
            _id: $_id,
            tipoLub: $tipoLub,
            descrMetodo: $descrMetodo,
            descrMetodoAnt: $descrMetodoAnt, 
          }
        ){
          success
          errors{
            path
            message
          }
        }
      }
    `,
    deleteMetodo: gpl`
      mutation($_id: ID!){
        deleteMetodo(
          _id: $_id
        ){
        success
        errors{
          path
          message
          }                
        }
      }
    `,
    createHallazgo: gpl`
    mutation($descrHallazgo: String, $fechaCreate: Date){
      createHallazgo(
        hallazgo:{
          descrHallazgo: $descrHallazgo,
          fechaCreate: $fechaCreate,
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,
  editHallazgo: gpl`
    mutation($_id: ID, $descrHallazgo: String, $descrHallazgoAnt: String){
      editHallazgo(
        hallazgo:{
          _id: $_id,
          descrHallazgo: $descrHallazgo,
          descrHallazgoAnt: $descrHallazgoAnt, 
        }
      ){
        success
        errors{
          path
          message
        }
      }
    }
  `,
  deleteHallazgo: gpl`
    mutation($_id: ID!){
      deleteHallazgo(
        _id: $_id
      ){
      success
      errors{
        path
        message
        }                
      }
    }
  `,
  createUtilidad: gpl`
  mutation($descrUtilidad: String, $fechaCreate: Date){
    createUtilidad(
      utilidad:{
        descrUtilidad: $descrUtilidad,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editUtilidad: gpl`
  mutation($_id: ID, $descrUtilidad: String, $descrUtilidadAnt: String){
    editUtilidad(
      utilidad:{
        _id: $_id,
        descrUtilidad: $descrUtilidad,
        descrUtilidadAnt: $descrUtilidadAnt, 
      }
    ){
      success
      errors{
        path
        message
      }
    }
  }
`,
deleteUtilidad: gpl`
  mutation($_id: ID!){
    deleteUtilidad(
      _id: $_id
    ){
    success
    errors{
      path
      message
      }                
    }
  }
`,

createPrograma: gpl`
mutation($descrPrograma: String, $fechaCreate: Date){
  createPrograma(
    programa:{
      descrPrograma: $descrPrograma,
      fechaCreate: $fechaCreate,
    }
  ){
    success
    _id
    errors{
      path
      message
    }
  }
}
`,
editPrograma: gpl`
mutation($_id: ID, $descrPrograma: String, $descrProgramaAnt: String){
  editPrograma(
    programa:{
      _id: $_id,
      descrPrograma: $descrPrograma,
      descrProgramaAnt: $descrProgramaAnt, 
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
deletePrograma: gpl`
mutation($_id: ID!){
  deletePrograma(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,


    createTarea: gpl`
    mutation($tipoLub: String, $descrTarea: String, $fechaCreate: Date){
      createTarea(
        tarea:{
          tipoLub: $tipoLub,
          descrTarea: $descrTarea,
          fechaCreate: $fechaCreate,
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,
  editTarea: gpl`
    mutation($_id: ID, $tipoLub: String, $descrTarea: String, $descrTareaAnt: String){
      editTarea(
        tarea:{
          _id: $_id,
          tipoLub: $tipoLub,
          descrTarea: $descrTarea,
          descrTareaAnt: $descrTareaAnt,
        }
      ){
        success
        errors{
          path
          message
        }
      }
    }
  `,
  deleteTarea: gpl`
    mutation($_id: ID!){
      deleteTarea(
        _id: $_id
      ){
      success
      errors{
        path
        message
        }                
      }
    }
  `,
createFrecuencia: gpl`
  mutation($tipoFrecuencia: String, $descrFrecuencia: String, $cantidad: Number, $abrevUnidad: String, $fechaCreate: Date){
    createFrecuencia(
      frecuencia:{
        tipoFrecuencia: $tipoFrecuencia,
        descrFrecuencia: $descrFrecuencia,
        cantidad: $cantidad,
        abrevUnidad: $abrevUnidad,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editFrecuencia: gpl`
  mutation($_id: ID, $tipoFrecuencia: String, $descrFrecuencia: String, $cantidad: Number, $abrevUnidad: String){
    editFrecuencia(
      frecuencia:{
        _id: $_id,
        tipoFrecuencia: $tipoFrecuencia,
        descrFrecuencia: $descrFrecuencia,
        cantidad: $cantidad,
        abrevUnidad: $abrevUnidad,
      }
    ){
      success
      errors{
        path
        message
      }
    }
  }
`,
deleteFrecuencia: gpl`
  mutation($_id: ID!){
    deleteFrecuencia(
      _id: $_id
    ){
    success
    errors{
      path
      message
      }                
    }
  }
  `,
createAplicacion: gpl`
  mutation($descrAplicacion: String, $tipoLub: String, $tipoGrado: String, $sector: String, 
    $color: String, $fechaCreate: Date){
    createAplicacion(
      aplicacion:{
        descrAplicacion: $descrAplicacion,
        tipoLub: $tipoLub,
        tipoGrado: $tipoGrado,
        sector: $sector,
        fechaCreate: $fechaCreate,
        color: $color,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editAplicacion: gpl`
mutation($_id: ID, $descrAplicacion: String, $tipoLub: String, $tipoGrado: String, $sector: String, 
  $color: String, $descrAplicacionAnt: String){
  editAplicacion(
    aplicacion:{
      _id: $_id,
      descrAplicacion: $descrAplicacion,
      tipoLub: $tipoLub,
      tipoGrado: $tipoGrado,
      sector: $sector,
      color: $color,
      descrAplicacionAnt: $descrAplicacionAnt,
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
deleteAplicacion: gpl`
mutation($_id: ID!){
  deleteAplicacion(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,
createGrado: gpl`
  mutation($descrGrado: String, $tipoLub: String, $tipoGrado: String, 
    $sector: String, $aplicacionSAE: String, $categoriaSAE: String, 
    $apiSAE: String, $color: String, $colorTexto: String, $fechaCreate: Date){
    createGrado(
      grado:{
        tipoLub: $tipoLub,
        tipoGrado: $tipoGrado,
        descrGrado: $descrGrado,
        sector: $sector,
        aplicacionSAE: $aplicacionSAE,
        categoriaSAE: $categoriaSAE,
        apiSAE: $apiSAE,
        color: $color,
        colorTexto: $colorTexto,
        fechaCreate: $fechaCreate,
        }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editGrado: gpl`
  mutation($_id: ID, $tipoLub: String, $tipoGrado: String, $descrGrado: String, $tipoGradoAnt: String, 
    $descrGradoAnt: String, $apiSAEAnt: String,  $sector: String, $aplicacionSAE: String, $categoriaSAE: String, 
    $apiSAE: String, $color: String, $colorTexto: String){
  editGrado(
    grado:{
      _id: $_id,
      tipoLub: $tipoLub,
      tipoGrado: $tipoGrado,
      descrGrado: $descrGrado,
      tipoGradoAnt: $tipoGradoAnt,
      descrGradoAnt: $descrGradoAnt,  
      apiSAEAnt: $apiSAEAnt,    
      sector: $sector,
      aplicacionSAE: $aplicacionSAE,
      categoriaSAE: $categoriaSAE,
      apiSAE: $apiSAE,
      color: $color,
      colorTexto: $colorTexto
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
deleteGrado: gpl`
mutation($_id: ID!){
  deleteGrado(
    _id: $_id
  ){
  success
    errors{
      path
      message
    }                
  }
}
`,
createLubricante: gpl`
  mutation($descrLubricante: String, $descrFabricante: String, $tipoLub: String, $claseLub: String,
    $categoriaLub: String, $tipoGrado: String, $descrGrado: String, $colorGrado: String, $apiSAE: String,
    $isoGrasa: String, $isoGrasaColor: String, $isoGrasaTexto: String, $color: Number, $visco40: Number, $visco100: Number, 
    $indice: Number,
    $agua: Number,
    $codigoPar: String,
    $micras4: Number,
    $micras6: Number,
    $micras14: Number,
    $micras21: Number,
    $micras25: Number,
    $micras38: Number,
    $micras70: Number,
    $hollin: Number,
    $nitracion: Number,
    $sulfatacion: Number,
    $dilucion: Number,
    $glicol: Number,
    $oxidacion: Number,
    $tan: Number,
    $tbn: Number,
    $hierro: Number,
    $cobre: Number,
    $aluminio: Number,
    $cromo: Number,
    $plomo: Number,
    $estano: Number,
    $niquel: Number,
    $vanadio: Number,
    $titanio: Number,
    $silicio: Number,
    $sodio: Number,
    $potasio: Number,
    $boro: Number,
    $magnesio: Number,
    $calcio: Number,
    $fosforo: Number,
    $zinc: Number,
    $molibdeno: Number,
    $bario: Number,
    $manganeso: Number,
    $fluidez: Number,
    $inflamacion: Number,
    $cenizas: Number,
    $tost: Number,
    $rpvot: Number,
    $metalicos: String,
    $phosporus: Number,
    $grasa: Number,
    $separabilidad: Number,
    $abrasion: Number,
    $bolas: Number,
    $huella: Number,
    $timken: Number,
    $espuma: String,
    $secuencia1: Number,
    $secuencia2: Number,
    $secuencia3: Number,
    $aeroemulsion: Number,
    $demulsibilidad: Number,
    $emulsion: Number,
    $corrosion: String,
    $ultracentrifuga: Number,
    $densidad: Number,
    $fuego: Number,
    $herrumbre: String,
    $destilada: String,
    $deMar: String,
    $temperatura: Number,
    $penetracion: Number,
    $goteo: Number,
    $lavado: Number,
    $nsf: String,
    $fda: String,
    $biodegradables: String,
    $noToxico: String,
    $ignifugo: String,
    $cumple: String,
    $salud: String,
    $inflamabilidad: String,
    $reactividad: String,
    $blanco: String,
    $pq: Number,
    $fischer: Number,
    $tanpte: Number,
    $tbnpte: Number,
    $fechaCreate: Date){
    createLubricante(
      lubricante:{
        descrLubricante: $descrLubricante,
        descrFabricante: $descrFabricante,
        tipoLub: $tipoLub,
        claseLub: $claseLub,
        categoriaLub: $categoriaLub,
        tipoGrado: $tipoGrado,
        descrGrado: $descrGrado,
        colorGrado: $colorGrado,
        apiSAE: $apiSAE,
        isoGrasa: $isoGrasa,
        isoGrasaColor: $isoGrasaColor,
        isoGrasaTexto: $isoGrasaTexto,
        color: $color,
        visco40: $visco40,
        visco100: $visco100,
        indice: $indice,
        agua: $agua,
        codigoPar: $codigoPar,
        micras4: $micras4,
        micras6: $micras6,
        micras14: $micras14,
        micras21: $micras21,
        micras25: $micras25,
        micras38: $micras38,
        micras70: $micras70,
        hollin: $hollin,
        nitracion: $nitracion,
        sulfatacion: $sulfatacion,
        dilucion: $dilucion,
        glicol: $glicol,
        oxidacion: $oxidacion,
        tan: $tan,
        tbn: $tbn,
        hierro: $hierro,
        cobre: $cobre,
        aluminio: $aluminio
        cromo: $cromo,
        plomo: $plomo,
        estano: $estano,
        niquel: $niquel,
        vanadio: $vanadio,
        titanio: $titanio,
        silicio: $silicio
        sodio: $sodio,
        potasio: $potasio,
        boro: $boro,
        magnesio: $magnesio,
        calcio: $calcio,
        fosforo: $fosforo,
        zinc: $zinc,
        molibdeno: $molibdeno,
        bario: $bario,
        manganeso: $manganeso,
        fluidez: $fluidez,
        inflamacion: $inflamacion,
        cenizas: $cenizas,
        tost: $tost,
        rpvot: $rpvot,
        metalicos: $metalicos,
        phosporus: $phosporus,
        grasa: $grasa,
        separabilidad: $separabilidad,
        abrasion: $abrasion,
        bolas: $bolas,
        huella: $huella,
        timken: $timken,
        espuma: $espuma,
        secuencia1: $secuencia1,
        secuencia2: $secuencia2,
        secuencia3: $secuencia3,
        aeroemulsion: $aeroemulsion,
        demulsibilidad: $demulsibilidad,
        emulsion: $emulsion,
        corrosion: $corrosion,
        ultracentrifuga: $ultracentrifuga,
        fuego: $fuego,
        densidad: $densidad,
        herrumbre: $herrumbre,
        destilada: $destilada,
        deMar: $deMar,
        temperatura: $temperatura,
        penetracion: $penetracion,
        goteo: $goteo,
        lavado: $lavado,
        nsf: $nsf,
        fda: $fda,
        biodegradables: $biodegradables,
        noToxico: $noToxico,
        ignifugo: $ignifugo,
        cumple: $cumple,
        salud: $salud,
        inflamabilidad: $inflamabilidad,
        reactividad: $reactividad,
        blanco: $blanco,
        pq: $pq,
        fischer: $fischer,
        tanpte: $tanpte,
        tbnpte: $tbnpte,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
  `,
  editLubricante: gpl`
  mutation($_id: ID, $descrLubricante: String, $descrLubricanteAnt: String, $descrFabricante: String, $tipoLub: String, 
    $claseLub: String, $categoriaLub: String, $tipoGrado: String, $descrGrado: String, $colorGrado: String, $apiSAE: String,
    $isoGrasa: String, $isoGrasaColor: String, $isoGrasaTexto: String, 
    $descrEmpresa: String,
    $existencia: Number,
    $minimo: Number,
    $descrUnidad: String, 
    $usuarioAct: String,
    $fechaAct: Date,
    $color: Number, 
    $visco40: Number, $visco100: Number, $indice: Number,
    $agua: Number,
    $codigoPar: String,
    $micras4: Number,
    $micras6: Number,
    $micras14: Number,
    $micras21: Number,
    $micras25: Number,
    $micras38: Number,
    $micras70: Number,
    $hollin: Number,
    $nitracion: Number,
    $sulfatacion: Number,
    $dilucion: Number,
    $glicol: Number,
    $oxidacion: Number,
    $tan: Number,
    $tbn: Number,
    $hierro: Number,
    $cobre: Number,
    $aluminio: Number,
    $cromo: Number,
    $plomo: Number,
    $estano: Number,
    $niquel: Number,
    $vanadio: Number,
    $titanio: Number,
    $silicio: Number,
    $sodio: Number,
    $potasio: Number,
    $boro: Number,
    $magnesio: Number,
    $calcio: Number,
    $fosforo: Number,
    $zinc: Number,
    $molibdeno: Number,
    $bario: Number,
    $manganeso: Number,
    $fluidez: Number,
    $inflamacion: Number,
    $cenizas: Number,
    $tost: Number,
    $rpvot: Number,
    $metalicos: String,
    $phosporus: Number,
    $grasa: Number,
    $separabilidad: Number,
    $abrasion: Number,
    $bolas: Number,
    $huella: Number,
    $timken: Number,
    $espuma: String,
    $secuencia1: Number,
    $secuencia2: Number,
    $secuencia3: Number,
    $aeroemulsion: Number,
    $demulsibilidad: Number,
    $emulsion: Number,
    $corrosion: String,
    $ultracentrifuga: Number,
    $densidad: Number,
    $fuego: Number,
    $herrumbre: String,
    $destilada: String,
    $deMar: String,
    $temperatura: Number,
    $penetracion: Number,
    $goteo: Number,
    $lavado: Number,
    $nsf: String,
    $fda: String,
    $biodegradables: String,
    $noToxico: String,
    $ignifugo: String,
    $cumple: String,
    $salud: String,
    $inflamabilidad: String,
    $reactividad: String,
    $blanco: String,
    $pq: Number,
    $fischer: Number,
    $tanpte: Number,
    $tbnpte: Number,
    $tipoAct: String,
    ){
    editLubricante(
      lubricante:{
        _id: $_id,
        descrLubricante: $descrLubricante,
        descrLubricanteAnt: $descrLubricanteAnt,
        descrFabricante: $descrFabricante,
        tipoLub: $tipoLub,
        claseLub: $claseLub,
        categoriaLub: $categoriaLub,
        tipoGrado: $tipoGrado,
        descrGrado: $descrGrado,
        colorGrado: $colorGrado,
        apiSAE: $apiSAE,
        isoGrasa: $isoGrasa,
        isoGrasaColor: $isoGrasaColor,
        isoGrasaTexto: $isoGrasaTexto,
        color: $color,
        visco40: $visco40,
        visco100: $visco100,
        indice: $indice,
        agua: $agua,
        codigoPar: $codigoPar,
        micras4: $micras4,
        micras6: $micras6,
        micras14: $micras14,
        micras21: $micras21,
        micras25: $micras25,
        micras38: $micras38,
        micras70: $micras70,
        hollin: $hollin,
        nitracion: $nitracion,
        sulfatacion: $sulfatacion,
        dilucion: $dilucion,
        glicol: $glicol,
        oxidacion: $oxidacion,
        tan: $tan,
        tbn: $tbn,
        hierro: $hierro,
        cobre: $cobre,
        aluminio: $aluminio,
        cromo: $cromo,
        plomo: $plomo,
        estano: $estano,
        niquel: $niquel,
        vanadio: $vanadio,
        titanio: $titanio,
        silicio: $silicio
        sodio: $sodio,
        potasio: $potasio,
        boro: $boro,
        magnesio: $magnesio,
        calcio: $calcio,
        fosforo: $fosforo,
        zinc: $zinc,
        molibdeno: $molibdeno,
        bario: $bario,
        manganeso: $manganeso,
        fluidez: $fluidez,
        inflamacion: $inflamacion,
        cenizas: $cenizas,
        tost: $tost,
        rpvot: $rpvot,
        metalicos: $metalicos,
        phosporus: $phosporus,
        grasa: $grasa,
        separabilidad: $separabilidad,
        abrasion: $abrasion,
        bolas: $bolas,
        huella: $huella,
        timken: $timken,
        espuma: $espuma,
        secuencia1: $secuencia1,
        secuencia2: $secuencia2,
        secuencia3: $secuencia3,
        aeroemulsion: $aeroemulsion,
        demulsibilidad: $demulsibilidad,
        emulsion: $emulsion,
        corrosion: $corrosion,
        ultracentrifuga: $ultracentrifuga,
        densidad: $densidad,
        fuego: $fuego,
        herrumbre: $herrumbre,
        destilada: $destilada,
        deMar: $deMar,
        temperatura: $temperatura,
        penetracion: $penetracion,
        goteo: $goteo,
        lavado: $lavado,
        nsf: $nsf,
        fda: $fda,
        biodegradables: $biodegradables,
        noToxico: $noToxico,
        ignifugo: $ignifugo,
        cumple: $cumple,
        salud: $salud,
        inflamabilidad: $inflamabilidad,
        reactividad: $reactividad,
        blanco: $blanco,
        pq: $pq,
        fischer: $fischer,
        tanpte: $tanpte,
        tbnpte: $tbnpte,
        tipoAct: $tipoAct,
        inventario:{
          descrEmpresa: $descrEmpresa,
          existencia: $existencia,
          minimo: $minimo,
          descrUnidad: $descrUnidad, 
          usuarioAct: $usuarioAct,
          fechaAct: $fechaAct,
        }
      }
    ){
      success
      errors{
        path
        message
      }
    }
  }
`,
deleteLubricante: gpl`
mutation($_id: ID!){
  deleteLubricante(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,
createProcEjec: gpl`
mutation($descrProcedimiento: String, $codProcedimiento: String, $nombreArchivo: String, $fechaCreate: Date){
  createProcEjec(
    procejec:{
      descrProcedimiento: $descrProcedimiento,
      codProcedimiento: $codProcedimiento,
      nombreArchivo: $nombreArchivo,
      fechaCreate: $fechaCreate,
    }
  ){
    success
    _id
    errors{
      path
      message
    }
  }
}
`,
editProcEjec: gpl`
  mutation($_id: ID, $descrProcedimiento: String, $codProcedimiento: String, $codProcedimientoAnt: String, 
  $nombreArchivo: String, $nombreArchivoAnt: String, $modArch1: String){
    editProcEjec(
      procejec:{
        _id: $_id,
        descrProcedimiento: $descrProcedimiento,
        codProcedimiento: $codProcedimiento,
        codProcedimientoAnt: $codProcedimientoAnt,
        nombreArchivo: $nombreArchivo,
        nombreArchivoAnt: $nombreArchivoAnt,
        modArch1: $modArch1
      }
    ){
      success
      errors{
        path
        message
      }                
    }
  }
`,
deleteProcEjec: gpl`
  mutation($_id: ID!, $descrProcedimiento: String, $nombreArchivo: String){
    deleteProcEjec(
        _id: $_id
        descrProcedimiento: $descrProcedimiento
        nombreArchivo: $nombreArchivo
    ){
    success
    errors{
        path
        message
        }                
    }
  }
`,
createInfoTarea: gpl`
mutation($descrInfoTarea: String, $codInfoTarea: String, $nombreArchivoInfo: String, $fechaCreate: Date){
  createInfoTarea(
    infotarea:{
      descrInfoTarea: $descrInfoTarea,
      codInfoTarea: $codInfoTarea,
      nombreArchivoInfo: $nombreArchivoInfo,
      fechaCreate: $fechaCreate,
    }
  ){
    success
    _id
    errors{
      path
      message
    }
  }
}
`,
editInfoTarea: gpl`
  mutation($_id: ID, $descrInfoTarea: String, $codInfoTarea: String, $codInfoTareaAnt: String, $nombreArchivoInfo: String,){
    editInfoTarea(
      infotarea:{
        _id: $_id,
        descrInfoTarea: $descrInfoTarea,
        codInfoTarea: $codInfoTarea,
        nombreArchivoInfo: $nombreArchivoInfo,
        codInfoTareaAnt: $codInfoTareaAnt
      }
    ){
      success
      errors{
        path
        message
      }                
    }
  }
`,
deleteInfoTarea: gpl`
  mutation($_id: ID!, $codInfoTarea: String){
    deleteInfoTarea(
        _id: $_id,
        codInfoTarea: $codInfoTarea
    ){
    success
    errors{
        path
        message
        }                
    }
  }
`,
createPrueba: gpl`
  mutation($tipoPrueba: String, $descrPrueba: String, $unidad: String, $validacion: String, 
    $codNorma: String, $descrNorma: String, $campoBD: String, $descrArchivo: String, 
    $tipoProblema: String, $descripcion: String, $metodo: String, 
    $analisisCon: String,
    $analisisPre: String,
    $analisisAla: String,
    $analisisPel: String,
    $recomenCon: String,
    $recomenPre: String,
    $recomenAla: String,
    $recomenPel: String,
    $fechaCreate: Date){
    createPrueba(
      prueba:{
        tipoPrueba: $tipoPrueba,
        descrPrueba: $descrPrueba,
        unidad: $unidad,
        validacion: $validacion,
        codNorma: $codNorma,
        descrNorma: $descrNorma,
        campoBD: $campoBD,
        descrArchivo: $descrArchivo,
        tipoProblema: $tipoProblema,
        descripcion: $descripcion,
        metodo: $metodo,
        analisisCon: $analisisCon,
        analisisPre: $analisisPre,
        analisisAla: $analisisAla,
        analisisPel: $analisisPel,
        recomenCon: $recomenCon,
        recomenPre: $recomenPre,
        recomenAla: $recomenAla,
        recomenPel: $recomenPel,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editPrueba: gpl`
mutation($_id: ID, $tipoPrueba: String, $descrPrueba: String, $unidad: String, $validacion: String, 
  $codNorma: String, $descrNorma: String, $campoBD: String, $descrArchivo: String, $tipoProblema: String, 
  $descripcion: String, $metodo: String, 
  $analisisCon: String,
  $analisisPre: String,
  $analisisAla: String,
  $analisisPel: String,
  $recomenCon: String,
  $recomenPre: String,
  $recomenAla: String,
  $recomenPel: String,  $descrAplicacion: String, $valor1Alarma: Number, $valor2Alarma: Number, $valor3Alarma: Number, 
  $valor1Corte: Number, $valor2Corte: Number, $valor3Corte: Number, $fechaCreate: Date, $tipoAct: String){
  editPrueba(
    prueba:{
      _id: $_id,
      tipoPrueba: $tipoPrueba,
      descrPrueba: $descrPrueba,
      unidad: $unidad,
      validacion: $validacion,
      codNorma: $codNorma,
      descrNorma: $descrNorma,
      campoBD: $campoBD,
      descrArchivo: $descrArchivo,
      tipoProblema: $tipoProblema,
      descripcion: $descripcion,
      metodo: $metodo,
      analisisCon: $analisisCon,
      analisisPre: $analisisPre,
      analisisAla: $analisisAla,
      analisisPel: $analisisPel,
      recomenCon: $recomenCon,
      recomenPre: $recomenPre,
      recomenAla: $recomenAla,
      recomenPel: $recomenPel,
      tipoAct: $tipoAct,
      pruebaslab:{
        descrAplicacion: $descrAplicacion,
        valor1Alarma: $valor1Alarma,
        valor2Alarma: $valor2Alarma,
        valor3Alarma: $valor3Alarma,
        valor1Corte: $valor1Corte,
        valor2Corte: $valor2Corte,
        valor3Corte: $valor3Corte,      
        fechaCreate: $fechaCreate,
      },
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
deletePrueba: gpl`
mutation($_id: ID!){
  deletePrueba(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,
createMecValRef: gpl`
  mutation($descrEmpresa: String, $descrPlanta: String, $descrSeccion: String, $descrEquipo: String, 
    $descrComponente: String, $descrMecanismo: String, $descrAplicacion: String, $fechaCreate: Date){
    createMecValRef(
      mecvalref:{
        descrEmpresa: $descrEmpresa,
        descrPlanta: $descrPlanta,
        descrSeccion: $descrSeccion,
        descrEquipo: $descrEquipo,
        descrComponente: $descrComponente,
        descrMecanismo: $descrMecanismo,
        descrAplicacion: $descrAplicacion,
        fechaCreate: $fechaCreate,
      }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
`,
editMecValRef: gpl`
  mutation($_id: ID, $descrEmpresa: String, $descrPlanta: String, $descrSeccion: String, 
  $descrEquipo: String, $descrComponente: String, $descrMecanismo: String, $descrAplicacion: String, $tipoAct: String, 
  $descrPrueba: String, $tipoPrueba: String, $validacion: String, $valor1Alarma: Number, $valor2Alarma: Number, $valor3Alarma: Number, 
  $valor1Corte: Number, $valor2Corte: Number, $valor3Corte: Number){
  editMecValRef(
    mecvalref:{
      _id: $_id,
      descrEmpresa: $descrEmpresa,
      descrPlanta: $descrPlanta,
      descrSeccion: $descrSeccion,
      descrEquipo: $descrEquipo,
      descrComponente: $descrComponente,
      descrMecanismo: $descrMecanismo,
      descrAplicacion: $descrAplicacion,
      tipoAct: $tipoAct,
      pruebaslab:{
        descrPrueba: $descrPrueba,
        tipoPrueba: $tipoPrueba,
        validacion: $validacion,
        valor1Alarma: $valor1Alarma,
        valor2Alarma: $valor2Alarma,
        valor3Alarma: $valor3Alarma,
        valor1Corte: $valor1Corte,
        valor2Corte: $valor2Corte,
        valor3Corte: $valor3Corte,  
      },
    }
  ){
    success
    errors{
      path
      message
    }
  }
}
`,
editMecValRefVR: gpl`
    mutation($mecvalref: [iMecValRefUpd2]){
      editMecValRefVR(
        mecvalref: $mecvalref
      ){
        success
        errors{
          path
          message
        }                
      }
    }
`,
deleteMecValRef: gpl`
mutation($_id: ID!){
  deleteMecValRef(
    _id: $_id
  ){
  success
  errors{
    path
    message
    }                
  }
}
`,
createPlantaMany: gpl`
mutation($planta: [iPlantaMany]){
  createPlantaMany(
      planta: $planta
    ){
        success
        errors{
            path
            message
            }                
        }
    }
    `,
    createPlanta: gpl`
    mutation($codPlanta: String!, $descrPlanta: String!, $descrEmpresa: String!){
      createPlanta(
        planta:{
            codPlanta: $codPlanta,
            descrPlanta: $descrPlanta
            descrEmpresa: $descrEmpresa
        }
    ){
      success
      _id
      errors{
        path
        message
      }
    }
  }
  `,
  editPlanta: gpl`
    mutation($_id: ID!, $descrPlanta: String!, $descrPlantaAnt: String, $codPlanta: String, $descrEmpresa: String){
      editPlanta(
        planta:{
            _id: $_id,
            descrPlanta: $descrPlanta,
            descrPlantaAnt: $descrPlantaAnt
            codPlanta: $codPlanta
            descrEmpresa: $descrEmpresa
        }
    ){
    success
    errors{
        path
        message
        }                
    }
  }
  `,
  deletePlanta: gpl`
    mutation($_id: ID!){
      deletePlanta(
          _id: $_id
        ){
          success
          errors{
            path
            message
        }                
      }
    }
  `,
  editPlantaEstructura: gpl`
    mutation($planta: [iPlantaUpdSeccion]){
      editPlantaEstructura(
        planta: $planta
      ){
        success
        errors{
          path
          message
        }                
      }
    }
  `,
  editPlantaUpdSeccion: gpl` 
      mutation($_id: ID,
          $descrEmpresa: String,
          $codPlanta: String, $descrPlanta: String,
          $codSeccion: String, $descrSeccion: String, $nombre: String, $fechaCreateSeccion: Date, $usuarioCreateSeccion: String,
          $codEquipo: String, $descrEquipo: String, $numCarta: Number, $descrPrograma: String, $nombreUsuario: String, $cedula: String, 
          $acumulado: Number, $fechaAcum: Date, $usuarioAcum: String, $horasKmPorDia: Number, $fechaCreateEquipo: Date, $usuarioCreateEquipo: String,
          $codComponente: String, $descrComponente: String, $fechaCreateComponente: Date, $usuarioCreateComponente: String,
          $nombreImagen: String, $archImagen: String, $anchoImagen: Number, $altoImagen: Number, $ordenImagen: Number,
          $nombreDoc: String, $fechaCreateImagen: Date, $usuarioCreateImagen: String,
          $codMecanismo: String, 
          $codigoQR: String,
          $descrMecanismo: String, 
          $estado: String, 
          $ultInforme: Number, 
          $nomArchivo: String,
          $descrSeccionAnt: String,
          $descrEquipoAnt: String,
          $descrComponenteAnt: String,
          $descrMecanismoAnt: String,
          $claseLub: String,
          $descrFabricante: String,
          $descrLubricante: String,
          $categoriaLub: String,
          $tipoLub: String,
          $tipoGrado: String,
          $descrGrado: String,
          $colorGrado: String,
          $colorTexto: String,
          $apiSAE: String,
          $isoGrasa: String,
          $isoGrasaColor: String,
          $isoGrasaTexto: String,
          $descrUtilidad: String,
          $descrAplicacion: String,
          $colorAplicacion: String,
          $tipoFrecuencia: String,
          $abrevUnidadTF: String,
          $cantidadTotal: Number,
          $descrUnidad: String,
          $abrevUnidad: String,
          $enInfLabNuevo: Boolean,
          $fechaCreateMecanismo: Date, $usuarioCreateMecanismo: String,
          $consecutivo: Number,
          $cantidad: Number,
          $puntosLub: Number,
          $minutos: Number,
          $descrUnidadProg: String,
          $descrMetodo: String,
          $descrTarea: String,
          $modoTarea: String,
          $requiereSISO: String,
          $descrMetodoAnt: String,
          $descrTareaAnt: String,
          $descrFrecuencia: String,
          $descrFrecuenciaPre: String,
          $codProcedimiento: String,
          $nombreArchivo: String,
          $descrInfoTarea: String,
          $codInfoTarea: String,
          $nombreArchivoInfo: String,
          $fechaUlt: String,
          $fechaProx: String,
          $acumUlt: Number,
          $acumProx: Number,          
          $archRotulo: String,
          $enRuta: String,
          $ultObservacion: String,
          $activo: String,
          $estadoTarea: String,
          $fechaCreateProg: Date, $usuarioCreateProg: String,
          $tipoAct: String){
          editPlantaUpdSeccion(planta:{
              _id: $_id,
              descrEmpresa: $descrEmpresa,
              codPlanta: $codPlanta,
              descrPlanta: $descrPlanta,
              descrSeccionAnt: $descrSeccionAnt
              descrEquipoAnt: $descrEquipoAnt
              descrComponenteAnt: $descrComponenteAnt
              descrMecanismoAnt: $descrMecanismoAnt
              descrMetodoAnt: $descrMetodoAnt,
              descrTareaAnt: $descrTareaAnt,
              tipoAct: $tipoAct,
              secciones:{
                  codSeccion: $codSeccion,
                  descrSeccion: $descrSeccion,
                  fechaCreate: $fechaCreateSeccion,
                  usuarioCreate: $usuarioCreateSeccion,
                  equipos:{
                      codEquipo: $codEquipo,
                      descrEquipo: $descrEquipo,
                      numCarta: $numCarta,
                      descrPrograma: $descrPrograma,
                      nombreUsuario: $nombreUsuario,
                      cedula: $cedula,
                      acumulado: $acumulado,
                      fechaAcum: $fechaAcum, 
                      usuarioAcum: $usuarioAcum,
                      horasKmPorDia: $horasKmPorDia,
                      fechaCreate: $fechaCreateEquipo,
                      usuarioCreate: $usuarioCreateEquipo,
                      componentes:{
                          codComponente: $codComponente,
                          descrComponente: $descrComponente,
                          fechaCreate: $fechaCreateComponente,
                          usuarioCreate: $usuarioCreateComponente,
                          mecanismos:{
                            codMecanismo: $codMecanismo,
                            codigoQR: $codigoQR,
                            descrMecanismo: $descrMecanismo,
                            estado: $estado,
                            ultInforme: $ultInforme,
                            nomArchivo: $nomArchivo,
                            claseLub: $claseLub,
                            descrFabricante: $descrFabricante,
                            descrLubricante: $descrLubricante,
                            categoriaLub: $categoriaLub,
                            tipoLub: $tipoLub,
                            tipoGrado: $tipoGrado,
                            descrGrado: $descrGrado,
                            colorGrado: $colorGrado,
                            colorTexto: $colorTexto,
                            apiSAE: $apiSAE,
                            isoGrasa: $isoGrasa,
                            isoGrasaColor: $isoGrasaColor,
                            isoGrasaTexto: $isoGrasaTexto,
                            descrUtilidad: $descrUtilidad,
                            descrAplicacion: $descrAplicacion,
                            colorAplicacion: $colorAplicacion,
                            tipoFrecuencia: $tipoFrecuencia,
                            abrevUnidadTF: $abrevUnidadTF,
                            cantidadTotal: $cantidadTotal,
                            descrUnidad: $descrUnidad,
                            abrevUnidad: $abrevUnidad,
                            enInfLabNuevo: $enInfLabNuevo,
                            fechaCreate: $fechaCreateMecanismo,
                            usuarioCreate: $usuarioCreateMecanismo,
                            programacion:{
                              consecutivo: $consecutivo,
                              cantidad: $cantidad,
                              puntosLub: $puntosLub,
                              minutos: $minutos,
                              descrUnidad: $descrUnidadProg
                              descrMetodo: $descrMetodo,
                              descrTarea: $descrTarea,
                              modoTarea: $modoTarea,
                              requiereSISO: $requiereSISO,
                              descrFrecuencia: $descrFrecuencia,
                              descrFrecuenciaPre: $descrFrecuenciaPre,
                              codProcedimiento: $codProcedimiento,
                              nombreArchivo: $nombreArchivo,
                              codInfoTarea:  $codInfoTarea,
                              descrInfoTarea: $descrInfoTarea,
                              nombreArchivoInfo: $nombreArchivoInfo,
                              fechaUlt: $fechaUlt,
                              fechaProx: $fechaProx,
                              acumUlt: $acumUlt,
                              acumProx: $acumProx,
                              archRotulo: $archRotulo,
                              enRuta: $enRuta,
                              ultObservacion: $ultObservacion,
                              activo: $activo,
                              estadoTarea: $estadoTarea,
                              fechaCreate: $fechaCreateProg,
                              usuarioCreate: $usuarioCreateProg,  
                            }
                          }
                      }
                      imagenes:{
                        nombreImagen: $nombreImagen,
                        archImagen: $archImagen,
                        anchoImagen: $anchoImagen,
                        altoImagen: $altoImagen,    
                        ordenImagen: $ordenImagen,                  
                        fechaCreate: $fechaCreateImagen,
                        usuarioCreate: $usuarioCreateImagen,  
                      }
                      documentos:{
                        nombreDoc: $nombreDoc,
                        fechaCreate: $fechaCreateImagen,
                        usuarioCreate: $usuarioCreateImagen,  
                      }
                  }
                  imagen:{
                    nombre: $nombre,
                  }
              }
          }){
          success
          errors{
              path
              message
              }                
          }
      }
  `,
  deletePlantaUpdSeccion: gpl`
      mutation($_id: ID!, $descrPlanta: String, $descrSeccion: String, $descrEquipo: String, $nombre: String, 
          $descrComponente: String, $nombreImagen: String, $nombreDoc: String, $descrMecanismo: String, $tipoAct: String){
              deletePlantaUpdSeccion(planta:{
                  _id: $_id,
                  descrPlanta: $descrPlanta,
                  tipoAct: $tipoAct,
                  secciones:{
                      descrSeccion: $descrSeccion,
                      equipos:{
                          descrEquipo: $descrEquipo,
                          componentes:{
                              descrComponente: $descrComponente,
                              mecanismos:{
                                descrMecanismo: $descrMecanismo,
                                programacion:{
                                  descrMetodo: $descrMetodo,
                              }
                            }                          
                          }
                          imagenes:{
                            nombreImagen: $nombreImagen
                          }
                          documentos:{
                            nombreDoc: $nombreDoc
                          }
                      }
                      imagen:{
                        nombre: $nombre
                      }
                  }
              }){
              success
              errors{
                  path
                  message
                  }                
              }
          }
          `,
createInflab: gpl`
mutation(
  $estadoInflab: String,
  $estadoEnvio: String,
  $numeroInflab: Number,
  $mecInflab: Number,
  $prioridad: String,
  $ruta: Number,
  $numeroOrden: Number,
  $ordenSAP: String,
  $descrEmpresa: String,
  $nombreUsuario: String,
  $email: String,
  $telefono: String,
  $codPlanta: String
  $descrPlanta: String
  $codSeccion: String
  $descrSeccion: String
  $codEquipo: String
  $descrEquipo: String
  $descrPrograma: String
  $codComponente: String
  $descrComponente: String
  $codMecanismo: String
  $descrMecanismo: String,
  $descrAplicacion: String,
  $descrFabricante: String,
  $descrLubricante: String,
  $tipoLub: String,
  $tipoGrado: String,
  $descrGrado: String,
  $apiSAE: String,
  $tipoFrecuencia: String,
  $abrevUnidadTF: String,
  $abrevUnidad: String,
  $aceiteTotal: Number,
  $aceiteRep: Number,
  $fechaMuestra: String,
  $tomaMuestra: String,
  $ultimoCambio: String,
  $cambioFiltroAc: String,
  $cambioFiltroAire: String,
  $fechaCreate: Date,
  $usuarioCreate: String,
){
  createInflab(
    inflab:{
      estadoInflab: $estadoInflab,
      estadoEnvio: $estadoEnvio,
      numeroInflab: $numeroInflab,
      mecInflab: $mecInflab,
      prioridad: $prioridad,
      ruta: $ruta,
      numeroOrden: $numeroOrden,
      ordenSAP: $ordenSAP,
      descrEmpresa: $descrEmpresa,
      nombreUsuario: $nombreUsuario,
      email: $email,
      telefono: $telefono,
      codPlanta: $codPlanta,
      descrPlanta: $descrPlanta,
      codSeccion: $codSeccion,
      descrSeccion: $descrSeccion,
      codEquipo: $codEquipo,
      descrEquipo: $descrEquipo,
      descrPrograma: $descrPrograma,
      codComponente: $codComponente,
      descrComponente: $descrComponente,
      codMecanismo: $codMecanismo,
      descrMecanismo: $descrMecanismo,
      descrAplicacion: $descrAplicacion,
      descrFabricante: $descrFabricante,
      descrLubricante: $descrLubricante,
      tipoLub: $tipoLub,
      tipoGrado: $tipoGrado,
      descrGrado: $descrGrado,
      apiSAE: $apiSAE,
      tipoFrecuencia: $tipoFrecuencia,
      abrevUnidadTF: $abrevUnidadTF,
      abrevUnidad: $abrevUnidad,
      aceiteTotal: $aceiteTotal,
      aceiteRep: $aceiteRep,
      fechaMuestra: $fechaMuestra,
      tomaMuestra: $tomaMuestra,
      ultimoCambio: $ultimoCambio,
      cambioFiltroAc: $cambioFiltroAc,
      cambioFiltroAire: $cambioFiltroAire,
      fechaCreate: $fechaCreate,
      usuarioCreate: $usuarioCreate
    }
  ){
    success
    _id
    errors{
      path
      message
    }
  }
}
`,
editInflabMany: gpl`
  mutation($inflab: [iInflabUpdRep]){
    editInflabMany(
      inflab: $inflab
    )
    {
      success
      errors{
        path
        message
      }                
    }
  }
`,
editInflab: gpl`
  mutation($_id: ID, $estadoInflab: String, $numeroInflab: Number, $mecInflab: Number, 
    $estadoEnvio: String,
    $fechaEnvioLab: Date,
    $usuarioEnvioLab: String,
    $fechaRecibeLab: Date,
    $usuarioRecibeLab: String,
    $fechaEnvioCliente: Date,
    $usuarioEnvioCliente: String,
    $prioridad: String,
    $ordenSAP: String,
    $numOrdenCompra: String,
    $estado: String,
    $descrPrograma: String,
    $fechaMuestra: String,
    $tomaMuestra: String,
    $ultimoCambio: String,
    $recorrido: Number,
    $cambioFiltroAc: String,
    $cambioFiltroAire: String,
    $aceiteRep: Number,
    $aceiteTotal: Number,
    $visco40: Number,
    $visco100: Number,
    $indice: Number,
    $agua: Number,
    $codigoPar: String,
    $micras4: Number,
    $micras6: Number,
    $micras14: Number,
    $micras21: Number,
    $micras25: Number,
    $micras38: Number,
    $micras70: Number,
    $hollin: Number,
    $nitracion: Number,
    $sulfatacion: Number,
    $dilucion: Number,
    $glicol: Number,
    $oxidacion: Number,
    $tan: Number,
    $tbn: Number,
    $hierro: Number,
    $cobre: Number,
    $aluminio: Number,
    $cromo: Number,
    $plomo: Number,
    $estano: Number,
    $niquel: Number,
    $vanadio: Number,
    $titanio: Number,
    $silicio: Number,
    $sodio: Number,
    $potasio: Number,
    $boro: Number,
    $magnesio: Number,
    $calcio: Number,
    $fosforo: Number,
    $zinc: Number,
    $molibdeno: Number,
    $bario: Number,
    $manganeso: Number,   
    $color: Number,
    $rulerP: Number,
    $rulerA: Number,
    $rulerF: Number,
    $rulerZ: Number,
    $rpvot: Number,
    $barniz: Number,
    $demulsibilidadA: Number,
    $demulsibilidadAg: Number,
    $demulsibilidadE: Number,
    $demulsibilidadT: Number,
    $separaA54: Number,
    $separaAg54: Number,
    $separaE54: Number,
    $separaT54: Number,
    $separaA82: Number,
    $separaAg82: Number,
    $separaE82: Number,
    $separaT82: Number,
    $espumas1_0: Number,
    $espumas1_10: Number,
    $espumas2_0: Number,
    $espumas2_10: Number,
    $espumas3_0: Number,
    $espumas3_10: Number,
    $liberacion: Number,
    $inflamacion: Number,
    $corrosion: String,
    $ultracentrifuga: Number,    
    $densidad: Number,
    $pq: Number,
    $fischer: Number,
    $tanpte: Number,
    $tbnpte: Number,
    $pqV: String,
    $fischerV: String,
    $tanpteV: String,
    $tbnpteV: String,
    $pqE: String,
    $fischerE: String,
    $tanpteE: String,
    $tbnpteE: String,
    $visco40E: String,
    $visco100E: String,
    $indiceE: String,
    $aguaE: String,
    $codigoParE: String,
    $micras4E: String,
    $micras6E: String,
    $micras14E: String,
    $micras21E: String,
    $micras25E: String,
    $micras38E: String,
    $micras70E: String,
    $hollinE: String,
    $nitracionE: String,
    $sulfatacionE: String,
    $dilucionE: String,
    $glicolE: String,
    $oxidacionE: String,
    $tanE: String,
    $tbnE: String,
    $hierroE: String,
    $cobreE: String,
    $aluminioE: String,
    $cromoE: String,
    $plomoE: String,
    $estanoE: String,
    $niquelE: String,
    $vanadioE: String,
    $titanioE: String,
    $silicioE: String,
    $sodioE: String,
    $potasioE: String,
    $boroE: String,
    $magnesioE: String,
    $calcioE: String,
    $fosforoE: String,
    $zincE: String,
    $molibdenoE: String,
    $barioE: String,
    $manganesoE: String, 
    $colorE: String,
    $rulerPE: String,
    $rulerAE: String,
    $rulerFE: String,
    $rulerZE: String,
    $rpvotE: String,
    $barnizE: String,
    $demulsibilidadAE: String,
    $demulsibilidadAgE: String,
    $demulsibilidadEE: String,
    $demulsibilidadTE: String,
    $separaA54E: String,
    $separaAg54E: String,
    $separaE54E: String,
    $separaT54E: String,
    $separaA82E: String,
    $separaAg82E: String,
    $separaE82E: String,
    $separaT82E: String,
    $espumas1_0E: String,
    $espumas1_10E: String,
    $espumas2_0E: String,
    $espumas2_10E: String,
    $espumas3_0E: String,
    $espumas3_10E: String,
    $liberacionE: String,
    $inflamacionE: String,
    $corrosionE: String,   
    $ultracentrifugaE: String, 
    $densidadE: String,
    $apariencia: String,
    $olor: String,
    $fuego: Number,
    $aparienciaE: String,
    $olorE: String,
    $fuegoE: String,
    $visco40V: String,
    $visco100V: String,
    $indiceV: String,
    $aguaV: String,
    $codigoParV: String,
    $micras4V: String,
    $micras6V: String,
    $micras14V: String,
    $micras21V: String,
    $micras25V: String,
    $micras38V: String,
    $micras70V: String,
    $hollinV: String,
    $nitracionV: String,
    $sulfatacionV: String,
    $dilucionV: String,
    $glicolV: String,
    $oxidacionV: String,
    $tanV: String,
    $tbnV: String,
    $hierroV: String,
    $cobreV: String,
    $aluminioV: String,
    $cromoV: String,
    $plomoV: String,
    $estanoV: String,
    $niquelV: String,
    $vanadioV: String,
    $titanioV: String,
    $silicioV: String,
    $sodioV: String,
    $potasioV: String,
    $boroV: String,
    $magnesioV: String,
    $calcioV: String,
    $fosforoV: String,
    $zincV: String,
    $molibdenoV: String,
    $barioV: String,
    $manganesoV: String,
    $colorV: String,
    $rulerPV: String,
    $rulerAV: String,
    $rulerFV: String,
    $rulerZV: String,
    $rpvotV: String,
    $barnizV: String,
    $demulsibilidadAV: String,
    $demulsibilidadAgV: String,
    $demulsibilidadEV: String,
    $demulsibilidadTV: String,
    $separaA54V: String,
    $separaAg54V: String,
    $separaE54V: String,
    $separaT54V: String,
    $separaA82V: String,
    $separaAg82V: String,
    $separaE82V: String,
    $separaT82V: String,
    $espumas1_0V: String,
    $espumas1_10V: String,
    $espumas2_0V: String,
    $espumas2_10V: String,
    $espumas3_0V: String,
    $espumas3_10V: String,
    $liberacionV: String,
    $inflamacionV: String,
    $corrosionV: String,
    $ultracentrifugaV: String,
    $densidadV: String,
    $aparienciaV: String,
    $olorV: String,
    $fuegoV: String,
    $observaciones: String,
    $observacionesLab: String,
    $acciones: String,
    $inf1: String,
    $inf2: String,
    $inf3: String,
    $est1: String,
    $est2: String,
    $est3: String,
    $fab1: String,
    $fab2: String,
    $fab3: String,
    $lub1: String,
    $lub2: String,
    $lub3: String,
    $gra1: String,
    $gra2: String,
    $gra3: String,
    $mue1: String,
    $mue2: String,
    $mue3: String,
    $ult1: String,
    $ult2: String,
    $ult3: String,
    $rec1: String,
    $rec2: String,
    $rec3: String,
    $fil1: String,
    $fil2: String,
    $fil3: String,
    $aire1: String,
    $aire2: String,
    $aire3: String,
    $rep1: String,
    $rep2: String,
    $rep3: String,
    $tot1: String,
    $tot2: String,
    $tot3: String,
    $fec1: String,
    $fec2: String,
    $fec3: String,
    $fecEnv1: String,
    $fecEnv2: String,
    $fecEnv3: String,
    $fecRec1: String,
    $fecRec2: String,
    $fecRec3: String,
    $fecCli1: String,
    $fecCli2: String,
    $fecCli3: String,
    $diasEnt: String,
    $diasLog: String,
    $diasEnt1: String,
    $diasLog1: String,
    $diasEnt2: String,
    $diasLog2: String,
    $diasEnt3: String,
    $diasLog3: String,
    $nomArchivo: String,
    $nomArchivoAnt: String,
    $tipoAct: String,
    $columna1: String,
    $columna2: String,
    $columna3: String,
    $columna4: String,
    $columna5: String,
    $columna6: String,
    $columna7: String,
    $columna8: String,
    $columna9: String,
    $columna10: String,
    $columna11: String,
    $columna12: String,
    $columna13: String,
    $columna14: String,
    $columna15: String,
    $columna16: String,
    $columna17: String,
    $columna18: String,
    $columna19: String,
    $columna20: String,
    $columna21: String,
    $columna22: String,
    $columna23: String,
    $columna24: Number,
    $columna25: String,
    $columna26: Number,
    $columna27: String,
    $columna28: String,
    $columna29: String,
    $columna30: String,
  ){
    editInflab(
      inflab:{
        _id: $_id,
        estadoInflab: $estadoInflab,
        estadoEnvio: $estadoEnvio,
        fechaEnvioLab: $fechaEnvioLab,
        usuarioEnvioLab: $usuarioEnvioLab,
        fechaRecibeLab: $fechaRecibeLab,
        usuarioRecibeLab: $usuarioRecibeLab,
        fechaEnvioCliente: $fechaEnvioCliente,
        usuarioEnvioCliente: $usuarioEnvioCliente,
        numeroInflab: $numeroInflab,
        mecInflab: $mecInflab,
        prioridad: $prioridad,
        ordenSAP: $ordenSAP,
        numOrdenCompra: $numOrdenCompra,
        estado: $estado,
        descrPrograma: $descrPrograma,
        fechaMuestra: $fechaMuestra,
        tomaMuestra: $tomaMuestra,
        ultimoCambio: $ultimoCambio,
        recorrido: $recorrido,
        cambioFiltroAc: $cambioFiltroAc,
        cambioFiltroAire: $cambioFiltroAire,
        aceiteRep: $aceiteRep,
        aceiteTotal: $aceiteTotal,
        visco40: $visco40,
        visco100: $visco100,
        indice: $indice,
        agua: $agua,
        codigoPar: $codigoPar,
        micras4: $micras4,
        micras6: $micras6,
        micras14: $micras14,
        micras21: $micras21,
        micras25: $micras25,
        micras38: $micras38,
        micras70: $micras70,
        hollin: $hollin,
        nitracion: $nitracion,
        sulfatacion: $sulfatacion,
        dilucion: $dilucion,
        glicol: $glicol,
        oxidacion: $oxidacion,
        tan: $tan,
        tbn: $tbn,
        hierro: $hierro,
        cobre: $cobre,
        aluminio: $aluminio,
        cromo: $cromo,
        plomo: $plomo,
        estano: $estano,
        niquel: $niquel,
        vanadio: $vanadio,
        titanio: $titanio,
        silicio: $silicio,
        sodio: $sodio,
        potasio: $potasio,
        boro: $boro,
        magnesio: $magnesio,
        calcio: $calcio,
        fosforo: $fosforo,
        zinc: $zinc,
        molibdeno: $molibdeno,
        bario: $bario,
        manganeso: $manganeso,
        color: $color,
        rulerP: $rulerP,
        rulerA: $rulerA,
        rulerF: $rulerF,
        rulerZ: $rulerZ,
        rpvot: $rpvot,
        barniz: $barniz,
        demulsibilidadA: $demulsibilidadA,
        demulsibilidadAg: $demulsibilidadAg,
        demulsibilidadE: $demulsibilidadE,
        demulsibilidadT: $demulsibilidadT,
        separaA54: $separaA54,
        separaAg54: $separaAg54,
        separaE54: $separaE54,
        separaT54: $separaT54,
        separaA82: $separaA82,
        separaAg82: $separaAg82,
        separaE82: $separaE82,
        separaT82: $separaT82,
        espumas1_0: $espumas1_0,
        espumas1_10: $espumas1_10,
        espumas2_0: $espumas2_0,
        espumas2_10: $espumas2_10,
        espumas3_0: $espumas3_0,
        espumas3_10: $espumas3_10,
        liberacion: $liberacion,
        inflamacion: $inflamacion,
        corrosion: $corrosion,  
        ultracentrifuga: $ultracentrifuga,  
        densidad: $densidad,  
        pq: $pq,
        fischer: $fischer,
        tanpte: $tanpte,
        tbnpte: $tbnpte,
        pqE: $pqE,
        fischerE: $fischerE,
        tanpteE: $tanpteE,
        tbnpteE: $tbnpteE,  
        pqV: $pqV,
        fischerV: $fischerV,
        tanpteV: $tanpteV,
        tbnpteV: $tbnpteV,
        visco40E: $visco40E,
        visco100E: $visco100E,
        indiceE: $indiceE,
        aguaE: $aguaE,
        codigoParE: $codigoParE,
        micras4E: $micras4E,
        micras6E: $micras6E,
        micras14E: $micras14E,
        micras21E: $micras21E,
        micras25E: $micras25E,
        micras38E: $micras38E,
        micras70E: $micras70E,
        hollinE: $hollinE,
        nitracionE: $nitracionE,
        sulfatacionE: $sulfatacionE,
        dilucionE: $dilucionE,
        glicolE: $glicolE,
        oxidacionE: $oxidacionE,
        tanE: $tanE,
        tbnE: $tbnE,
        hierroE: $hierroE,
        cobreE: $cobreE,
        aluminioE: $aluminioE,
        cromoE: $cromoE,
        plomoE: $plomoE,
        estanoE: $estanoE,
        niquelE:$ niquelE,
        vanadioE: $vanadioE,
        titanioE: $titanioE,
        silicioE: $silicioE,
        sodioE: $sodioE,
        potasioE: $potasioE,
        boroE: $boroE,
        magnesioE: $magnesioE,
        calcioE: $calcioE,
        fosforoE: $fosforoE,
        zincE: $zincE,
        molibdenoE: $molibdenoE,
        barioE: $barioE,
        manganesoE: $manganesoE,
        colorE: $colorE,
        rulerPE: $rulerPE,
        rulerAE: $rulerAE,
        rulerFE: $rulerFE,
        rulerZE: $rulerZE,
        rpvotE: $rpvotE,
        barnizE: $barnizE,
        demulsibilidadAE: $demulsibilidadAE,
        demulsibilidadAgE: $demulsibilidadAgE,
        demulsibilidadEE: $demulsibilidadEE,
        demulsibilidadTE: $demulsibilidadTE,
        separaA54E: $separaA54E,
        separaAg54E: $separaAg54E,
        separaE54E: $separaE54E,
        separaT54E: $separaT54E,
        separaA82E: $separaA82E,
        separaAg82E: $separaAg82E,
        separaE82E: $separaE82E,
        separaT82E: $separaT82E,
        espumas1_0E: $espumas1_0E,
        espumas1_10E: $espumas1_10E,
        espumas2_0E: $espumas2_0E,
        espumas2_10E: $espumas2_10E,
        espumas3_0E: $espumas3_0E,
        espumas3_10E: $espumas3_10E,
        liberacionE: $liberacionE,
        inflamacionE: $inflamacionE,
        corrosionE: $corrosionE,
        ultracentrifugaE: $ultracentrifugaE,
        densidadE: $densidadE,
        apariencia: $apariencia,
        olor: $olor,
        fuego: $fuego,
        aparienciaE: $aparienciaE,
        olorE: $olorE,
        fuegoE: $fuegoE,
        visco40V: $visco40V,
        visco100V: $visco100V,
        indiceV: $indiceV,
        aguaV: $aguaV,
        codigoParV: $codigoParV,
        micras4V: $micras4V,
        micras6V: $micras6V,
        micras14V: $micras14V,
        micras21V: $micras21V,
        micras25V: $micras25V,
        micras38V: $micras38V,
        micras70V: $micras70V,
        hollinV: $hollinV,
        nitracionV: $nitracionV,
        sulfatacionV: $sulfatacionV,
        dilucionV: $dilucionV,
        glicolV: $glicolV,
        oxidacionV: $oxidacionV,
        tanV: $tanV,
        tbnV: $tbnV,
        hierroV: $hierroV,
        cobreV: $cobreV,
        aluminioV: $aluminioV,
        cromoV: $cromoV,
        plomoV: $plomoV,
        estanoV: $estanoV,
        niquelV: $niquelV,
        vanadioV: $vanadioV,
        titanioV: $titanioV,
        silicioV: $silicioV,
        sodioV: $sodioV,
        potasioV: $potasioV,
        boroV: $boroV,
        magnesioV: $magnesioV,
        calcioV: $calcioV,
        fosforoV: $fosforoV,
        zincV: $zincV,
        molibdenoV: $molibdenoV,
        barioV: $barioV,
        manganesoV: $manganesoV,
        colorV: $colorV,
        rulerPV: $rulerPV,
        rulerAV: $rulerAV,
        rulerFV: $rulerFV,
        rulerZV: $rulerZV,
        rpvotV: $rpvotV,
        barnizV: $barnizV,
        demulsibilidadAV: $demulsibilidadAV,
        demulsibilidadAgV: $demulsibilidadAgV,
        demulsibilidadEV: $demulsibilidadEV,
        demulsibilidadTV: $demulsibilidadTV,
        separaA54V: $separaA54V,
        separaAg54V: $separaAg54V,
        separaE54V: $separaE54V,
        separaT54V: $separaT54V,
        separaA82V: $separaA82V,
        separaAg82V: $separaAg82V,
        separaE82V: $separaE82V,
        separaT82V: $separaT82V,
        espumas1_0V: $espumas1_0V,
        espumas1_10V: $espumas1_10V,
        espumas2_0V: $espumas2_0V,
        espumas2_10V: $espumas2_10V,
        espumas3_0V: $espumas3_0V,
        espumas3_10V: $espumas3_10V,
        liberacionV: $liberacionV,
        inflamacionV: $inflamacionV,
        corrosionV: $corrosionV,
        ultracentrifugaV: $ultracentrifugaV,
        densidadV: $densidadV,
        aparienciaV: $aparienciaV,
        olorV: $olorV,
        fuegoV: $fuegoV,
        observaciones: $observaciones,
        observacionesLab: $observacionesLab,
        acciones: $acciones,
        inf1: $inf1,
        inf2: $inf2,
        inf3: $inf3,
        est1: $est1,
        est2: $est2,
        est3: $est3,
        fab1: $fab1,
        fab2: $fab2,
        fab3: $fab3,
        lub1: $lub1,
        lub2: $lub2,
        lub3: $lub3,
        gra1: $gra1,
        gra2: $gra2,
        gra3: $gra3,
        mue1: $mue1,
        mue2: $mue2,
        mue3: $mue3,
        ult1: $ult1,
        ult2: $ult2,
        ult3: $ult3,
        rec1: $rec1,
        rec2: $rec2,
        rec3: $rec3,
        fil1: $fil1,
        fil2: $fil2,
        fil3: $fil3,
        aire1: $aire1,
        aire2: $aire2,
        aire3: $aire3,
        rep1: $rep1,
        rep2: $rep2,
        rep3: $rep3,
        tot1: $tot1,
        tot2: $tot2,
        tot3: $tot3,
        fec1: $fec1,
        fec2: $fec2,
        fec3: $fec3,
        fecEnv1: $fecEnv1,
        fecEnv2: $fecEnv2,
        fecEnv3: $fecEnv3,
        fecRec1: $fecRec1,
        fecRec2: $fecRec2,
        fecRec3: $fecRec3,
        fecCli1: $fecCli1,
        fecCli2: $fecCli2,
        fecCli3: $fecCli3,
        diasEnt: $diasEnt,
        diasLog: $diasLog,
        diasEnt1: $diasEnt1,
        diasLog1: $diasLog1,
        diasEnt2: $diasEnt2,
        diasLog2: $diasLog2,
        diasEnt3: $diasEnt3,
        diasLog3: $diasLog3,
        nomArchivo: $nomArchivo,
        nomArchivoAnt: $nomArchivoAnt,
        tipoAct: $tipoAct,
        reportes:{
          columna1: $columna1,
          columna2: $columna2,
          columna3: $columna3,
          columna4: $columna4,
          columna5: $columna5,
          columna6: $columna6,
          columna7: $columna7,
          columna8: $columna8,
          columna9: $columna9,
          columna10: $columna10,
          columna11: $columna11,
          columna12: $columna12,
          columna13: $columna13,
          columna14: $columna14,
          columna15: $columna15,
          columna16: $columna16,
          columna17: $columna17,
          columna18: $columna18,
          columna19: $columna19,
          columna20: $columna20,
          columna21: $columna21,
          columna22: $columna22,
          columna23: $columna23,
          columna24: $columna24,
          columna25: $columna25,
          columna26: $columna26,
          columna27: $columna27,
          columna28: $columna28,
          columna29: $columna29,
          columna30: $columna30
        }
      }  
    )
    {
    success
    errors{
      path
      message
      }                
    }
  }
`,
deleteInflab: gpl`
  mutation($_id: ID!){
    deleteInflab(
          _id: $_id
      ){
          success
          errors{
              path
              message
        }                
    }
  }
`,
createOrdenMany: gpl`
mutation($orden: [iOrden]){
  createOrdenMany(
    orden: $orden
  ){
      success
      errors{
          path
          message
          }                
      }
  }
`,

createOrden: gpl`
mutation($ruta: Number,
  $fechaIni: Date,
  $fechaFin: Date,
  $estadoOrden: String,
  $numeroOrden: Number,
  $ordenSAP: String,
  $descrEmpresa: String,
  $nombreUsuario: String,
  $cedula: String,
  $mail: String,
  $telefono: String,
  $codPlanta: String,
  $descrPlanta: String,
  $codSeccion: String,
  $descrSeccion: String,
  $codEquipo: String,
  $descrEquipo: String,
  $descrPrograma: String,
  $codComponente: String,
  $descrComponente: String,
  $codMecanismo: String,
  $descrMecanismo: String,
  $codigoQR: String,
  $tipoLub: String,
  $claseLub: String,
  $descrFabricante: String,
  $descrLubricante: String,
  $descrUtilidad: String,
  $descrAplicacion: String,
  $tipoFrecuencia: String,
  $abrevUnidadTF: String,
  $cantidadTotal: Number,
  $descrUnidad: String,
  $abrevUnidad: String,
  $cantidad: Number,
  $puntosLub: Number,
  $minutos: Number,
  $descrMetodo: String,
  $descrTarea: String,
  $modoTarea: String,
  $requiereSISO: String,
  $descrHallazgo: String,
  $descrFrecuencia: String,
  $descrFrecuenciaPre: String,
  $acumulado: Number,
  $fechaUlt: String,
  $fechaProx: String,
  $acumUlt: Number,
  $acumProx: Number,
  $fechaProg: Date,
  $observaciones: String,
  $realizado: String,
  $acumReal: Number,
  $fechaReal: Date,
  $horaReal: Number,
  $cantidadReal: Number,
  $minutosReal: Number,  
  $observacionesReal: String,
  $nombreUsuarioReal: String,
  $cedulaReal: String,  
  $codProcedimiento: String,
  $nombreArchivo: String,
  $descrInfoTarea: String,
  $codInfoTarea:  String,
  $nombreArchivoInfo: String,
  $numeroInflab: Number,
  $mecInflab: Number,
  $tempAntesLub: Number,
  $tempDespuesLub: Number,
  $ultraAntesLub: Number,
  $ultraDespuesLub: Number,
  $vibraAntesLub: Number,
  $vibraDespuesLub: Number,
  $alimSistema: String,
  $imgAntes: String,
  $imgDespues: String,
  $videoAntes: String,
  $videoDespues: String,
  $fechaCreate: Date,
  $usuarioCreate: String,
  $tipoAct: String){
  createOrden(
    orden:{
      ruta: $ruta,
      fechaIni: $fechaIni,
      fechaFin: $fechaFin,
      estadoOrden: $estadoOrden,
      numeroOrden: $numeroOrden,
      ordenSAP: $ordenSAP,
      descrEmpresa: $descrEmpresa,
      nombreUsuario: $nombreUsuario,
      cedula: $cedula,
      mail: $mail,
      telefono: $telefono,
      codPlanta: $codPlanta,
      descrPlanta: $descrPlanta,
      codSeccion: $codSeccion,
      descrSeccion: $descrSeccion,
      codEquipo: $codEquipo,
      descrEquipo: $descrEquipo,
      descrPrograma: $descrPrograma,
      codComponente: $codComponente,
      descrComponente: $descrComponente,
      codMecanismo: $codMecanismo,
      descrMecanismo: $descrMecanismo,
      codigoQR: $codigoQR,
      tipoLub: $tipoLub,
      claseLub: $claseLub,
      descrFabricante: $descrFabricante,
      descrLubricante: $descrLubricante,
      descrUtilidad: $descrUtilidad,
      descrAplicacion: $descrAplicacion,
      tipoFrecuencia: $tipoFrecuencia,
      abrevUnidadTF: $abrevUnidadTF,
      cantidadTotal: $cantidadTotal,
      descrUnidad: $descrUnidad,
      abrevUnidad: $abrevUnidad,
      cantidad: $cantidad,
      puntosLub: $puntosLub,
      minutos: $minutos,
      descrMetodo: $descrMetodo,
      descrTarea: $descrTarea,
      modoTarea: $modoTarea,
      requiereSISO: $requiereSISO,
      descrHallazgo: $descrHallazgo,
      descrFrecuencia: $descrFrecuencia,
      descrFrecuenciaPre: $descrFrecuenciaPre,
      acumulado: $acumulado,
      fechaUlt: $fechaUlt,
      fechaProx: $fechaProx,
      acumUlt: $acumUlt,
      acumProx: $acumProx,
      fechaProg: $fechaProg,
      observaciones: $observaciones,
      realizado: $realizado,
      acumReal: $acumReal,
      fechaReal: $fechaReal,
      horaReal: $horaReal,
      cantidadReal: $cantidadReal,
      minutosReal: $minutosReal,  
      observacionesReal: $observacionesReal,
      nombreUsuarioReal: $nombreUsuarioReal,
      cedulaReal: $cedulaReal,  
      codProcedimiento: $codProcedimiento,
      codInfoTarea:  $codInfoTarea,
      descrInfoTarea: $descrInfoTarea,
      nombreArchivo: $nombreArchivo,
      nombreArchivoInfo: $nombreArchivoInfo,
      numeroInflab: $numeroInflab,
      mecInflab: $mecInflab,
      tempAntesLub: $tempAntesLub,
      tempDespuesLub:  $tempDespuesLub,
      ultraAntesLub: $ultraAntesLub,
      ultraDespuesLub: $ultraDespuesLub,
      vibraAntesLub: $vibraAntesLub,
      vibraDespuesLub: $vibraDespuesLub,
      alimSistema: $alimSistema,
      imgAntes: $imgAntes,
      imgDespues: $imgDespues,
      videoAntes: $videoAntes,
      videoDespues: $videoDespues,
      fechaCreate: $fechaCreate,
      usuarioCreate: $usuarioCreate,
      tipoAct: $tipoAct,
    }
  ){
    success
    _id
    errors{
      path
      message
    }
  }
}
`,
  editOrden: gpl`
    mutation($_id: ID, 
      $ruta: Number,
      $numeroOrden: Number,
      $ordenSAP: String,
      $descrEmpresa: String,
      $descrPlanta: String,
      $descrSeccion: String,
      $descrEquipo: String,
      $descrPrograma: String,
      $descrComponente: String,
      $descrMecanismo: String,
      $estadoOrden: String,
      $nombreUsuario: String,
      $cedula: String,
      $mail: String,
      $telefono: String,
      $realizado: String,
      $fechaProg: Date,
      $acumReal: Number,
      $fechaReal: Date,
      $horaReal: Number,
      $cantidadReal: Number,
      $minutosReal: Number,  
      $observacionesReal: String,
      $nombreUsuarioReal: String,
      $cedulaReal: String,
      $tipoAct: String,
      $tipoLub: String,
      $claseLub: String,
      $tempAntesLub: Number,
      $tempDespuesLub:  Number,
      $ultraAntesLub: Number,
      $ultraDespuesLub: Number,
      $vibraAntesLub: Number,
      $vibraDespuesLub: Number,
      $imgAntes: String,
      $imgDespues: String,
      $videoAntes: String,
      $videoDespues: String,
      $fechaUpd: Date,
      $usuarioUpd: String,
      $alimSistema: String,
      $descrFabricante: String,
      $descrLubricante: String,
      $codigoQR: String,
      $numeroInflab: Number,
      $mecInflab: Number,
      $descrHallazgo: String,
      $archivoInflab: String,
      $fallaLub: String,
      $archivoRCA: String,
      $tiempoFalla: Number,
      $costoFalla: Number){
      editOrden(
        orden:{
          _id: $_id, 
          ruta: $ruta,
          numeroOrden: $numeroOrden,
          ordenSAP: $ordenSAP,
          descrEmpresa: $descrEmpresa,
          descrPlanta: $descrPlanta,
          descrSeccion: $descrSeccion,
          descrEquipo: $descrEquipo,
          descrPrograma: $descrPrograma,
          descrComponente: $descrComponente,
          descrMecanismo: $descrMecanismo,
          estadoOrden: $estadoOrden,
          nombreUsuario: $nombreUsuario,
          cedula: $cedula,
          mail: $mail,
          telefono: $telefono,
          realizado: $realizado,
          fechaProg: $fechaProg,,
          acumReal: $acumReal,
          fechaReal: $fechaReal,
          horaReal: $horaReal,
          cantidadReal: $cantidadReal,
          minutosReal: $minutosReal,  
          observacionesReal: $observacionesReal,
          nombreUsuarioReal: $nombreUsuarioReal,
          cedulaReal: $cedulaReal,
          tipoAct: $tipoAct,
          tipoLub: $tipoLub,
          claseLub: $claseLub,
          tempAntesLub: $tempAntesLub,
          tempDespuesLub:  $tempDespuesLub,
          ultraAntesLub: $ultraAntesLub,
          ultraDespuesLub: $ultraDespuesLub,
          vibraAntesLub: $vibraAntesLub,
          vibraDespuesLub: $vibraDespuesLub,
          imgAntes: $imgAntes,
          imgDespues: $imgDespues,
          videoAntes: $videoAntes,
          videoDespues: $videoDespues,
          fechaUpd: $fechaUpd,
          usuarioUpd: $usuarioUpd,
          alimSistema: $alimSistema,
          descrFabricante: $descrFabricante,
          descrLubricante: $descrLubricante,
          codigoQR: $codigoQR,
          numeroInflab: $numeroInflab,
          mecInflab: $mecInflab,
          descrHallazgo: $descrHallazgo,
          archivoInflab: $archivoInflab,
          fallaLub: $fallaLub,
          archivoRCA: $archivoRCA,
          tiempoFalla: $tiempoFalla,
          costoFalla: $costoFalla,
        }
      ){
        success
        errors{
          path
          message
        }
      }
    }
    `,
    deleteOrden: gpl`
      mutation($_id: ID!){
        deleteOrden(
          _id: $_id
        ){
        success
        errors{
          path
          message
          }                
        }
      }
    `,   
  createDocumento: gpl`
    mutation($descrDocumento: String, $fechaCreate: Date){
      createDocumento(
        documento:{
          descrDocumento: $descrDocumento,
          fechaCreate: $fechaCreate,
        }
      ){
        success
        _id
        errors{
          path
          message
        }
      }
    }
  `,    
  editDocumento: gpl`
        mutation($_id: ID, $descrDocumento: String){
          editDocumento(
            documento:{
              _id: $_id,
              descrDocumento: $descrDocumento,
            }
          ){
            success
            errors{
              path
              message
            }                
          }
        }
      `,
      deleteDocumento: gpl`
        mutation($_id: ID!){
          deleteDocumento(
              _id: $_id
          ){
          success
          errors{
              path
              message
              }                
          }
        }
        `,
        createBancoprov: gpl`
          mutation($descrBancoprov: String, $fechaCreate: Date){
            createBancoprov(
              bancoprov:{
                descrBancoprov: $descrBancoprov,
                fechaCreate: $fechaCreate,
              }
            ){
              success
              _id
              errors{
                path
                message
              }
            }
          }
        `,
        editBancoprov: gpl`
          mutation($_id: ID, $descrBancoprov: String){
            editBancoprov(
              bancoprov:{
                _id: $_id,
                descrBancoprov: $descrBancoprov,
              }
            ){
              success
              errors{
                path
                message
              }                
            }
          }
        `,
        deleteBancoprov: gpl`
          mutation($_id: ID!){
            deleteBancoprov(
                _id: $_id
            ){
            success
            errors{
                path
                message
                }                
            }
          }
        `,
        createProveed: gpl`
          mutation($descrDocumento: String, $numeroDocumento: String, $descrProveed: String, $ciudad: String,
                  $direccion: String, $telefono: String, $email: String, $contacto: String, $consecCoti: Number, $fechaCreate: Date){
            createProveed(
              proveed:{
                descrDocumento: $descrDocumento,
                ciudad: $ciudad,
                direccion: $direccion,
                telefono: $telefono,
                email: $email,
                contacto: $contacto,
                consecCoti: $consecCoti,
                numeroDocumento: $numeroDocumento,
                descrProveed: $descrProveed,
                fechaCreate: $fechaCreate,
              }
            ){
              success
              _id
              errors{
                path
                message
              }
            }
          }
        `,
        editProveed: gpl`
          mutation($_id: ID, $descrDocumento: String, $numeroDocumento: String, $descrProveed: String, 
            $ciudad: String, $direccion: String, $telefono: String, $email: String, $contacto: String, $consecCoti: Number, $tipoAct: String, 
            $descrProveedAnt: String, $numeroDocumentoAnt: String){
            editProveed(
              proveed:{
                _id: $_id,
                descrDocumento: $descrDocumento,
                numeroDocumento: $numeroDocumento,
                descrProveed: $descrProveed,
                ciudad: $ciudad,
                direccion: $direccion,
                telefono: $telefono,
                email: $email,
                contacto: $contacto,
                consecCoti: $consecCoti, 
                tipoAct: $tipoAct,
                descrProveedAnt: $descrProveedAnt,
                numeroDocumentoAnt: $numeroDocumentoAnt, 
              }
            ){
              success
              errors{
                path
                message
              }
            }
          }
        `,
        deleteProveed: gpl`
          mutation($_id: ID!){
            deleteProveed(
              _id: $_id
            ){
            success
            errors{
              path
              message
              }                
            }
          }
        `,
        createProducto: gpl`
        mutation($tipoProducto: String, $descrProducto: String, $descrCorta: String, $marca: String, $ficha: String, $ficha2: String, $tipoOrden: String,
          $precio: Number, $vigenteHasta: Date, $numProducto: Number, $descrUnidad: String, $porcIVA: Number, $fechaCreate: Date, $descrLubricante: String, 
          $costo: Number, $margen: Number, $monedaCosto: String, $codigo: String, $estado: String, $precioDolar: Number, 
          $comisionRango1: Number,
          $comisionRango2: Number,
          $comisionRango3: Number, $comisionExt: Number){
          createProducto(
            producto:{
              tipoProducto: $tipoProducto,
              descrProducto: $descrProducto,
              descrCorta: $descrCorta,
              marca: $marca,
              ficha: $ficha,
              ficha2: $ficha2,
              tipoOrden: $tipoOrden,
              precio: $precio,
              precioDolar: $precioDolar,
              vigenteHasta: $vigenteHasta,
              numProducto: $numProducto,
              descrUnidad: $descrUnidad, 
              porcIVA: $porcIVA,
              fechaCreate: $fechaCreate,
              descrLubricante: $descrLubricante,
              estado: $estado,
              costo: $costo,
              monedaCosto: $monedaCosto,
              margen: $margen,
              codigo: $codigo,
              comisionRango1: $comisionRango1,
              comisionRango2: $comisionRango2,
              comisionRango3: $comisionRango3,
              comisionExt: $comisionExt
            }
          ){
            success
            _id
            errors{
              path
              message
            }
          }
        }
      `,
      editProducto: gpl` 
        mutation($_id: ID, $tipoProducto: String, $descrProducto: String, $descrCorta: String, $marca: String, $descrLubricante: String, $numProducto: Number, 
          $ficha: String, $ficha2: String, $modArch1: String, $modArch2: String, $precio: Number, $vigenteHasta: Date, $precioDolar: Number, 
          $descrUnidad: String, $porcIVA: Number, $porcImpto: Number, $tipoOrden: String, $descrProductoAnt: String, $estado: String,
          $costo: Number, $margen: Number, $monedaCosto: String, $codigo: String,
          $comisionRango1: Number,
          $comisionRango2: Number,
          $comisionRango3: Number, $comisionExt: Number){
          editProducto(
            producto:{
              _id: $_id,
              tipoProducto: $tipoProducto,
              descrProducto: $descrProducto,
              descrCorta: $descrCorta,
              marca: $marca,
              descrLubricante: $descrLubricante,
              ficha: $ficha,
              ficha2: $ficha2,
              modArch1: $modArch1,
              modArch2: $modArch2,
              precio: $precio,
              vigenteHasta: $vigenteHasta,
              numProducto: $numProducto, 
              precioDolar: $precioDolar,
              descrUnidad: $descrUnidad, 
              porcIVA: $porcIVA,
              porcImpto: $porcImpto,
              tipoOrden: $tipoOrden,
              descrProductoAnt: $descrProductoAnt,
              estado: $estado,
              costo: $costo,
              monedaCosto: $monedaCosto,
              margen: $margen,
              codigo: $codigo,
              comisionRango1: $comisionRango1,
              comisionRango2: $comisionRango2,
              comisionRango3: $comisionRango3,
              comisionExt: $comisionExt
            }
          ){
            success
            errors{
              path
              message
            }
          }
        }
      `,
      deleteProducto: gpl`
        mutation($_id: ID!){
          deleteProducto(
            _id: $_id
          ){
          success
          errors{
            path
            message
            }                
          }
        }
      `,
        createCaja: gpl`
          mutation($numCaja: String, $tipoCaja: String, $descrCaja: String, $saldoCaja: Number, $fechaCreate: Date){
            createCaja(
              caja:{
                numCaja: $numCaja,
                tipoCaja: $tipoCaja,
                descrCaja: $descrCaja,
                saldoCaja: $saldoCaja,
                fechaCreate: $fechaCreate,
              }
            ){
              success
              _id
              errors{
                path
                message
              }
            }
          }
        `,
        editCaja: gpl`
          mutation($_id: ID, $tipoCaja: String, $descrCaja: String){
            editCaja(
              caja:{
                _id: $_id,
                tipoCaja: $tipoCaja,
                descrCaja: $descrCaja,
              }
            ){
              success
              errors{
                path
                message
              }
            }
          }
        `,
        deleteCaja: gpl`
          mutation($_id: ID!){
            deleteCaja(
              _id: $_id
            ){
            success
            errors{
              path
              message
              }                
            }
          }
        `,

        createProyecto: gpl`
          mutation($contrato: String, $descrEmpresa: String, $obra: String,
                  $descrLocalizac: String, $fechaAsig: Date, $fechaInicio: Date, $fechaFinal: Date,
                  $nuevaFechaFinal: Date, $valorTotal: Number, $observaciones: String, $fechaCreate: Date){
            createProyecto(
              proyecto:{
                contrato: $contrato,
                descrEmpresa: $descrEmpresa,
                obra: $obra,
                descrLocalizac: $descrLocalizac,
                fechaAsig: $fechaAsig,
                fechaInicio: $fechaInicio,
                fechaFinal: $fechaFinal,
                nuevaFechaFinal: $nuevaFechaFinal,
                valorTotal: $valorTotal,
                observaciones: $observaciones,
                fechaCreate: $fechaCreate,
              }
            ){
              success
              _id
              errors{
                path
                message
              }
            }
          }
        `,
        editProyecto: gpl`
          mutation($_id: ID, $descrEmpresa: String, $obra: String, $estadoProyecto: String, $descrLocalizac: String,
                $fechaAsig: Date, $fechaInicio: Date, $fechaFinal: Date, $nuevaFechaFinal: Date,
                $fechaUpdAdicional: Date, $usrUpdAdicional: String, $valorInicial: Number, $valorAdicional: Number,
                $valorTotal: Number, $valorGastadoTotal: Number, $observaciones: String, $descrCptogasto: String,
                $valorPresupuestado: Number, $valorGastado: Number, $tipoAct: String){
            editProyecto(
              proyecto:{
                _id: $_id,
                descrEmpresa: $descrEmpresa,
                obra: $obra,
                estadoProyecto: $estadoProyecto,
                descrLocalizac: $descrLocalizac,
                fechaAsig: $fechaAsig,
                fechaInicio: $fechaInicio,
                fechaFinal: $fechaFinal,
                nuevaFechaFinal: $nuevaFechaFinal
                fechaUpdAdicional: $fechaUpdAdicional
                usrUpdAdicional: $usrUpdAdicional
                valorInicial: $valorInicial
                valorAdicional: $valorAdicional
                valorTotal: $valorTotal,
                valorGastadoTotal: $valorGastadoTotal,
                observaciones: $observaciones,
                tipoAct: $tipoAct,
                presupgastos:{
                  descrCptogasto: $descrCptogasto,
                  valorPresupuestado: $valorPresupuestado,
                  valorGastado: $valorGastado
                },
              }
            ){
              success
              errors{
                path
                message
              }
            }
          }
        `,
        deleteProyecto: gpl`
          mutation($_id: ID!){
            deleteProyecto(
              _id: $_id
            ){
            success
            errors{
              path
              message
              }                
            }
          }
          `,
          createMovcaja: gpl`
            mutation(
              $contrato: String,
              $tipo: String,
              $subtipo: String,
              $tipoDocum: String,
              $numeroDocum: String,
              $fechaMov: Date,
              $estadoMovim: String,
              $concepto: String,
              $valorMovim: Number,
              $numeroEgreso: Number,
              $cuentaContable: String,
              $descrdocumprov: String,
              $numdocumprov: String,
              $descrProveed: String,
              $descrBancoprov: String,
              $nombreTitular: String,
              $numCuenta: String,
              $tipoCuenta: String,
              $descrCptogasto: String,
              $fechaCreate: Date,
            ){
              createMovcaja(
                movcaja:{
                  contrato: $contrato,
                  tipo: $tipo,
                  subtipo: $subtipo,
                  tipoDocum: $tipoDocum,
                  numeroDocum: $numeroDocum,
                  fechaMov: $fechaMov,
                  estadoMovim: $estadoMovim,
                  concepto: $concepto,
                  valorMovim: $valorMovim,
                  numeroEgreso: $numeroEgreso,
                  cuentaContable: $cuentaContable,
                  descrdocumprov: $descrdocumprov,
                  numdocumprov: $numdocumprov,
                  descrProveed: $descrProveed,
                  descrBancoprov: $descrBancoprov,
                  nombreTitular: $nombreTitular,
                  numCuenta: $numCuenta,
                  tipoCuenta: $tipoCuenta,
                  descrCptogasto: $descrCptogasto,
                  fechaCreate: $fechaCreate,
                }
              ){
                success
                _id
                errors{
                  path
                  message
                }
              }
            }
          `,
          editMovcaja: gpl`
            mutation(
              $_id: ID
              $tipoDocum: String,
              $numeroDocum: String,
              $fechaMov: Date,
              $estadoMovim: String,
              $concepto: String,
              $valorMovim: Number,
              $valorReal: Number,
              $fechaPago: Date,
              $saldoCaja: Number,
              $fechaEntreg: Date,
              $fechaAnul: Date,
              $numOrdenPago: Number,
              $numeroEgreso: Number,
              $cuentaContable: String,
              $fechaAut: Date,
              $fechaRech: Date,
              $fechaOrden: Date,
              $fechaEnviado: Date,
              $enviadoCon: String,
              $descrCaja: String,
              $descrdocumprov: String,
              $numdocumprov: String,
              $descrProveed: String,
              $descrBancoprov: String,
              $nombreTitular: String,
              $numCuenta: String,
              $tipoCuenta: String,
              $descrCptogasto: String,
              $tipoAct: String,
            ){
              editMovcaja(
                movcaja:{
                  _id: $_id
                  tipoDocum: $tipoDocum,
                  numeroDocum: $numeroDocum,
                  fechaMov: $fechaMov
                  estadoMovim: $estadoMovim,
                  concepto: $concepto,
                  valorMovim: $valorMovim,
                  valorReal: $valorReal,
                  fechaPago: $fechaPago,
                  saldoCaja: $saldoCaja,
                  fechaEntreg: $fechaEntreg,
                  fechaAnul: $fechaAnul,
                  numOrdenPago: $numOrdenPago,
                  numeroEgreso: $numeroEgreso,
                  cuentaContable: $cuentaContable,
                  fechaAut: $fechaAut,
                  fechaRech: $fechaRech,
                  fechaOrden: $fechaOrden,
                  fechaEnviado: $fechaEnviado,
                  enviadoCon: $enviadoCon,
                  descrCaja: $descrCaja,
                  descrdocumprov: $descrdocumprov,
                  numdocumprov: $numdocumprov,
                  descrProveed: $descrProveed,
                  descrBancoprov: $descrBancoprov,
                  nombreTitular: $nombreTitular,
                  numCuenta: $numCuenta,
                  tipoCuenta: $tipoCuenta,
                  descrCptogasto: $descrCptogasto,
                  tipoAct: $tipoAct,
                }
              ){
                success
                errors{
                  path
                  message
                }
              }
            }
          `,
          deleteMovcaja: gpl`
            mutation($_id: ID!){
              deleteMovcaja(
                _id: $_id
              ){
              success
              errors{
                path
                message
                }                
              }
            }
          `,
        createClienteMany: gpl`
      mutation($cliente: [iClienteMany]){
        createClienteMany(
            cliente: $cliente
          ){
              success
              errors{
                  path
                  message
                  }                
              }
          }
      `,
            createCliente: gpl`
                mutation($contrato: String!, $nombreCliente: String!, $apellidoCliente: String!,
                        $sexoCliente: String, $eMail: String, $descrEstrato: String,
                        $cicloFact: String, $tag: String, $referencia1: String, $telefonoRef1: String,
                        $referencia2: String, $telefonoRef2: String, $fechaCreacionSistema: Date,
                        $numeroOdeDX: Number,
                        $telefono1: String, $telefono2: String, $telefono3: String, $observaciones: String,
                        $_idTipoDoc: ID, $codigoTipoDoc: String, $descrTipoDoc: String, $numeroDoc: String,
                        $_idTipoCl: ID, $codigoTipoCliente: String, $descrTipoCliente: String,
                        $_idGrupoAf: ID, $codigoGrupoAfin: String, $descrGrupoAfin: String){
                    createCliente(
                    cliente:{
                        contrato: $contrato,
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        sexoCliente: $sexoCliente,
                        eMail: $eMail,
                        descrEstrato: $descrEstrato,
                        cicloFact: $cicloFact,
                        tag: $tag,
                        referencia1: $referencia1,
                        telefonoRef1: $telefonoRef1,
                        referencia2: $referencia2,
                        telefonoRef2: $telefonoRef2,
                        fechaCreacionSistema: $fechaCreacionSistema,
                        numeroOdeDX: $numeroOdeDX,
                        telefono1: $telefono1,
                        telefono2: $telefono2,
                        telefono3: $telefono3,
                        observaciones: $observaciones,
                        tipodoc:{
                            _id: $_idTipoDoc,
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        },
                        numeroDoc: $numeroDoc,
                        tipocl:{
                            _id: $_idTipoCl,
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        },
                        grupoaf:{
                            _id: $_idGrupoAf,
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createTarifa: gpl`
                    mutation($codigoTarifa: String, $descrTarifa: String, $cicloFact: String, $estadoTarifa: Boolean){
                        createTarifa(
                            tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            estadoTarifa: $estadoTarifa
                        }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createOferta: gpl`
                        mutation($codigoOferta: String, $descrOferta: String, $estadoOferta: Boolean){
                            createOferta(
                                oferta:{
                                codigoOferta: $codigoOferta,
                                descrOferta: $descrOferta,
                                estadoOferta: $estadoOferta
                            }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                    `,
                    createDpto: gpl`
                mutation($codigoDpto: String!, $descrDpto: String!){
                    createDpto(
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
            `,
            createServicio: gpl`
            mutation($codigoServicio: String!, $nombreResumido: String!, $descripcionServicio: String!,
              $conceptoEnFra: String, $consecEnFra: Number, $_idSubclaseServ: ID!,
              $codigoSubclaseServ: String!, $descrSubclaseServ: String!, $_idClaseServ: ID!,
              $codigoClaseServ: String!, $descrClaseServ: String!, $paraProcMasDX: String!){
                createServicio(
                    servicio:{
                        codigoServicio:$codigoServicio,
                        nombreResumido:$nombreResumido,
                        descripcionServicio:$descripcionServicio,
                        conceptoEnFra: $conceptoEnFra,
                        consecEnFra: $consecEnFra,
                        subclaseserv:{
                            _id: $_idSubclaseServ,
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ
                            claseserv:{
                                _id: $_idClaseServ,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        },
                        paraProcMasDX: $paraProcMasDX
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createDetalleDXMany: gpl`
            mutation($detalledx: [iDetalleDXMany]){
                createDetalleDXMany(
                    detalledx: $detalledx
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovCliCCMany: gpl`
            mutation($movcliente: [iMovCliCCMany]){
                createMovCliCCMany(
                    movcliente: $movcliente
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovCliCC: gpl`
            mutation($contrato: String, $fechaMov: Date, $tipo: String, $subTipo: String,
                $procesado: String, $pagueHasta: Date, $numeroOdeDX: Number,
                $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                $periodo: String, $origen: String, $saldoCliente: Number, $valorTotal: Number,
                $valorAntesImptos: Number, $agno: String, $mes: String, $numeroFra: String,
                $numeroCE: String,
                $numeroRC: String, $documento: String, $valorPagado: Number, $fechaUltPago: Date,
                $valorUltPago: Number){
                    createMovCliCC(
                        movcliente:{
                        contrato: $contrato
                        fechaMov: $fechaMov
                        tipo: $tipo
                        subTipo: $subTipo
                        procesado: $procesado
                        pagueHasta: $pagueHasta
                        numeroOdeDX: $numeroOdeDX
                        codigoServicio: $codigoServicio
                        nombreResumido: $nombreResumido
                        descripcionServicio: $descripcionServicio
                        descrClaseServ: $descrClaseServ
                        concepto: $concepto
                        periodo: $periodo
                        origen: $origen
                        saldoCliente: $saldoCliente
                        valorTotal: $valorTotal
                        valorAntesImptos: $valorAntesImptos
                        agno: $agno
                        mes: $mes
                        numeroFra: $numeroFra
                        numeroCE: $numeroCE
                        numeroRC: $numeroRC
                        documento: $documento
                        valorPagado: $valorPagado
                        fechaUltPago: $fechaUltPago
                        valorUltPago: $valorUltPago
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createMovClientesMany: gpl`
            mutation($movcliente: [iMovClientesMany]){
                createMovClientesMany(
                    movcliente: $movcliente
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createMovClientes: gpl`
            mutation($contrato: String, $fechaMov: Date, $tipo: String, $subTipo: String,
                $procesado: String, $pagueHasta: Date, $numeroOdeDX: Number,
                $codigoServicio: String, $nombreResumido: String,
                $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                $periodo: String, $origen: String, $saldoCliente: Number, $valorTotal: Number,
                $valorAntesImptos: Number, $agno: String, $mes: String, $numeroFra: String,
                $numeroCE: String,
                $numeroRC: String, $documento: String, $valorPagado: Number, $valorPendiente: Number,
                $fechaUltPago: Date, $valorUltPago: Number){
                    createMovClientes(
                        movcliente:{
                        contrato: $contrato
                        fechaMov: $fechaMov
                        tipo: $tipo
                        subTipo: $subTipo
                        procesado: $procesado
                        pagueHasta: $pagueHasta
                        numeroOdeDX: $numeroOdeDX
                        codigoServicio: $codigoServicio
                        nombreResumido: $nombreResumido
                        descripcionServicio: $descripcionServicio
                        descrClaseServ: $descrClaseServ
                        concepto: $concepto
                        periodo: $periodo
                        origen: $origen
                        saldoCliente: $saldoCliente
                        valorTotal: $valorTotal
                        valorAntesImptos: $valorAntesImptos
                        agno: $agno
                        mes: $mes
                        numeroFra: $numeroFra
                        numeroCE: $numeroCE
                        numeroRC: $numeroRC
                        documento: $documento
                        valorPagado: $valorPagado
                        valorPendiente: $valorPendiente
                        fechaUltPago: $fechaUltPago
                        valorUltPago: $valorUltPago
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createPagoClientes: gpl`
              mutation($contrato: String, $saldoPendiente: Number, $fechaPago: Date, $tipo: String,
                $descripcionPago: String, $numeroFra: String,
                $numeroRC: String, $documento: String, $numeroRT: String, $numeroDocum: String,
                $descrRecurso: String, $valorTotal: Number, $valorEf: Number, $valorCh: Number,
                $numeroCh: String, $bancoCh: String, $fechaVencCh: Date, $valorTr: Number,
                $bancoTr: String, $fechaTr: Date, $valorTD: Number, $bancoTD: String, $valorTC: Number,
                $bancoTC: String, $fechaCreate: String){
                  createPagoClientes(
                    pagocliente:{
                      contrato: $contrato
                      saldoPendiente: $saldoPendiente
                      fechaPago: $fechaPago
                      tipo: $tipo
                      descripcionPago: $descripcionPago
                      numeroFra: $numeroFra
                      numeroRC: $numeroRC,
                      documento: $documento,
                      numeroRT: $numeroRT,
                      numeroDocum: $numeroDocum,
                      descrRecurso: $descrRecurso,
                      valorTotal: $valorTotal
                      valorEf: $valorEf
                      valorCh: $valorCh
                      numeroCh: $numeroCh
                      bancoCh: $bancoCh
                      fechaVencCh: $fechaVencCh
                      valorTr: $valorTr
                      bancoTr: $bancoTr
                      fechaTr: $fechaTr
                      valorTD: $valorTD
                      bancoTD: $bancoTD
                      valorTC: $valorTC
                      bancoTC: $bancoTC
                      fechaCreate: $fechaCreate
                  }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createFacturacionMany: gpl`
            mutation($facturacion: [iFacturacionMany]){
                createFacturacionMany(
                    facturacion: $facturacion
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createFacturacion: gpl`
            mutation($codProcFact: String, $tipoGen: String, $idRangoFact: String, $numeroFra: String,
                $fechaFact: Date, $contrato: String, $pagueHasta: Date,
                $direccion: String, $descrDpto: String, $nombreCiudad: String, $nombreZona: String,
                $nombreBarrio: String, $nombreCliente: String, $apellidoCliente: String,
                $saldoPendiente: Number,
                $fechaMov: Date, $valorAntesImptos: Number, $valorFacturado: Number,
                $valorFactura: Number, $agno: String, $mes: String,
                $numeroDocum: String, $descrRecurso: String){
                  createFacturacion(
                    facturacion:{
                      codProcFact: $codProcFact
                      tipoGen: $tipoGen
                      idRangoFact: $idRangoFact
                      numeroFra: $numeroFra
                      fechaFact: $fechaFact
                      contrato: $contrato
                      pagueHasta: $pagueHasta
                      direccion: $direccion
                      descrDpto: $descrDpto
                      nombreCiudad: $nombreCiudad
                      nombreZona: $nombreZona
                      nombreBarrio: $nombreBarrio
                      nombreCliente: $nombreCliente
                      apellidoCliente: $apellidoCliente
                      saldoPendiente: $saldoPendiente                    
                      fechaMov: $fechaMov
                      valorAntesImptos: $valorAntesImptos
                      valorFacturado: $valorFacturado
                      valorFactura: $valorFactura
                      agno: $agno
                      mes: $mes
                      numeroDocum: $numeroDocum
                      descrRecurso: $descrRecurso                    
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
          `,
          createHistProyectoMany: gpl`
            mutation($histproyecto: [iHistProyectoMany]){
              createHistProyectoMany(
                histproyecto: $histproyecto
              ){
                success
                errors{
                  path
                  message
                }                
              }
            }
          `,
          createCargoEspMany: gpl`
            mutation($cargoesp: [iCargoEspMany]){
                createCargoEspMany(
                    cargoesp: $cargoesp
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            createCargoEsp: gpl`
            mutation($codProcCE: String, $tipoGen: String, $numeroCE: String, $fechaCE: Date, $contrato: String,
              $fechaMov: Date, $valorAntesImptos: Number, $valorCargado: Number,
                $valorCargo: Number, $agno: String, $mes: String, $nombreBarrio: String,
                $numeroDocum: String, $descrRecurso: String){
                  createCargoEsp(
                    cargoesp:{
                      codProcCE: $codProcCE
                      tipoGen: $tipoGen
                      numeroCE: $numeroCE
                      fechaCE: $fechaCE
                      contrato: $contrato
                      fechaMov: $fechaMov
                      valorAntesImptos: $valorAntesImptos
                      valorCargado: $valorCargado
                      valorCargo: $valorCargo
                      agno: $agno
                      mes: $mes
                      nombreBarrio: $nombreBarrio
                      numeroDocum: $numeroDocum
                      descrRecurso: $descrRecurso                    
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createNotasDebCre: gpl`
            mutation($tipoNota: String, $numeroNota: String, $idRangoFact: String, $numeroFra: String, $fechaNota: Date,
              $contrato: String, $valorAntesImptos: Number, $valorNota: Number){
                  createNotasDebCre(
                    notasdebcre:{
                      tipoNota: $tipoNota
                      numeroNota: $numeroNota
                      idRangoFact: $idRangoFact
                      numeroFra: $numeroFra
                      fechaNota: $fechaNota
                      contrato: $contrato
                      valorAntesImptos: $valorAntesImptos
                      valorNota: $valorNota
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createAjuste: gpl`
            mutation($tipoAjuste: String, $numeroAjuste: String, $fechaAjuste: Date,
              $contrato: String, $concepto: String, $valorAjuste: Number){
                createAjuste(
                    ajuste:{
                      tipoAjuste: $tipoAjuste
                      numeroAjuste: $numeroAjuste
                      fechaAjuste: $fechaAjuste
                      contrato: $contrato
                      concepto: $concepto
                      valorAjuste: $valorAjuste
                    }
                ){
                  success
                  _id
                  errors{
                    path
                    message
                  }
                }
            }
            `,
            createOdeS: gpl`
                mutation($numeroOS: Number, $contrato: String, $_idTipoOS: ID, $codigoTipoOS: String,
                        $descrTipoOS: String, $observacAB: String,
                        $codigoTipoDocV: String, $numeroDocumV: String, $descrRecursoV: String,
                        $horaSolic: String, $nombreSolic: String,
                        $fechaEjec: Date, $fechaFra: Date, $fechaCreate: Date){
                    createOdeS(
                        odes:{
                            numeroOS: $numeroOS,
                            contrato: $contrato,
                            tipoos:{
                                _id: $_idTipoOS,
                                codigoTipoOS: $codigoTipoOS,
                                descrTipoOS: $descrTipoOS
                            },
                            observacAB: $observacAB,
                            codigoTipoDocV: $codigoTipoDocV,
                            numeroDocumV: $numeroDocumV,
                            descrRecursoV: $descrRecursoV,
                            horaSolic: $horaSolic,
                            nombreSolic: $nombreSolic,                        
                            fechaEjec: $fechaEjec,
                            fechaFra: $fechaFra,
                            fechaCreate: $fechaCreate,
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
            createTipoRec: gpl`
                mutation($descrTipoRec: String!, $areaAprovech: String!){
                    createTipoRec(
                        tiporec:{
                            descrTipoRec: $descrTipoRec,
                            areaAprovech: $areaAprovech
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createRecurso: gpl`
                  mutation($codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String,
                    $_idTipoRec: ID, $descrTipoRec: String!, $areaAprovech: String, $dirArchIn: String){
                    createRecurso(
                      recurso:{
                        codigoTipoDoc: $codigoTipoDoc,
                        numeroDocum: $numeroDocum,
                        descrRecurso: $descrRecurso,
                        tiporec:{
                          _id: $_idTipoRec,
                          descrTipoRec: $descrTipoRec,
                          areaAprovech: $areaAprovech
                        },
                        dirArchIn: $dirArchIn
                      }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                  }
                  `,
                  createRdoTerc: gpl`
                    mutation($numeroDocum: String, $descrRecurso: String, $archivo: String, $contrato: String,
                      $nombreCliente: String, $apellidoCliente: String, $valorTotal: Number,
                      $fechaPago: Date, $procesado: String, $fechaCreate: Date){
                      createRdoTerc(
                        rdoterc:{
                          numeroDocum: $numeroDocum,
                          descrRecurso: $descrRecurso,
                          archivo: $archivo,
                          contrato: $contrato,
                          nombreCliente: $nombreCliente,
                          apellidoCliente: $apellidoCliente,
                          valorTotal: $valorTotal,
                          fechaPago: $fechaPago,
                          procesado: $procesado,
                          fechaCreate: $fechaCreate
                        }
                      ){
                        success
                        _id
                        errors{
                          path
                          message
                        }
                      }
                    }
                  `,
                      createEquipo: gpl`
                        mutation($numeroSerie: String, $mac: String, $estadoEquipo: String,
                            $_idClaseEqu: ID!, $codigoClaseEqu: String!, $descrClaseEqu: String,
                            $_idMarcaEqu: ID!, $codigoMarcaEqu: String!, $descrMarcaEqu: String,
                            $_idFabriEqu: ID!, $codigoFabriEqu: String!, $descrFabriEqu: String,
                            $_idBodega: ID!, $codigoBodega: String!, $descrBodega: String){
                            createEquipo(
                                equipo:{
                                    numeroSerie: $numeroSerie,
                                    mac: $mac,
                                    estadoEquipo: $estadoEquipo,
                                    claseequ:{
                                        _id: $_idClaseEqu,
                                        codigoClaseEqu: $codigoClaseEqu,
                                        descrClaseEqu: $descrClaseEqu
                                    },
                                    marcaequ:{
                                        _id: $_idMarcaEqu,
                                        codigoMarcaEqu: $codigoMarcaEqu,
                                        descrMarcaEqu: $descrMarcaEqu
                                    },
                                    fabriequ:{
                                        _id: $_idFabriEqu,
                                        codigoFabriEqu: $codigoFabriEqu,
                                        descrFabriEqu: $descrFabriEqu
                                    },
                                    bodega:{
                                        _id: $_idBodega,
                                        codigoBodega: $codigoBodega,
                                        descrBodega: $descrBodega
                                    },
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createRangoFact: gpl`
                            mutation($factInicial: Number, $factFinal: Number, $fecha: Date,
                                $numResolucion: String, $observaciones: String, $proxFact: Number,
                                $estadoRangoFact: Boolean){
                                  createRangoFact(
                                    rangoFact:{
                                      factInicial: $factInicial,
                                      factFinal: $factFinal,
                                      fecha: $fecha,
                                      numResolucion: $numResolucion,
                                      observaciones: $observaciones,
                                      proxFact: $proxFact,
                                      estadoRangoFact: $estadoRangoFact,
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createProcDX: gpl`
                              mutation($numeroOdeDX: Number, $totCliDX: Number, $totServDX: Number,
                                $codProcDX: String, $estadoProcDX: String,
                                $fechaRef: Date, $diasMora: Number, $porcMovim: Number,
                                $valorMovim: Number, $servaDX: String, $descrDpto: String, $nombreCiudad: String,
                                $nombreZona: String, $nombreBarrio: String, $descrClaseServ: String){
                                    createProcDX(
                                        procdx:{
                                            numeroOdeDX: $numeroOdeDX,
                                            codProcDX: $codProcDX,
                                            estadoProcDX: $estadoProcDX,
                                            totCliDX: $totCliDX,
                                            totServDX: $totServDX,
                                            fechaRef: $fechaRef,
                                            diasMora: $diasMora,
                                            porcMovim: $porcMovim,
                                            valorMovim: $valorMovim,
                                            servaDX: $servaDX,
                                            descrDpto: $descrDpto,
                                            nombreCiudad: $nombreCiudad,
                                            nombreZona: $nombreZona,
                                            nombreBarrio: $nombreBarrio,
                                            descrClaseServ: $descrClaseServ
                                    }
                                  ){
                                    success
                                    _id
                                    errors{
                                      path
                                      message
                                    }
                                  }
                              }
                              `,
                            createProcFact: gpl`
                              mutation($codProcFact: String, $mes: String, $fechaFact: Date, $factInicial: String, $factFinal: String,
                                  $pagueHasta: Date, $idRangoFact: String, $descrDpto: String,
                                  $nombreCiudad: String, $descrClaseServ: String, $cicloFact: String, 
                                  $observaciones: String, $imagenLado: String, $imagenInf: String, $fechaCreate: Date){
                                    createProcFact(
                                      procFact:{
                                      codProcFact: $codProcFact,
                                      mes: $mes,
                                      fechaFact: $fechaFact,
                                      factInicial: $factInicial,
                                      factFinal: $factFinal,
                                      pagueHasta: $pagueHasta,
                                      idRangoFact: $idRangoFact,
                                      descrDpto: $descrDpto,
                                      nombreCiudad: $nombreCiudad,
                                      descrClaseServ: $descrClaseServ,
                                      cicloFact: $cicloFact,
                                      observaciones: $observaciones,
                                      imagenLado: $imagenLado,
                                      imagenInf: $imagenInf,
                                      fechaCreate: $fechaCreate
                                    }
                                  ){
                                    success
                                    _id
                                    errors{
                                      path
                                      message
                                    }
                                  }
                              }
                              `,
                              createProcCE: gpl`
                                mutation($codProcCE: String, $mes: String, $fechaCE: Date,
                                    $pagueHasta: Date,
                                  $prefijoCE: String, $proxCE: String, $descrDpto: String,
                                  $nombreCiudad: String, $descrClaseServ: String, $cicloFact: String,
                                  $observaciones: String, $fechaCreate: Date){
                                    createProcCE(
                                      procCE:{
                                        codProcCE: $codProcCE,
                                        mes: $mes,
                                        fechaCE: $fechaCE,
                                        pagueHasta: $pagueHasta,
                                        prefijoCE: $prefijoCE,
                                        proxCE: $proxCE,
                                        descrDpto: $descrDpto,
                                        nombreCiudad: $nombreCiudad,
                                        descrClaseServ: $descrClaseServ,
                                        cicloFact: $cicloFact,
                                        observaciones: $observaciones,
                                        fechaCreate: $fechaCreate
                                      }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                                }
                                `,
              createTiUndMat: gpl`
                mutation($codigoTiUndMat: String!, $descrTiUndMat: String!){
                    createTiUndMat(
                        tiundmat:{
                            codigoTiUndMat: $codigoTiUndMat,
                            descrTiUndMat: $descrTiUndMat
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createClaseEqu: gpl`
                    mutation($codigoClaseEqu: String!, $descrClaseEqu: String!){
                        createClaseEqu(
                            claseequ:{
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createMarcaEqu: gpl`
                        mutation($codigoMarcaEqu: String!, $descrMarcaEqu: String!){
                            createMarcaEqu(
                                marcaequ:{
                                    codigoMarcaEqu: $codigoMarcaEqu,
                                    descrMarcaEqu: $descrMarcaEqu
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createFabriEqu: gpl`
                            mutation($codigoFabriEqu: String!, $descrFabriEqu: String!){
                                createFabriEqu(
                                    fabriequ:{
                                        codigoFabriEqu: $codigoFabriEqu,
                                        descrFabriEqu: $descrFabriEqu
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createBodega: gpl`
                                mutation($codigoBodega: String!, $descrBodega: String!){
                                    createBodega(
                                        bodega:{
                                            codigoBodega: $codigoBodega,
                                            descrBodega: $descrBodega
                                        }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                                }
                                `,
                  createUndMat: gpl`
                    mutation($descrUndMat: String!, $_idTiUndMat: ID!, $codigoTiUndMat: String!, $descrTiUndMat: String!){
                        createUndMat(
                            undmat:{
                                descrUndMat: $descrUndMat,
                                tiundmat:{
                                  _id: $_idTiUndMat,
                                  codigoTiUndMat: $codigoTiUndMat,
                                  descrTiUndMat: $descrTiUndMat
                                },
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createTipoUnd: gpl`
                        mutation($descrTipoUnd: String!){
                            createTipoUnd(
                                tipound:{
                                    descrTipoUnd: $descrTipoUnd
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                        `,
                        createTipoVia: gpl`
                            mutation($descrTipoVia: String!){
                                createTipoVia(
                                    tipovia:{
                                        descrTipoVia: $descrTipoVia
                                    }
                                ){
                                  success
                                  _id
                                  errors{
                                    path
                                    message
                                  }
                                }
                            }
                            `,
                            createEstrato: gpl`
                                mutation($descrEstrato: String!){
                                    createEstrato(
                                        estrato:{
                                            descrEstrato: $descrEstrato
                                        }
                                    ){
                                      success
                                      _id
                                      errors{
                                        path
                                        message
                                      }
                                    }
                                }
                                `,
                                createCicloFact: gpl`
                                    mutation($cicloFact: String!, $noFactRET: Boolean){
                                        createCicloFact(
                                            ciclofact:{
                                                cicloFact: $cicloFact,
                                                noFactRET: $noFactRET
                                            }
                                        ){
                                          success
                                          _id
                                          errors{
                                            path
                                            message
                                          }
                                        }
                              }
              `,
              createClaseServ: gpl`
                mutation($codigoClaseServ: String!, $descrClaseServ: String!){
                  createClaseServ(
                    claseserv:{
                        codigoClaseServ: $codigoClaseServ,
                        descrClaseServ: $descrClaseServ
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createTipoAju: gpl`
                mutation($fechaCreate: Date, $descrTipoAju: String!){
                  createTipoAju(
                    tipoaju:{
                      descrTipoAju: $descrTipoAju
                      fechaCreate: $fechaCreate
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createBaseDat: gpl`
                mutation($fechaCreate: Date, $descrBaseDat: String!){
                  createBaseDat(
                    basedat:{
                      descrBaseDat: $descrBaseDat
                      fechaCreate: $fechaCreate
                    }
                  ){
                    success
                    _id
                    errors{
                      path
                      message
                    }
                  }
              }
              `,
              createTipoCliente: gpl`
                mutation($codigoTipoCliente: String!, $descrTipoCliente: String!){
                    createTipoCliente(
                        tipocliente:{
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                      }
                    `,
            createGrupoAfin: gpl`
                mutation($codigoGrupoAfin: String!, $descrGrupoAfin: String!){
                    createGrupoAfin(
                        grupoafin:{
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
            `,
            createTipoDoc: gpl`
                mutation($codigoTipoDoc: String!, $descrTipoDoc: String!){
                    createTipoDoc(
                        tipodoc:{
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createImpto: gpl`
                    mutation($codigoImpto: String, $descrImpto: String, $porcImpto: Number){
                        createImpto(
                            impto:{
                                codigoImpto: $codigoImpto,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    createOtrosPagCl: gpl`
                        mutation($descrOtrosPagCl: String, $codigoImpto: String, $descrImpto: String,
                                $porcImpto: Number, $descrClaseServ: String){
                            createOtrosPagCl(
                                otrospagcl:{
                                    descrOtrosPagCl: $descrOtrosPagCl,
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    descrClaseServ: $descrClaseServ
                                }
                            ){
                              success
                              _id
                              errors{
                                path
                                message
                              }
                            }
                        }
                    `,
                    createSubclaseServ: gpl`
                mutation($codigoSubclaseServ: String!, $descrSubclaseServ: String!, $_idClaseserv: ID!, $codigoClaseServ: String!, $descrClaseServ: String!){
                    createSubclaseServ(
                        subclaseserv:{
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ,
                            claseserv:{
                                _id: $_idClaseserv,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        }
                    ){
                      success
                      _id
                      errors{
                        path
                        message
                      }
                    }
                }
                `,
                createTipoOS: gpl`
                    mutation($codigoTipoOS: String!, $descrTipoOS: String!,
                        $permDireccion: String!, $permTarServ: String!, $permOfertas: String!,
                        $permEquipos: String!, $paraCliNuevo: String!, $estadoCrearOS: String!,
                        $estadoCerrarOS: String!
                    ){
                        createTipoOS(
                            tipoos:{
                                codigoTipoOS: $codigoTipoOS
                                descrTipoOS: $descrTipoOS
                                permDireccion: $permDireccion
                                permTarServ: $permTarServ
                                permOfertas: $permOfertas
                                permEquipos: $permEquipos
                                paraCliNuevo: $paraCliNuevo
                                estadoCrearOS: $estadoCrearOS
                                estadoCerrarOS: $estadoCerrarOS
                            }
                        ){
                          success
                          _id
                          errors{
                            path
                            message
                          }
                        }
                    }
                    `,
                    editSeqFrafindOneAndUpdate: gpl`
                      mutation($_id: ID, $proxFact: Number){
                        editSeqFrafindOneAndUpdate(
                          sequence:{
                              _id: $_id,
                              proxFact: $proxFact,
                          }
                        ){
                            success
                            errors{
                              path
                              message
                            }
                            proxFact              
                          }
                      }
                    `,
                    editSeqfindOneAndUpdate: gpl`
      mutation($coleccion: String, $seq: Number){
        editSeqfindOneAndUpdate(
          sequence:{
              coleccion: $coleccion,
              seq: $seq,
          }
        ){
            success
            errors{
              path
              message
            }
            seq              
          }
      }
    `,

    editSequence: gpl`
      mutation($coleccion: String, $seq: Number){
        editSequence(
          sequence:{
            coleccion: $coleccion,
            seq: $seq,
          }
        ){
          success
          errors{
            path
            message
          }                
        }
      }
    `,
    editParametro: gpl`
      mutation($_id: ID, $mensaje: String, 
        $empresaRazonSocial: String,
        $empresaNit: String,
        $empresaWeb: String,
        $empresaDir1: String,
        $empresaTel1: String,
        $empresaCel1: String,
        $empresaCiudad1: String,
        $empresaDir2: String,
        $empresaTel2: String,
        $empresaCel2: String,
        $empresaCiudad2: String,
        $empresaBanco1: String,
        $empresaCuenta1: String,
        $empresaBanco2: String,
        $empresaCuenta2: String,
        $empresaPresentacion: String,
        $empresaNombreFirma: String,
        $empresaCargoFirma: String,
        $empresaMailFirma: String,
        $empresaCelFirma: String,
        $rutaLogo: String,
        $generandoProg: String,
        $trm: String,
        $mailFactura: String,
        $mailFacturaPanama: String,
        $medidaQR: Number,
        $minimoDolar: Number,
        $maximoDolar: Number,
        $parametroMail1: String,
        $parametroMail2: String,
        $parametroMail3: String,
        $nodemailerUser: String,
        $nodemailerPass: String,
        $rango1Desde: Number,
        $rango1Hasta: Number,
        $rango2Hasta: Number,
        $rango3Hasta: Number){ 
        editParametro(
          parametro:{
            _id: $_id,
            mensaje: $mensaje,
            empresaRazonSocial: $empresaRazonSocial,
            empresaNit: $empresaNit,
            empresaWeb: $empresaWeb,
            empresaDir1: $empresaDir1,
            empresaTel1: $empresaTel1,
            empresaCel1: $empresaCel1,
            empresaCiudad1: $empresaCiudad1,
            empresaDir2: $empresaDir2,
            empresaTel2: $empresaTel2,
            empresaCel2: $empresaCel2,
            empresaCiudad2: $empresaCiudad2,
            empresaBanco1: $empresaBanco1,
            empresaCuenta1: $empresaCuenta1,
            empresaBanco2: $empresaBanco2,
            empresaCuenta2: $empresaCuenta2,
            empresaPresentacion: $empresaPresentacion,
            empresaNombreFirma: $empresaNombreFirma,
            empresaCargoFirma: $empresaCargoFirma,
            empresaMailFirma: $empresaMailFirma,
            empresaCelFirma: $empresaCelFirma,
            rutaLogo: $rutaLogo,
            generandoProg: $generandoProg,
            trm: $trm,
            mailFactura: $mailFactura,
            mailFacturaPanama: $mailFacturaPanama,
            medidaQR: $medidaQR,
            minimoDolar: $minimoDolar,
            maximoDolar: $maximoDolar,
            parametroMail1: $parametroMail1,
            parametroMail2: $parametroMail2,
            parametroMail3: $parametroMail3,
            nodemailerUser: $nodemailerUser,
            nodemailerPass: $nodemailerPass,
            rango1Desde: $rango1Desde,
            rango1Hasta: $rango1Hasta,
            rango2Hasta: $rango2Hasta,
            rango3Hasta: $rango3Hasta
          }
        ){
          success
          errors{
            path
            message
          }                
        }
      }
      `,
      editAutorizac: gpl`
      mutation($_id: ID!, $descrAutorizac: String!){
        editAutorizac(
          autorizac:{
              _id: $_id,
              descrAutorizac: $descrAutorizac
          }
      ){
          success
          errors{
              path
              message
          }                
        }
      }
    `,
    editPerfil: gpl`
      mutation($_id: ID!, $descrPerfil: String!){
        editPerfil(
          perfil:{
            _id: $_id,
            descrPerfil: $descrPerfil
          }
      ){
        success
        errors{
          path
          message
        }                
      }
    }
    `,
    editPerfilUpdDoc: gpl`
      mutation($_id: ID, $tipoAct: String, $codigoAutorizac: String, $descrAutorizac: String
      ){
        editPerfilUpdDoc(perfil:{
            _id: $_id,
            tipoAct: $tipoAct,
            autorizac:{
              codigoAutorizac: $codigoAutorizac,
              descrAutorizac: $descrAutorizac,
            },
        }){
        success
        errors{
            path
            message
            }                
        }
    }
`,
editTipoRec: gpl`
                mutation($_id: ID!, $descrTipoRec: String!){
                    editTipoRec(
                    tiporec:{
                        _id: $_id,
                        descrTipoRec: $descrTipoRec
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRecurso: gpl`
            mutation($_id: ID, $descrRecurso: String,
                     $idTipoRec: ID,
                     $descrTipoRec: String,
                     $areaAprovech: String,
                     $_idAnterior: ID,
                     $dirArchIn: String
            ){
                editRecurso(recurso:{
                        _id: $_id,
                        descrRecurso: $descrRecurso,
                        tiporec:{
                            _id: $idTipoRec,
                            descrTipoRec: $descrTipoRec,
                            areaAprovech: $areaAprovech
                        },
                        dirArchIn: $dirArchIn
                    },
                    _idAnterior: $_idAnterior
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRdoTerc: gpl`
            mutation($_id: ID, $procesado: String
            ){
                editRdoTerc(rdoterc:{
                        _id: $_id,
                        procesado: $procesado
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editEquipo: gpl`
            mutation($tipoAct: String, $numeroSerie: String, $mac: String, $estadoEquipo: String,
                $contrato: String, $_idBodega: ID, $codigoBodega: String, $descrBodega: String){
                editEquipo(equipo:{
                    tipoAct: $tipoAct,
                    numeroSerie: $numeroSerie,
                    mac: $mac,
                    estadoEquipo: $estadoEquipo,
                    contrato: $contrato,
                    bodega:{
                        _id: $_idBodega,
                        codigoBodega: $codigoBodega,
                        descrBodega: $descrBodega
                    },
                }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editRangoFact: gpl`
            mutation($_id: ID, $tipoAct: String, $fecha: Date, $numResolucion: String,
                $observaciones: String, $proxFact: Number, $estadoRangoFact: Boolean){
                  editRangoFact(rangoFact:{
                    _id: $_id,
                    tipoAct: $tipoAct,
                    fecha: $fecha,
                    numResolucion: $numResolucion,
                    observaciones: $observaciones,
                    proxFact: $proxFact,
                    estadoRangoFact: $estadoRangoFact
                }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editProcFact: gpl`
            mutation($codProcFact: String, $factInicial: String, $factFinal: String){
              editProcFact(procFact:{
                codProcFact: $codProcFact
                factInicial: $factInicial,
                factFinal: $factFinal
              }
              ){
                success
                errors{
                    path
                    message
                }
              }
            }
            `,
            editProcCE: gpl`
            mutation($_id: ID, $observaciones: String){
              editProcCE(procCE:{
                _id: $_id,
                observaciones: $observaciones
              }
              ){
                success
                errors{
                    path
                    message
                }                
              }
            }
            `,
            editTiUndMat: gpl`
                mutation($_id: ID!, $descrTiUndMat: String!){
                    editTiUndMat(
                    tiundmat:{
                        _id: $_id,
                        descrTiUndMat: $descrTiUndMat
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editClaseEqu: gpl`
                mutation($_id: ID!, $descrClaseEqu: String!){
                    editClaseEqu(
                    claseequ:{
                        _id: $_id,
                        descrClaseEqu: $descrClaseEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editMarcaEqu: gpl`
                mutation($_id: ID!, $descrMarcaEqu: String!){
                    editMarcaEqu(
                    marcaequ:{
                        _id: $_id,
                        descrMarcaEqu: $descrMarcaEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editFabriEqu: gpl`
                mutation($_id: ID!, $descrFabriEqu: String!){
                    editFabriEqu(
                    fabriequ:{
                        _id: $_id,
                        descrFabriEqu: $descrFabriEqu
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editBodega: gpl`
                mutation($_id: ID!, $descrBodega: String!){
                    editBodega(
                    bodega:{
                        _id: $_id,
                        descrBodega: $descrBodega
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editUndMat: gpl`
            mutation($_id: ID!, $descrUndMat: String!){
                editUndMat(
                    undmat:{
                        _id: $_id,
                        descrUndMat: $descrUndMat
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editTipoUnd: gpl`
                mutation($_id: ID!, $descrTipoUnd: String!){
                    editTipoUnd(
                    tipound:{
                        _id: $_id,
                        descrTipoUnd: $descrTipoUnd
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editTipoVia: gpl`
                mutation($_id: ID!, $descrTipoVia: String!){
                    editTipoVia(
                    tipovia:{
                        _id: $_id,
                        descrTipoVia: $descrTipoVia
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editEstrato: gpl`
                mutation($_id: ID!, $descrEstrato: String!){
                    editEstrato(
                    estrato:{
                        _id: $_id,
                        descrEstrato: $descrEstrato
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
            editCicloFact: gpl`
                mutation($_id: ID!, $cicloFact: String!, $noFactRET: Boolean){
                    editCicloFact(
                    ciclofact:{
                        _id: $_id,
                        cicloFact: $cicloFact,
                        noFactRET: $noFactRET
                    }
                ){
                    success
                    errors{
                        path
                        message
                    }                
                }
            }
            `,
              editClaseServ: gpl`
                mutation($_id: ID!, $descrClaseServ: String!){
                  editClaseServ(
                  claseserv:{
                      _id: $_id,
                      descrClaseServ: $descrClaseServ
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editTipoAju: gpl`
                mutation($_id: ID!, $descrTipoAju: String!){
                  editTipoAju(
                  tipoaju:{
                      _id: $_id,
                      descrTipoAju: $descrTipoAju
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
            `,
            editSubclaseServ: gpl`
              mutation($_id: ID!, $descrSubclaseServ: String!){
                editSubclaseServ(
                  subclaseserv:{
                    _id: $_id,
                    descrSubclaseServ: $descrSubclaseServ
                }
            ){
                success
                errors{
                    path
                    message
                }                
            }
        }
    `,
        editServicio: gpl`
                mutation($_id: ID!, $nombreResumido: String!, $descripcionServicio: String!,
                  $conceptoEnFra: String, $consecEnFra: Number, $paraProcMasDX: String!){
                    editServicio(
                        servicio:{
                            _id: $_id,
                            nombreResumido: $nombreResumido,
                            descripcionServicio: $descripcionServicio,
                            conceptoEnFra: $conceptoEnFra
                            consecEnFra: $consecEnFra
                            paraProcMasDX: $paraProcMasDX
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editDetalleDXMany: gpl`
                mutation($detalledx: [iDetalleDXUpdMany]){
                    editDetalleDXMany(
                        detalledx: $detalledx
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    editDetalleDX: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String){
                        editDetalleDX(
                            detalledx:{
                                _id: $_id,
                                tipoAct: $tipoAct
                                contrato: $contrato
                                contratoNvo: $contratoNvo
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                editMovClientesDXMany: gpl`
                mutation($movcliente: [iMovClientesUpdDX]){
                    editMovClientesDXMany(
                        movcliente: $movcliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
                editMovClientesMany: gpl`
                mutation($movcliente: [iMovClientesUpd]){
                    editMovClientesMany(
                        movcliente: $movcliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
                editMovClientes: gpl`
                  mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                          $procesado: String,
                          $numeroOdeDX: Number, $concepto: String, $numeroFra: String,
                          $numeroRC: String, $numeroCE: String, $documento: String, $valorPagado: Number,
                          $valorPendiente: Number, $fechaUltPago: Date, $valorUltPago: Number){
                      editMovClientes(
                        movcliente:{
                              _id: $_id,
                              tipoAct: $tipoAct,
                              contrato: $contrato,
                              contratoNvo: $contratoNvo,
                              procesado: $procesado,
                              numeroOdeDX: $numeroOdeDX,
                              concepto: $concepto,
                              numeroFra: $numeroFra,
                              numeroRC: $numeroRC,
                              numeroCE: $numeroCE,
                              documento: $documento,
                              valorPagado: $valorPagado,
                              valorPendiente: $valorPendiente
                              fechaUltPago: $fechaUltPago,
                              valorUltPago: $valorUltPago,
                          }
                      ){
                          success
                          errors{
                              path
                              message
                          }                
                      }
                  }
                  `,
                  editMovCliCCMany: gpl`
                  mutation($movcliente: [iMovCliCCUpd]){
                      editMovCliCCMany(
                          movcliente: $movcliente
                      ){
                          success
                          errors{
                              path
                              message
                              }                
                          }
                      }
                  `,
                  editMovCliCC: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                            $procesado: String,
                            $numeroOdeDX: Number, $concepto: String, $numeroFra: String,
                            $numeroRC: String, $numeroCE: String, $documento: String, $valorPagado: Number,
                            $fechaUltPago: Date, $valorUltPago: Number){
                        editMovCliCC(
                          movcliente:{
                                _id: $_id,
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                                procesado: $procesado,
                                numeroOdeDX: $numeroOdeDX,
                                concepto: $concepto,
                                numeroFra: $numeroFra,
                                numeroRC: $numeroRC,
                                numeroCE: $numeroCE,
                                documento: $documento,
                                valorPagado: $valorPagado,
                                fechaUltPago: $fechaUltPago,
                                valorUltPago: $valorUltPago,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editPagoClientes: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                      $descripcionPago: String, $fechaPago: Date, $numeroFra: String, $numeroRC: String,
                      $documento: String, $numeroRT: String, $numeroDocum: String, $descrRecurso: String
                      $valorTotal: Number, $valorEf: Number, $valorCh: Number, $numeroCh: String,
                      $bancoCh: String, $fechaVencCh: Date, $valorTr: Number, $bancoTr: String,
                      $fechaTr: Date, $valorTD: Number, $bancoTD: String, $valorTC: Number,
                      $bancoTC: String, $razonap: String){
                      editPagoClientes(
                        pagocliente:{
                                _id: $_id,
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                                descripcionPago: $descripcionPago
                                fechaPago: $fechaPago
                                numeroFra: $numeroFra
                                numeroRC: $numeroRC
                                documento: $documento
                                numeroRT: $numeroRT
                                numeroDocum: $numeroDocum
                                descrRecurso: $descrRecurso
                                valorTotal: $valorTotal
                                valorEf: $valorEf
                                valorCh: $valorCh
                                numeroCh: $numeroCh
                                bancoCh: $bancoCh
                                fechaVencCh: $fechaVencCh
                                valorTr: $valorTr
                                bancoTr: $bancoTr
                                fechaTr: $fechaTr
                                valorTD: $valorTD
                                bancoTD: $bancoTD
                                valorTC: $valorTC
                                bancoTC: $bancoTC
                                razonap: $razonap
                                  }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editFacturacion: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String,
                        $codProcFact: String, $numeroFra: String, $fechaFact: Date){
                      editFacturacion(
                        facturacion:{
                                tipoAct: $tipoAct,
                                contrato: $contrato,
                                contratoNvo: $contratoNvo,
                                codProcFact: $codProcFact,
                                numeroFra: $numeroFra,
                                fechaFact: $fechaFact,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,editCargoEsp: gpl`
                    mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                        $numeroCE: String, $fechaCE: Date){
                      editCargoEsp(
                        cargoesp:{
                            _id: $_id,
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                            numeroCE: $numeroCE,
                            fechaCE: $fechaCE,
                          }
                        ){
                          success
                          errors{
                            path
                            message
                          }                
                        }
                    }
                    `,
                    editNotasDebCre: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String,
                        $numeroFra: String, $fechaNota: Date){
                      editNotasDebCre(
                        notasdebcre:{
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                            numeroFra: $numeroFra,
                            fechaNota: $fechaNota,
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editAjuste: gpl`
                    mutation($tipoAct: String, $contrato: String, $contratoNvo: String){
                        editAjuste(
                            ajuste:{
                                tipoAct: $tipoAct
                                contrato: $contrato     
                                contratoNvo: $contratoNvo   
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    editFacturacionUpdDoc: gpl`
                      mutation($_id: ID, $tipoAct: String, $numeroFra: String,
                        $codigoServicio: String, $nombreResumido: String,
                        $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                        $periodo: String, $tipo: String, $consecEnFra: Number,
                        $porcImpto: Number, $valor: Number){
                          editFacturacionUpdDoc(
                            facturacion:{
                              _id: $_id
                              tipoAct: $tipoAct
                              numeroFra: $numeroFra
                              detalleFact:{
                                codigoServicio: $codigoServicio
                                nombreResumido: $nombreResumido
                                descripcionServicio: $descripcionServicio
                                descrClaseServ: $descrClaseServ
                                concepto: $concepto
                                periodo: $periodo
                                tipo: $tipo
                                consecEnFra: $consecEnFra
                                porcImpto: $porcImpto
                                valor: $valor
                              },
                            }
                          ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                      }
                      `,
                      editCargoEspUpdDoc: gpl`
                        mutation($_id: ID, $tipoAct: String, $numeroCE: String,
                          $_idMC: String, $codigoServicio: String, $nombreResumido: String,
                          $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                          $periodo: String, $tipo: String, $consecEnCE: Number,
                          $porcImpto: Number, $valor: Number){
                            editCargoEspUpdDoc(
                              cargoesp:{
                                _id: $_id
                                tipoAct: $tipoAct
                                numeroCE: $numeroCE
                                detalleCE:{
                                  _idMC: $_idMC
                                  codigoServicio: $codigoServicio
                                  nombreResumido: $nombreResumido
                                  descripcionServicio: $descripcionServicio
                                  descrClaseServ: $descrClaseServ
                                  concepto: $concepto
                                  periodo: $periodo
                                  tipo: $tipo
                                  consecEnCE: $consecEnCE
                                  porcImpto: $porcImpto
                                  valor: $valor
                                },
                              }
                            ){
                              success
                              errors{
                                  path
                                  message
                              }                
                          }
                        }
                        `,
                        editNotasDebCreUpdDoc: gpl`
                        mutation($_id: ID, $tipoAct: String, $numeroFra: String,
                          $_idMC: String, $codigoServicio: String, $nombreResumido: String,
                          $descripcionServicio: String, $descrClaseServ: String, $concepto: String,
                          $periodo: String, $tipo: String, $consecEnFra: Number,
                          $porcImpto: Number, $valor: Number){
                            editNotasDebCreUpdDoc(
                              notasdebcre:{
                                _id: $_id
                                tipoAct: $tipoAct
                                numeroFra: $numeroFra
                                detalleNota:{
                                  _idMC: $_idMC
                                  codigoServicio: $codigoServicio
                                  nombreResumido: $nombreResumido
                                  descripcionServicio: $descripcionServicio
                                  descrClaseServ: $descrClaseServ
                                  concepto: $concepto
                                  periodo: $periodo
                                  tipo: $tipo
                                  consecEnFra: $consecEnFra
                                  porcImpto: $porcImpto
                                  valor: $valor
                                },
                              }
                            ){
                              success
                              errors{
                                  path
                                  message
                              }                
                          }
                        }
                        `,
                          editMovClientesUpdDoc: gpl`
                            mutation($_id: ID, $tipoAct: String, $origen: String,
                                $codigoServicio: String, $codigoImpto: String,
                                $descrImpto: String, $porcImpto: Number, $valorImpto: Number){
                                editMovClientesUpdDoc(
                                    movcliente:{
                                        _id: $_id,
                                        tipoAct: $tipoAct,
                                        origen: $origen,
                                        codigoServicio: $codigoServicio,
                                        imptos:{
                                            codigoImpto: $codigoImpto,
                                            descrImpto: $descrImpto,
                                            porcImpto: $porcImpto,
                                            valorImpto: $valorImpto,
                                        }
                                                    }
                                ){
                                    success
                                    errors{
                                        path
                                        message
                                    }                
                                }
                            }
                            `,
                            editMovCliCCUpdDoc: gpl`
                              mutation($_id: ID, $tipoAct: String, $origen: String,
                                  $codigoServicio: String, $codigoImpto: String,
                                  $descrImpto: String, $porcImpto: Number, $valorImpto: Number){
                                  editMovCliCCUpdDoc(
                                      movcliente:{
                                          _id: $_id,
                                          tipoAct: $tipoAct,
                                          origen: $origen,
                                          codigoServicio: $codigoServicio,
                                          imptos:{
                                              codigoImpto: $codigoImpto,
                                              descrImpto: $descrImpto,
                                              porcImpto: $porcImpto,
                                              valorImpto: $valorImpto,
                                          }
                                                      }
                                  ){
                                      success
                                      errors{
                                          path
                                          message
                                      }                
                                  }
                              }
                              `,
                              editMovClientesPHMany: gpl`
                                mutation($movcliente: [iMovClientesUpdPH]){
                                    editMovClientesPHMany(
                                        movcliente: $movcliente
                                    ){
                                        success
                                        errors{
                                            path
                                            message
                                            }                
                                        }
                                    }
                                    `,
                            editPagoClientesUpdDoc: gpl`
                            mutation($_id: ID, $tipoAct: String, $contrato: String,
                                $idMovClientes: String, $codigoServicio: String,
                                $nombreResumido: String, $descripcionServicio: String,
                                $descrClaseServ: String, $concepto: String,
                                $periodo: String, $valorTotal: Number, $valorDetalle: Number){
                                  editPagoClientesUpdDoc(
                                    pagocliente:{
                                      _id: $_id,
                                      tipoAct: $tipoAct,
                                      contrato: $contrato,
                                      detalle:{
                                        idMovClientes: $idMovClientes,
                                        codigoServicio: $codigoServicio,
                                        nombreResumido: $nombreResumido,
                                        descripcionServicio: $descripcionServicio,
                                        descrClaseServ: $descrClaseServ,
                                        concepto: $concepto,
                                        periodo: $periodo,
                                        valorTotal: $valorTotal,
                                        valorDetalle: $valorDetalle
                                      }
                                    }
                                ){
                                  success
                                  errors{
                                    path
                                    message
                                  }                
                                }
                            }
                            `,
                        editOdeS: gpl`
                        mutation($numeroOS: Number, $estadoOS: String, $impresa: Boolean,
                            $observacAB: String, $observacCE: String, $observacCA: String,
                            $codigoTipoDocV: String, $numeroDocumV: String, $descrRecursoV: String,
                            $tag: String, $horaSolic: String, $nombreSolic: String, $fechaImpr: Date,
                            $usuarioImpr: String, $fechaClose: Date, $usuarioClose: String,
                            $fechaCanc: Date, $usuarioCanc: String, $fechaEjec: Date, $fechaFra: Date){
                            editOdeS(odes:{
                                numeroOS: $numeroOS
                                estadoOS: $estadoOS
                                impresa: $impresa
                                observacAB: $observacAB
                                observacCE: $observacCE
                                observacCA: $observacCA
                                codigoTipoDocV: $codigoTipoDocV
                                numeroDocumV: $numeroDocumV
                                descrRecursoV: $descrRecursoV
                                tag: $tag
                                horaSolic: $horaSolic
                                nombreSolic: $nombreSolic
                                fechaImpr: $fechaImpr
                                usuarioImpr: $usuarioImpr
                                fechaClose: $fechaClose
                                usuarioClose: $usuarioClose
                                fechaCanc: $fechaCanc
                                usuarioCanc: $usuarioCanc
                                fechaEjec: $fechaEjec
                                fechaFra: $fechaFra
                            }
                            ){
                                success
                                errors{
                                    path
                                    message
                                }
                            }
                        }
                        `,
            editOdeSUpdDoc: gpl`
                mutation($_id: ID, $tipoAct: String, $numeroOS: Number, $observacAB: String,
                    $observacCE: String, $observacCA: String, $codigoDpto: String,
                    $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String, $codigoZona: String,
                    $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $descrTipoVia1: String, $numeroTipoVia1: String, $descrTipoVia2: String,
                    $numeroTipoVia2:String, $numeroTipoVia2F: String, $descrTipoUnd1: String,
                    $numeroTipoUnd1: String, $descrTipoUnd2: String, $numeroTipoUnd2: String,
                    $descrTiUndMat: String, $descrUndMat: String,
                    $codigoTarifa: String, $descrTarifa: String, $cicloFact: String, $fechaVence: Date,
                    $codigoServicioT: String, $nombreResumidoT: String, $descripcionServicioT: String,
                    $_idSubclaseServT: ID, $codigoSubclaseServT: String, $descrSubclaseServT: String,
                    $_idClaseServT: ID, $codigoClaseServT: String, $descrClaseServT: String,
                    $estadoServicio: String,
                    $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                    $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                    $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                    $numeroServicios: Number, $valorServicios: Number, $valorAntesImptos: Number,
                    $codigoImpto: String, $descrImpto: String, $porcImpto: Number, $valorImpto: Number,
                    $descrClaseServ: String, $codigoServicio: String, $nombreResumido: String,
                    $descripcionServicio: String, $fechaCargo: Date, $conceptoEnFra: String,
                    $periodoFrado: String, $origen: String, $numeroServiciosCF: Number,
                    $valorTotal: Number, $valorAntesImptosCF: Number, $codigoImptoCF: String,
                    $descrImptoCF: String, $porcImptoCF: Number, $valorImptoCF: Number,
                    $agnoFra: String, $mesFra: String,
                    $codigoOferta: String, $descrOferta: String,
                    $codigoServicioO: String, $nombreResumidoO: String, $descripcionServicioO: String,
                    $_idSubclaseServO: ID, $codigoSubclaseServO: String, $descrSubclaseServO: String,
                    $_idClaseServO: ID, $codigoClaseServO: String, $descrClaseServO: String,
                    $porcDctoOferta: Number, $numDiasOferta: Number, $fechaFinOferta: Date,
                    $fechaInicioOferta: Date, $numeroSerie: String, $mac: String, $accion: String,
                    $_idClaseEqu: ID, $codigoClaseEqu: String, $descrClaseEqu: String,
                    $_idMarcaEqu: ID, $codigoMarcaEqu: String, $descrMarcaEqu: String,
                    $_idFabriEqu: ID, $codigoFabriEqu: String, $descrFabriEqu: String,
                    $_idBodega: ID, $codigoBodega: String, $descrBodega: String,
                    $_idRecurso: ID, $codigoTipoDoc: String, $numeroDocum: String, $descrRecurso: String,
                    $_idTipoRec: ID, $descrTipoRec: String, $areaAprovech: String
                ){
                    editOdeSUpdDoc(odes:{
                        _id: $_id,
                        tipoAct: $tipoAct,
                        numeroOS: $numeroOS,
                        observacAB: $observacAB,
                        observacCE: $observacCE,
                        observacCA: $observacCA,
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto,
                            ciudades:{
                                codigoCiudad: $codigoCiudad,
                                nombreCiudad: $nombreCiudad,
                                zonas:{
                                    codigoZona: $codigoZona,
                                    nombreZona: $nombreZona,
                                    barrios:{
                                        codigoBarrio: $codigoBarrio,
                                        nombreBarrio: $nombreBarrio,
                                        codigoTipoDocT: $codigoTipoDocT,
                                        numeroDocumT: $numeroDocumT,
                                        descrRecursoT: $descrRecursoT,
                                        codigoTipoDocR: $codigoTipoDocR,
                                        numeroDocumR: $numeroDocumR,
                                        descrRecursoR: $descrRecursoR
                                    }
                                }
                            }
                        },
                        direccion:{
                            descrTipoVia1: $descrTipoVia1,
                            numeroTipoVia1: $numeroTipoVia1,
                            descrTipoVia2: $descrTipoVia2,
                            numeroTipoVia2: $numeroTipoVia2,
                            numeroTipoVia2F: $numeroTipoVia2F,
                            descrTipoUnd1: $descrTipoUnd1,
                            numeroTipoUnd1: $numeroTipoUnd1,
                            descrTipoUnd2: $descrTipoUnd2,
                            numeroTipoUnd2: $numeroTipoUnd2,
                            descrTiUndMat: $descrTiUndMat,
                            descrUndMat: $descrUndMat
                        },
                        tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            fechaVence: $fechaVence,
                            servicios:{
                                codigoServicio: $codigoServicioT,
                                nombreResumido: $nombreResumidoT,
                                descripcionServicio: $descripcionServicioT,
                                subclaseserv:{
                                    _id: $_idSubclaseServT,
                                    codigoSubclaseServ: $codigoSubclaseServT,
                                    descrSubclaseServ: $descrSubclaseServT
                                    claseserv:{
                                        _id: $_idClaseServT,
                                        codigoClaseServ: $codigoClaseServT,
                                        descrClaseServ: $descrClaseServT
                                    },
                                },
                                estadoServicio: $estadoServicio,
                                rango1NumServValorIni: $rango1NumServValorIni,
                                rango1NumServValorFin: $rango1NumServValorFin,
                                rango1Valor: $rango1Valor,
                                rango2NumServValorIni: $rango2NumServValorIni,
                                rango2NumServValorFin: $rango2NumServValorFin,
                                rango2Valor: $rango2Valor,
                                rango3NumServValorIni: $rango3NumServValorIni,
                                rango3NumServValorFin: $rango3NumServValorFin,
                                rango3Valor: $rango3Valor,
                                numeroServicios: $numeroServicios,
                                valorServicios: $valorServicios,
                                valorAntesImptos: $valorAntesImptos,
                                imptos:{
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    valorImpto: $valorImpto,
                                }
                            }
                        },
                        cargoFra:{
                            descrClaseServ: $descrClaseServ,
                            codigoServicio: $codigoServicio,
                            nombreResumido: $nombreResumido,
                            descripcionServicio: $descripcionServicio,
                            fechaCargo: $fechaCargo,
                            conceptoEnFra: $conceptoEnFra,
                            periodoFrado: $periodoFrado,
                            origen: $origen,
                            numeroServicios: $numeroServiciosCF,
                            valorTotal: $valorTotal,
                            valorAntesImptos: $valorAntesImptosCF,
                            imptos:{
                                codigoImpto: $codigoImptoCF,
                                descrImpto: $descrImptoCF,
                                porcImpto: $porcImptoCF,
                                valorImpto: $valorImptoCF,
                            }
                            agnoFra: $agnoFra,
                            mesFra: $mesFra,
                        },
                        oferta:{
                            codigoOferta: $codigoOferta,
                            descrOferta: $descrOferta,
                            servicios:{
                                codigoServicio: $codigoServicioO,
                                nombreResumido: $nombreResumidoO,
                                descripcionServicio: $descripcionServicioO,
                                subclaseserv:{
                                    _id: $_idSubclaseServO,
                                    codigoSubclaseServ: $codigoSubclaseServO,
                                    descrSubclaseServ: $descrSubclaseServO
                                    claseserv:{
                                        _id: $_idClaseServO,
                                        codigoClaseServ: $codigoClaseServO,
                                        descrClaseServ: $descrClaseServO
                                    }
                                },
                                porcDctoOferta: $porcDctoOferta,
                                numDiasOferta: $numDiasOferta,
                                fechaFinOferta: $fechaFinOferta,
                            },
                            fechaInicioOferta: $fechaInicioOferta
                        },
                        equipos:{
                            numeroSerie: $numeroSerie,
                            mac: $mac,
                            accion: $accion,
                            claseequ:{
                                _id: $_idClaseEqu,
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            },
                            marcaequ:{
                                _id: $_idMarcaEqu,
                                codigoMarcaEqu: $codigoMarcaEqu,
                                descrMarcaEqu: $descrMarcaEqu
                            },
                            fabriequ:{
                                _id: $_idFabriEqu,
                                codigoFabriEqu: $codigoFabriEqu,
                                descrFabriEqu: $descrFabriEqu
                            },
                            bodega:{
                                _id: $_idBodega,
                                codigoBodega: $codigoBodega,
                                descrBodega: $descrBodega
                            },
                        },
                        recursos:{
                            _id: $_idRecurso,
                            codigoTipoDoc: $codigoTipoDoc,
                            numeroDocum: $numeroDocum,
                            descrRecurso: $descrRecurso,
                            tiporec:{
                                _id: $_idTipoRec,
                                descrTipoRec: $descrTipoRec,
                                areaAprovech: $areaAprovech
                            }
                        }
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editOdeSContr: gpl`
                mutation($tipoAct: String, $contrato: String, $contratoNvo: String){
                    editOdeSContr(
                      odes:{
                            tipoAct: $tipoAct
                            contrato: $contrato
                            contratoNvo: $contratoNvo
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                updDocumMany: gpl`
                mutation($docum: [iUpdDocum]){
                  updDocumMany(
                    docum: $docum
                  ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
            editClienteMany: gpl`
                mutation($cliente: [iClienteUpd]){
                    editClienteMany(
                      cliente: $cliente
                    ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    editClienteUpdDocMany: gpl`
                    mutation($cliente: [iClienteUpdDoc]){
                        editClienteUpdDocMany(
                          cliente: $cliente
                        ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                    `,
                editCliente: gpl`
                mutation($_id: ID, $tipoAct: String, $contrato: String, $contratoNvo: String,
                        $estadoCliente: String, $cargoMensual: Number,
                        $saldoPendiente: Number, $diasMora: Number, $pagueHasta: Date,
                        $totPagoAdelSinFrar: Number,
                        $nombreCliente: String, $apellidoCliente: String, $sexoCliente: String,
                        $eMail: String, $observaciones: String, $descrEstrato: String,
                        $cicloFact: String, $tag: String, $referencia1: String, $telefonoRef1: String, 
                        $referencia2: String, $telefonoRef2: String, 
                        $fechaUltOSAb: Date, $fechaPrimeraActivacion: Date, $fechaUltDX: Date, 
                        $fecgaUltRX: Date, $estadoAnterior: String, $fechaUltOSCe: Date, 
                        $fechaUltPago: Date, $valorUltPago: Number, $cupoFinanc: Number, 
                        $numeroOdeDX: Number, $numeroDoc: String,
                        $telefono1: String, $telefono2: String, $telefono3: String,
                        $idTipoCl: ID, $codigoTipoCliente: String, $descrTipoCliente: String,
                        $idTipoDoc: ID, $codigoTipoDoc: String, $descrTipoDoc: String,
                        $idGrupoAf: ID, $codigoGrupoAfin: String, $descrGrupoAfin: String,
                        $_idAnteriorTC: ID){
                    editCliente(
                    cliente:{
                        _id: $_id,
                        tipoAct: $tipoAct
                        contrato: $contrato
                        contratoNvo: $contratoNvo
                        estadoCliente: $estadoCliente
                        cargoMensual: $cargoMensual
                        saldoPendiente: $saldoPendiente
                        diasMora: $diasMora
                        pagueHasta: $pagueHasta
                        totPagoAdelSinFrar: $totPagoAdelSinFrar
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        sexoCliente: $sexoCliente,
                        eMail: $eMail,
                        descrEstrato: $descrEstrato,
                        cicloFact: $cicloFact,
                        tag: $tag,
                        referencia1: $referencia1,
                        telefonoRef1: $telefonoRef1,
                        referencia2: $referencia2,
                        telefonoRef2: $telefonoRef2,
                        fechaUltOSAb: $fechaUltOSAb,
                        fechaPrimeraActivacion: $fechaPrimeraActivacion,
                        fechaUltDX: $fechaUltDX,
                        fecgaUltRX: $fecgaUltRX,
                        estadoAnterior: $estadoAnterior,
                        fechaUltOSCe: $fechaUltOSCe,
                        fechaUltPago: $fechaUltPago,
                        valorUltPago: $valorUltPago,
                        cupoFinanc: $cupoFinanc,
                        numeroOdeDX: $numeroOdeDX,
                        telefono1: $telefono1,
                        telefono2: $telefono2,
                        telefono3: $telefono3,
                        numeroDoc: $numeroDoc,
                        observaciones: $observaciones,
                        tipocl:{
                            _id: $idTipoCl,
                            codigoTipoCliente: $codigoTipoCliente,
                            descrTipoCliente: $descrTipoCliente
                        },
                        tipodoc:{
                            _id: $idTipoDoc,
                            codigoTipoDoc: $codigoTipoDoc,
                            descrTipoDoc: $descrTipoDoc
                        },
                        grupoaf:{
                            _id: $idGrupoAf,
                            codigoGrupoAfin: $codigoGrupoAfin,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    },
                    _idAnteriorTC: $_idAnteriorTC
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                editTarifa: gpl`
                    mutation($_id: ID, $descrTarifa: String, $cicloFact: String, $estadoTarifa: Boolean){
                        editTarifa(
                            tarifa:{
                            _id: $_id,
                            descrTarifa: $descrTarifa,
                            cicloFact: $cicloFact,
                            estadoTarifa: $estadoTarifa,
                        }
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
            editTarifaUpdServ: gpl`
                mutation($_id: ID, $descrTarifa: String, $estadoTarifa: Boolean,
                        $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String,
                        $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String,
                        $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String,
                        $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                        $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                        $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                        $_idImpto: ID, $codigoImpto: String, $descrImpto: String, $porcImpto: Number,
                        $codigoTipoOS: String, $descrTipoOS: String,
                        $concepto1Tarifa: String, $valor1Tarifa: Number, $concepto2Tarifa: String, $valor2Tarifa: Number,
                        $concepto3Tarifa: String, $valor3Tarifa: Number,
                        $_idImptoTipoOS: ID, $codigoImptoTipoOS: String, $descrImptoTipoOS: String, $porcImptoTipoOS: Number,
                        $tipoAct: String){
                            editTarifaUpdServ(tarifa:{
                                _id: $_id,
                                descrTarifa: $descrTarifa,
                                estadoTarifa: $estadoTarifa,
                                tipoAct: $tipoAct,
                                servicios:{
                                    codigoServicio: $codigoServicio,
                                    nombreResumido: $nombreResumido,
                                    descripcionServicio: $descripcionServicio,
                                    subclaseserv:{
                                        _id: $_idSubclaseServ,
                                        codigoSubclaseServ: $codigoSubclaseServ,
                                        descrSubclaseServ: $descrSubclaseServ
                                        claseserv:{
                                            _id: $_idClaseServ,
                                            codigoClaseServ: $codigoClaseServ,
                                            descrClaseServ: $descrClaseServ
                                        },
                                    },
                                    rango1NumServValorIni: $rango1NumServValorIni,
                                    rango1NumServValorFin: $rango1NumServValorFin,
                                    rango1Valor: $rango1Valor,
                                    rango2NumServValorIni: $rango2NumServValorIni,
                                    rango2NumServValorFin: $rango2NumServValorFin,
                                    rango2Valor: $rango2Valor,
                                    rango3NumServValorIni: $rango3NumServValorIni,
                                    rango3NumServValorFin: $rango3NumServValorFin,
                                    rango3Valor: $rango3Valor,
                                    imptos:{
                                        _id: $_idImpto,
                                        codigoImpto: $codigoImpto,
                                        descrImpto: $descrImpto,
                                        porcImpto: $porcImpto,
                                    }
                                },
                                tipoos:{
                                    codigoTipoOS: $codigoTipoOS,
                                    descrTipoOS: $descrTipoOS,
                                    concepto1Tarifa: $concepto1Tarifa,
                                    valor1Tarifa: $valor1Tarifa,
                                    concepto2Tarifa: $concepto2Tarifa,
                                    valor2Tarifa: $valor2Tarifa,
                                    concepto3Tarifa: $concepto3Tarifa,
                                    valor3Tarifa: $valor3Tarifa,
                                    imptos:{
                                        _id: $_idImptoTipoOS,
                                        codigoImpto: $codigoImptoTipoOS,
                                        descrImpto: $descrImptoTipoOS,
                                        porcImpto: $porcImptoTipoOS,
                                    }
                                }
                            }){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        editOferta: gpl`
                            mutation($_id: ID, $descrOferta: String, $estadoOferta: Boolean){
                                editOferta(
                                    oferta:{
                                    _id: $_id,
                                    descrOferta: $descrOferta,
                                    estadoOferta: $estadoOferta,
                                }
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                        `,
                    editOfertaUpdServ: gpl`
                        mutation($_id: ID, $descrOferta: String, $estadoOferta: Boolean,
                                $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String,
                                $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String,
                                $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String,
                                $porcDctoOferta: Number, $numDiasOferta: Number,
                                $tipoAct: String){
                                    editOfertaUpdServ(oferta:{
                                        _id: $_id,
                                        descrOferta: $descrOferta,
                                        estadoOferta: $estadoOferta,
                                        tipoAct: $tipoAct,
                                        servicios:{
                                            codigoServicio: $codigoServicio,
                                            nombreResumido: $nombreResumido,
                                            descripcionServicio: $descripcionServicio,
                                            subclaseserv:{
                                                _id: $_idSubclaseServ,
                                                codigoSubclaseServ: $codigoSubclaseServ,
                                                descrSubclaseServ: $descrSubclaseServ
                                                claseserv:{
                                                    _id: $_idClaseServ,
                                                    codigoClaseServ: $codigoClaseServ,
                                                    descrClaseServ: $descrClaseServ
                                                },
                                            },
                                            porcDctoOferta: $porcDctoOferta,
                                            numDiasOferta: $numDiasOferta,
                                        },
                                    }){
                                    success
                                    errors{
                                        path
                                        message
                                        }                
                                    }
                                }
                            `,
                    editDpto: gpl`
                mutation($_id: ID!, $descrDpto: String!){
                    editDpto(
                        dirmayor:{
                            _id: $_id,
                            descrDpto: $descrDpto,
                        }
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editClienteUpdDoc: gpl`
                mutation($_id: ID, $tipoAct: String, $contrato: String, $nombreCliente: String,
                    $apellidoCliente: String,
                    $codigoDpto: String,
                    $descrDpto: String, $codigoCiudad: String, $nombreCiudad: String, $codigoZona: String,
                    $nombreZona: String, $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $descrTipoVia1: String, $numeroTipoVia1: String, $descrTipoVia2: String,
                    $numeroTipoVia2:String, $numeroTipoVia2F: String, $descrTipoUnd1: String,
                    $numeroTipoUnd1: String, $descrTipoUnd2: String, $numeroTipoUnd2: String,
                    $descrTiUndMat: String, $descrUndMat: String,
                    $codigoTarifa: String, $descrTarifa: String, $fechaVence: Date,
                    $codigoServicioT: String, $nombreResumidoT: String, $descripcionServicioT: String,
                    $_idSubclaseServT: ID, $codigoSubclaseServT: String, $descrSubclaseServT: String,
                    $_idClaseServT: ID, $codigoClaseServT: String, $descrClaseServT: String,
                    $estadoServicio: String,
                    $rango1NumServValorIni: Number, $rango1NumServValorFin: Number, $rango1Valor: Number,
                    $rango2NumServValorIni: Number, $rango2NumServValorFin: Number, $rango2Valor: Number,
                    $rango3NumServValorIni: Number, $rango3NumServValorFin: Number, $rango3Valor: Number,
                    $numeroServicios: Number, $valorServicios: Number, $valorAntesImptos: Number,
                    $codigoImpto: String, $descrImpto: String, $porcImpto: Number, $valorImpto: Number,
                    $codigoOferta: String, $descrOferta: String,
                    $codigoServicioO: String, $nombreResumidoO: String, $descripcionServicioO: String,
                    $_idSubclaseServO: ID, $codigoSubclaseServO: String, $descrSubclaseServO: String,
                    $_idClaseServO: ID, $codigoClaseServO: String, $descrClaseServO: String,
                    $porcDctoOferta: Number, $numDiasOferta: Number, $fechaFinOferta: Date,
                    $fechaInicioOferta: Date, $numeroSerie: String, $mac: String,
                    $_idClaseEqu: ID, $codigoClaseEqu: String, $descrClaseEqu: String,
                    $_idMarcaEqu: ID, $codigoMarcaEqu: String, $descrMarcaEqu: String,
                    $_idFabriEqu: ID, $codigoFabriEqu: String, $descrFabriEqu: String,
                    $_idBodega: ID, $codigoBodega: String, $descrBodega: String
                ){
                    editClienteUpdDoc(cliente:{
                        _id: $_id,
                        tipoAct: $tipoAct,
                        contrato: $contrato,
                        nombreCliente: $nombreCliente,
                        apellidoCliente: $apellidoCliente,
                        dirmayor:{
                            codigoDpto: $codigoDpto,
                            descrDpto: $descrDpto,
                            ciudades:{
                                codigoCiudad: $codigoCiudad,
                                nombreCiudad: $nombreCiudad,
                                zonas:{
                                    codigoZona: $codigoZona,
                                    nombreZona: $nombreZona,
                                    barrios:{
                                        codigoBarrio: $codigoBarrio,
                                        nombreBarrio: $nombreBarrio,
                                        codigoTipoDocT: $codigoTipoDocT,
                                        numeroDocumT: $numeroDocumT,
                                        descrRecursoT: $descrRecursoT,
                                        codigoTipoDocR: $codigoTipoDocR,
                                        numeroDocumR: $numeroDocumR,
                                        descrRecursoR: $descrRecursoR,
                                    }
                                }
                            }
                        },
                        direccion:{
                            descrTipoVia1: $descrTipoVia1,
                            numeroTipoVia1: $numeroTipoVia1,
                            descrTipoVia2: $descrTipoVia2,
                            numeroTipoVia2: $numeroTipoVia2,
                            numeroTipoVia2F: $numeroTipoVia2F,
                            descrTipoUnd1: $descrTipoUnd1,
                            numeroTipoUnd1: $numeroTipoUnd1,
                            descrTipoUnd2: $descrTipoUnd2,
                            numeroTipoUnd2: $numeroTipoUnd2,
                            descrTiUndMat: $descrTiUndMat,
                            descrUndMat: $descrUndMat
                        },
                        tarifa:{
                            codigoTarifa: $codigoTarifa,
                            descrTarifa: $descrTarifa,
                            fechaVence: $fechaVence,
                            servicios:{
                                codigoServicio: $codigoServicioT,
                                nombreResumido: $nombreResumidoT,
                                descripcionServicio: $descripcionServicioT,
                                subclaseserv:{
                                    _id: $_idSubclaseServT,
                                    codigoSubclaseServ: $codigoSubclaseServT,
                                    descrSubclaseServ: $descrSubclaseServT
                                    claseserv:{
                                        _id: $_idClaseServT,
                                        codigoClaseServ: $codigoClaseServT,
                                        descrClaseServ: $descrClaseServT
                                    },
                                },
                                estadoServicio: $estadoServicio,
                                rango1NumServValorIni: $rango1NumServValorIni,
                                rango1NumServValorFin: $rango1NumServValorFin,
                                rango1Valor: $rango1Valor,
                                rango2NumServValorIni: $rango2NumServValorIni,
                                rango2NumServValorFin: $rango2NumServValorFin,
                                rango2Valor: $rango2Valor,
                                rango3NumServValorIni: $rango3NumServValorIni,
                                rango3NumServValorFin: $rango3NumServValorFin,
                                rango3Valor: $rango3Valor,
                                numeroServicios: $numeroServicios,
                                valorServicios: $valorServicios,
                                valorAntesImptos: $valorAntesImptos,
                                imptos:{
                                    codigoImpto: $codigoImpto,
                                    descrImpto: $descrImpto,
                                    porcImpto: $porcImpto,
                                    valorImpto: $valorImpto,
                                }
                            }
                        },
                        oferta:{
                            codigoOferta: $codigoOferta,
                            descrOferta: $descrOferta,
                            servicios:{
                                codigoServicio: $codigoServicioO,
                                nombreResumido: $nombreResumidoO,
                                descripcionServicio: $descripcionServicioO,
                                subclaseserv:{
                                    _id: $_idSubclaseServO,
                                    codigoSubclaseServ: $codigoSubclaseServO,
                                    descrSubclaseServ: $descrSubclaseServO
                                    claseserv:{
                                        _id: $_idClaseServO,
                                        codigoClaseServ: $codigoClaseServO,
                                        descrClaseServ: $descrClaseServO
                                    }
                                },
                                porcDctoOferta: $porcDctoOferta,
                                numDiasOferta: $numDiasOferta,
                                fechaFinOferta: $fechaFinOferta,
                            },
                            fechaInicioOferta: $fechaInicioOferta
                        },
                        equipos:{
                            numeroSerie: $numeroSerie,
                            mac: $mac,
                            claseequ:{
                                _id: $_idClaseEqu,
                                codigoClaseEqu: $codigoClaseEqu,
                                descrClaseEqu: $descrClaseEqu
                            },
                            marcaequ:{
                                _id: $_idMarcaEqu,
                                codigoMarcaEqu: $codigoMarcaEqu,
                                descrMarcaEqu: $descrMarcaEqu
                            },
                            fabriequ:{
                                _id: $_idFabriEqu,
                                codigoFabriEqu: $codigoFabriEqu,
                                descrFabriEqu: $descrFabriEqu
                            },
                            bodega:{
                                _id: $_idBodega,
                                codigoBodega: $codigoBodega,
                                descrBodega: $descrBodega
                            }
                        },
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editDptoUpdCiu: gpl`
                mutation($_id: ID!, $codigoDpto: String, $descrDpto: String,
                    $codigoCiudad: String, $nombreCiudad: String, $fechaCreateCiu: Date, $usuarioCreateCiu: String,
                    $codigoZona: String, $nombreZona: String, $fechaCreateZon: Date, $usuarioCreateZon: String,
                    $codigoBarrio: String, $nombreBarrio: String,
                    $codigoTipoDocT: String, $numeroDocumT: String, $descrRecursoT: String,
                    $codigoTipoDocR: String, $numeroDocumR: String, $descrRecursoR: String,
                    $fechaCreateBarr: Date, $usuarioCreateBarr: String,
                    $tipoAct: String){
                    editDptoUpdCiu(dirmayor:{
                        _id: $_id,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        tipoAct: $tipoAct,
                        ciudades:{
                            codigoCiudad: $codigoCiudad,
                            nombreCiudad: $nombreCiudad,
                            fechaCreate: $fechaCreateCiu,
                            usuarioCreate: $usuarioCreateCiu,
                            zonas:{
                                codigoZona: $codigoZona,
                                nombreZona: $nombreZona,
                                fechaCreate: $fechaCreateZon,
                                usuarioCreate: $usuarioCreateZon,
                                barrios:{
                                    codigoBarrio: $codigoBarrio,
                                    nombreBarrio: $nombreBarrio,
                                    codigoTipoDocT: $codigoTipoDocT,
                                    numeroDocumT: $numeroDocumT,
                                    descrRecursoT: $descrRecursoT,
                                    codigoTipoDocR: $codigoTipoDocR,
                                    numeroDocumR: $numeroDocumR,
                                    descrRecursoR: $descrRecursoR,
                                    fechaCreate: $fechaCreateBarr,
                                    usuarioCreate: $usuarioCreateBarr,
                                }
                            }
                        }
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            editUsuario: gpl`
              mutation($_id: ID, $tipoAct: String, $nombreUsuario: String, $nombreUsuarioAnt: String, $claveDeAcceso: String,
                $idPerfil: ID, $descrPerfil: String, $descrEmpresa: String, $versionMacro: Number,
                $cedula: String,
                $ciudad: String,
                $cargo: String, $esLider: String, $suLider: String,
                $telefono: String, $tipo: String, $estado: String,
                $gestionaHallazgos: String, $archivoFirma: String, $modFirma: String){
                  editUsuario(
                    usuario:{
                      _id: $_id,
                      tipoAct: $tipoAct,
                      nombreUsuario: $nombreUsuario,
                      claveDeAcceso: $claveDeAcceso,
                      perfil:{
                        _id: $idPerfil,
                        descrPerfil: $descrPerfil
                    },
                    nombreUsuarioAnt: $nombreUsuarioAnt,
                    descrEmpresa: $descrEmpresa,
                    versionMacro: $versionMacro,
                    cedula: $cedula,
                    ciudad: $ciudad,
                    cargo: $cargo,
                    telefono: $telefono,
                    tipo: $tipo,
                    estado: $estado,
                    esLider: $esLider,
                    suLider: $suLider,
                    gestionaHallazgos: $gestionaHallazgos,
                    archivoFirma: $archivoFirma,
                    modFirma: $modFirma
                  }
                ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              editProcDX: gpl`
                  mutation($_id: ID, $estadoProcDX: String){
                    editProcDX(
                        procdx:{
                              _id: $_id,
                              estadoProcDX: $estadoProcDX
                          }
                      ){
                          success
                          errors{
                              path
                              message
                          }                
                      }
                  }
              `,
              editTipoCliente: gpl`
                mutation($_id: ID!, $descrTipoCliente: String!){
                    editTipoCliente(
                        tipocliente:{
                            _id: $_id,
                            descrTipoCliente: $descrTipoCliente
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
            `,
            editGrupoAfin: gpl`
                mutation($_id: ID!, $descrGrupoAfin: String!){
                    editGrupoAfin(
                        grupoafin:{
                            _id: $_id,
                            descrGrupoAfin: $descrGrupoAfin
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
            `,
            editTipoDoc: gpl`
                mutation($_id: ID!, $descrTipoDoc: String!){
                    editTipoDoc(
                        tipodoc:{
                            _id: $_id,
                            descrTipoDoc: $descrTipoDoc
                        }
                    ){
                        success
                        errors{
                            path
                            message
                        }                
                    }
                }
                `,
                editImpto: gpl`
                    mutation($_id: ID, $descrImpto: String, $porcImpto: Number){
                        editImpto(
                            impto:{
                                _id: $_id,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                `,
                editOtrosPagCl: gpl`
                    mutation($_id: ID, $descrOtrosPagCl: String, $codigoImpto: String, $descrImpto: String,
                            $porcImpto: Number, $descrClaseServ: String){
                        editOtrosPagCl(
                            otrospagcl:{
                                _id: $_id,
                                descrOtrosPagCl: $descrOtrosPagCl,
                                codigoImpto: $codigoImpto,
                                descrImpto: $descrImpto,
                                porcImpto: $porcImpto,
                                descrClaseServ: $descrClaseServ
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                `,
                editTipoOS: gpl`
                mutation($_id: ID, $descrTipoOS: String,
                    $permDireccion: String!, $permTarServ: String!, $permOfertas: String!,
                    $permEquipos: String!, $paraCliNuevo: String!, $estadoCrearOS: String!,
                    $estadoCerrarOS: String!
                ){
                        editTipoOS(
                            tipoos:{
                                _id: $_id,
                                descrTipoOS: $descrTipoOS
                                permDireccion: $permDireccion
                                permTarServ: $permTarServ
                                permOfertas: $permOfertas
                                permEquipos: $permEquipos
                                paraCliNuevo: $paraCliNuevo
                                estadoCrearOS: $estadoCrearOS
                                estadoCerrarOS: $estadoCerrarOS
                            }
                        ){
                            success
                            errors{
                                path
                                message
                            }                
                        }
                    }
                    `,
                    deleteAutorizac: gpl`
                mutation($_id: ID!){
                  deleteAutorizac(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deletePerfil: gpl`
            mutation($_id: ID!){
              deletePerfil(
                    _id: $_id
                ){
                success
                errors{
                    path
                    message
                    }                
                }
            }
        `,
                deleteOdeS: gpl`
                    mutation($_id: ID!){
                        deleteOdeS(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteTipoRec: gpl`
                mutation($_id: ID!){
                    deleteTipoRec(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteRecurso: gpl`
                    mutation($_id: ID!){
                        deleteRecurso(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteRdoTerc: gpl`
                        mutation($_id: ID!){
                            deleteRdoTerc(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                  deleteEquipo: gpl`
                mutation($_id: ID!){
                  deleteEquipo(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteDetalleDX: gpl`
                mutation($_id: ID!){
                    deleteDetalleDX(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteDetalleDXMany: gpl`
            mutation($detalledx: [idetalledxDel]){
                deleteDetalleDXMany(
                    detalledx: $detalledx
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
          deleteMovClientes: gpl`
                mutation($_id: ID!){
                  deleteMovClientes(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deletePagoClientes: gpl`
                mutation($_id: ID!){
                  deletePagoClientes(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteFacturacion: gpl`
                mutation($_id: ID!){
                  deleteFacturacion(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteCargoEsp: gpl`
                mutation($_id: ID!){
                  deleteCargoEsp(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteNotasDebCre: gpl`
                mutation($_id: ID!){
                  deleteNotasDebCre(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteAjuste: gpl`
                mutation($_id: ID!){
                    deleteAjuste(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteRangoFact: gpl`
                mutation($_id: ID!){
                  deleteRangoFact(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteProcFact: gpl`
                mutation($_id: ID!){
                  deleteProcFact(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
              deleteProcCE: gpl`
                mutation($_id: ID!){
                  deleteProcCE(
                    _id: $_id
                  ){
                    success
                    errors{
                    path
                    message
                  }
                }
              }
              `,
                deleteTiUndMat: gpl`
                mutation($_id: ID!){
                    deleteTiUndMat(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteClaseEqu: gpl`
                    mutation($_id: ID!){
                        deleteClaseEqu(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteMarcaEqu: gpl`
                        mutation($_id: ID!){
                            deleteMarcaEqu(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteFabriEqu: gpl`
                            mutation($_id: ID!){
                                deleteFabriEqu(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                            deleteBodega: gpl`
                                mutation($_id: ID!){
                                    deleteBodega(
                                        _id: $_id
                                    ){
                                    success
                                    errors{
                                        path
                                        message
                                        }                
                                    }
                                }
                                `,
                                deleteUndMat: gpl`
                    mutation($_id: ID!){
                        deleteUndMat(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteTipoUnd: gpl`
                        mutation($_id: ID!){
                            deleteTipoUnd(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteTipoVia: gpl`
                            mutation($_id: ID!){
                                deleteTipoVia(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                        deleteEstrato: gpl`
                        mutation($_id: ID!){
                            deleteEstrato(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                        `,
                        deleteCicloFact: gpl`
                        mutation($_id: ID!){
                            deleteCicloFact(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
              `,
              deleteClaseServ: gpl`
                mutation($_id: ID!){
                  deleteClaseServ(
                    _id: $_id
                  ){
                  success
                  errors{
                    path
                    message
                    }                
                  }
              }
              `,
              deleteTipoAju: gpl`
                mutation($_id: ID!){
                  deleteTipoAju(
                    _id: $_id
                  ){
                  success
                  errors{
                    path
                    message
                  }                
                }
              }
              `,
              deleteBaseDat: gpl`
                mutation($_id: ID!){
                  deleteBaseDat(
                    _id: $_id
                  ){
                  success
                  errors{
                    path
                    message
                    }                
                  }
              }
            `,
            deleteTipoCliente: gpl`
                mutation($_id: ID!){
                    deleteTipoCliente(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            deleteGrupoAfin: gpl`
                mutation($_id: ID!){
                    deleteGrupoAfin(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            deleteTipoDoc: gpl`
                mutation($_id: ID!){
                    deleteTipoDoc(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteImpto: gpl`
                    mutation($_id: ID!){
                        deleteImpto(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteOtrosPagCl: gpl`
                        mutation($_id: ID!){
                            deleteOtrosPagCl(
                                _id: $_id
                            ){
                            success
                            errors{
                                path
                                message
                                }                
                            }
                        }
                    `,
                    deleteSubclaseServ: gpl`
                mutation($_id: ID!){
                    deleteSubclaseServ(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteTipoOS: gpl`
                    mutation($_id: ID!){
                        deleteTipoOS(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                    deleteTarifa: gpl`
                    mutation($_id: ID!){
                        deleteTarifa(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                    `,
                            deleteOferta: gpl`
                            mutation($_id: ID!){
                                deleteOferta(
                                    _id: $_id
                                ){
                                success
                                errors{
                                    path
                                    message
                                    }                
                                }
                            }
                            `,
                        deleteCliente: gpl`
                mutation($_id: ID!, $contrato: String, $paraLog: String){
                    deleteCliente(
                        _id: $_id
                        contrato: $contrato
                        paraLog: $paraLog
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
        deleteClienteUpdDoc: gpl`
            mutation($_id: ID!, $nombreCliente: String, $apellidoCliente: String, $_idServicio: String, $codigoServicio: String, $nombreResumido: String, $descripcionServicio: String, $_idSubclaseServ: ID, $codigoSubclaseServ: String, $descrSubclaseServ: String, $_idClaseServ: ID, $codigoClaseServ: String, $descrClaseServ: String){
                deleteClienteUpdDoc(cliente:{
                    _id: $_id,
                    nombreCliente: $nombreCliente,
                    apellidoCliente: $apellidoCliente,
                    servicios:{
                        _id: $_idServicio,
                        codigoServicio: $codigoServicio,
                        nombreResumido: $nombreResumido,
                        descripcionServicio: $descripcionServicio,
                        subclaseserv:{
                            _id: $_idSubclaseServ,
                            codigoSubclaseServ: $codigoSubclaseServ,
                            descrSubclaseServ: $descrSubclaseServ
                            claseserv:{
                                _id: $_idClaseServ,
                                codigoClaseServ: $codigoClaseServ,
                                descrClaseServ: $descrClaseServ
                            },
                        },
                    }
                }){
                success
                errors{
                    path
                    message
                    }                
                }
            }
        `,
        deleteDptoUpdCiu: gpl`
            mutation($_id: ID!, $codigoDpto: String, $descrDpto: String,
                $codigoCiudad: String, $nombreCiudad: String,
                $codigoZona: String, $nombreZona: String,
                $codigoBarrio: String, $nombreBarrio: String,
                $tipoAct: String){
                    deleteDptoUpdCiu(dirmayor:{
                        _id: $_id,
                        codigoDpto: $codigoDpto,
                        descrDpto: $descrDpto,
                        tipoAct: $tipoAct,
                        ciudades:{
                            codigoCiudad: $codigoCiudad,
                            nombreCiudad: $nombreCiudad,
                            zonas:{
                                codigoZona: $codigoZona,
                                nombreZona: $nombreZona,
                                barrios:{
                                    codigoBarrio: $codigoBarrio,
                                    nombreBarrio: $nombreBarrio,
                                }
                            }
                        }
                    }){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
        `,
        deleteDpto: gpl`
            mutation($_id: ID!){
                deleteDpto(
                    _id: $_id
                ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
            `,
            deleteServicio: gpl`
                mutation($_id: ID!){
                    deleteServicio(
                        _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                }
                `,
                deleteCargoFras: gpl`
                    mutation($_id: ID!){
                        deleteCargoFras(
                            _id: $_id
                        ){
                        success
                        errors{
                            path
                            message
                            }                
                        }
                    }
                `,
                deleteUsuario: gpl`
                  mutation($_id: ID!){
                    deleteUsuario(
                      _id: $_id
                    ){
                    success
                    errors{
                        path
                        message
                        }                
                    }
                  }
              `,
        },
    // subscription:{},
}